(function ()
{
    'use strict';

    angular
        .module('app.deposit', [
            'monospaced.qrcode'
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider, $translatePartialLoaderProvider, msNavigationServiceProvider, USER_ROLES)
    {
        // State
        $stateProvider
            .state('app.deposit', {
                url    : '/deposit/:param',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/deposit/deposit.html',
                        controller : 'DepositController as vm'
                    }
                },
                data: {
                    authorizedRoles: [USER_ROLES.god, USER_ROLES.admin, USER_ROLES.user]
                },
                resolve  : {
                    DepositData: function (msApi)
                    {
                        return msApi.resolve('deposit@getDepositData');
                    }
                }
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/deposit');

        // Api
        msApiProvider.register('deposit', ['deposit', null, {
            'getDepositData': {
                method          : 'GET',
                withCredentials : true,
                transformResponse: function(data, headers){
                    var response = JSON.parse(data);
                    response.server_date = headers('date');
                    return response
                }
            }
        }]);

        // Navigation
        msNavigationServiceProvider.saveItem('deposit', {
            title    : 'Deposit',
            icon     : 'icon-bank',
            state    : 'app.deposit',
            /*stateParams: {
                'param1': 'page'
             },*/
            translate: 'DEPOSIT.DEPOSIT_NAV',
            hidden   : function () {
                return true;
            },
            weight   : 0
        });
    }
})();
(function ()
{
    'use strict';

    angular.module('app.deposit')
        .controller('InitialDialogController', InitialDialogController);

    /** @ngInject */
    function InitialDialogController($mdDialog, api, $resource, session, $rootScope, $timeout)
    {
        var vm = this;

        // Data
        vm.kyc = {};
        vm.dataLoading = {};
        vm.fileError = {};
        vm.date = new Date();
        vm.max_date_of_birth = new Date(
            vm.date.getFullYear() - 18,
            vm.date.getMonth(),
            vm.date.getDate()
        );
        vm.countries = [{name: 'Afghanistan', code: 'AF'},{name: 'Åland Islands', code: 'AX'},{name: 'Albania', code: 'AL'},{name: 'Algeria', code: 'DZ'},{name: 'American Samoa', code: 'AS'},{name: 'Andorra', code: 'AD'},{name: 'Angola', code: 'AO'},{name: 'Anguilla', code: 'AI'},{name: 'Antarctica', code: 'AQ'},{name: 'Antigua and Barbuda', code: 'AG'},{name: 'Argentina', code: 'AR'},{name: 'Armenia', code: 'AM'},{name: 'Aruba', code: 'AW'},{name: 'Australia', code: 'AU'},{name: 'Austria', code: 'AT'},{name: 'Azerbaijan', code: 'AZ'},{name: 'Bahamas', code: 'BS'},{name: 'Bahrain', code: 'BH'},{name: 'Bangladesh', code: 'BD'},{name: 'Barbados', code: 'BB'},{name: 'Belarus', code: 'BY'},{name: 'Belgium', code: 'BE'},{name: 'Belize', code: 'BZ'},{name: 'Benin', code: 'BJ'},{name: 'Bermuda', code: 'BM'},{name: 'Bhutan', code: 'BT'},{name: 'Bolivia', code: 'BO'},{name: 'Bosnia and Herzegovina', code: 'BA'},{name: 'Botswana', code: 'BW'},{name: 'Bouvet Island', code: 'BV'},{name: 'Brazil', code: 'BR'},{name: 'British Indian Ocean Territory', code: 'IO'},{name: 'Brunei Darussalam', code: 'BN'},{name: 'Bulgaria', code: 'BG'},{name: 'Burkina Faso', code: 'BF'},{name: 'Burundi', code: 'BI'},{name: 'Cambodia', code: 'KH'},{name: 'Cameroon', code: 'CM'},{name: 'Canada', code: 'CA'},{name: 'Cape Verde', code: 'CV'},{name: 'Cayman Islands', code: 'KY'},{name: 'Central African Republic', code: 'CF'},{name: 'Chad', code: 'TD'},{name: 'Chile', code: 'CL'},{name: 'China', code: 'CN'},{name: 'Christmas Island', code: 'CX'},{name: 'Cocos (Keeling) Islands', code: 'CC'},{name: 'Colombia', code: 'CO'},{name: 'Comoros', code: 'KM'},{name: 'Congo', code: 'CG'},{name: 'Congo, The Democratic Republic of the', code: 'CD'},{name: 'Cook Islands', code: 'CK'},{name: 'Costa Rica', code: 'CR'},{name: 'Cote D\'Ivoire', code: 'CI'},{name: 'Croatia', code: 'HR'},{name: 'Cuba', code: 'CU'},{name: 'Cyprus', code: 'CY'},{name: 'Czech Republic', code: 'CZ'},{name: 'Denmark', code: 'DK'},{name: 'Djibouti', code: 'DJ'},{name: 'Dominica', code: 'DM'},{name: 'Dominican Republic', code: 'DO'},{name: 'Ecuador', code: 'EC'},{name: 'Egypt', code: 'EG'},{name: 'El Salvador', code: 'SV'},{name: 'Equatorial Guinea', code: 'GQ'},{name: 'Eritrea', code: 'ER'},{name: 'Estonia', code: 'EE'},{name: 'Ethiopia', code: 'ET'},{name: 'Falkland Islands (Malvinas)', code: 'FK'},{name: 'Faroe Islands', code: 'FO'},{name: 'Fiji', code: 'FJ'},{name: 'Finland', code: 'FI'},{name: 'France', code: 'FR'},{name: 'French Guiana', code: 'GF'},{name: 'French Polynesia', code: 'PF'},{name: 'French Southern Territories', code: 'TF'},{name: 'Gabon', code: 'GA'},{name: 'Gambia', code: 'GM'},{name: 'Georgia', code: 'GE'},{name: 'Germany', code: 'DE'},{name: 'Ghana', code: 'GH'},{name: 'Gibraltar', code: 'GI'},{name: 'Greece', code: 'GR'},{name: 'Greenland', code: 'GL'},{name: 'Grenada', code: 'GD'},{name: 'Guadeloupe', code: 'GP'},{name: 'Guam', code: 'GU'},{name: 'Guatemala', code: 'GT'},{name: 'Guernsey', code: 'GG'},{name: 'Guinea', code: 'GN'},{name: 'Guinea-Bissau', code: 'GW'},{name: 'Guyana', code: 'GY'},{name: 'Haiti', code: 'HT'},{name: 'Heard Island and Mcdonald Islands', code: 'HM'},{name: 'Holy See (Vatican City State)', code: 'VA'},{name: 'Honduras', code: 'HN'},{name: 'Hong Kong', code: 'HK'},{name: 'Hungary', code: 'HU'},{name: 'Iceland', code: 'IS'},{name: 'India', code: 'IN'},{name: 'Indonesia', code: 'ID'},{name: 'Iran, Islamic Republic Of', code: 'IR'},{name: 'Iraq', code: 'IQ'},{name: 'Ireland', code: 'IE'},{name: 'Isle of Man', code: 'IM'},{name: 'Israel', code: 'IL'},{name: 'Italy', code: 'IT'},{name: 'Jamaica', code: 'JM'},{name: 'Japan', code: 'JP'},{name: 'Jersey', code: 'JE'},{name: 'Jordan', code: 'JO'},{name: 'Kazakhstan', code: 'KZ'},{name: 'Kenya', code: 'KE'},{name: 'Kiribati', code: 'KI'},{name: 'Korea, Democratic People\'s Republic of', code: 'KP'},{name: 'Korea, Republic of', code: 'KR'},{name: 'Kuwait', code: 'KW'},{name: 'Kyrgyzstan', code: 'KG'},{name: 'Lao People\'s Democratic Republic', code: 'LA'},{name: 'Latvia', code: 'LV'},{name: 'Lebanon', code: 'LB'},{name: 'Lesotho', code: 'LS'},{name: 'Liberia', code: 'LR'},{name: 'Libyan Arab Jamahiriya', code: 'LY'},{name: 'Liechtenstein', code: 'LI'},{name: 'Lithuania', code: 'LT'},{name: 'Luxembourg', code: 'LU'},{name: 'Macao', code: 'MO'},{name: 'Macedonia, The Former Yugoslav Republic of', code: 'MK'},{name: 'Madagascar', code: 'MG'},{name: 'Malawi', code: 'MW'},{name: 'Malaysia', code: 'MY'},{name: 'Maldives', code: 'MV'},{name: 'Mali', code: 'ML'},{name: 'Malta', code: 'MT'},{name: 'Marshall Islands', code: 'MH'},{name: 'Martinique', code: 'MQ'},{name: 'Mauritania', code: 'MR'},{name: 'Mauritius', code: 'MU'},{name: 'Mayotte', code: 'YT'},{name: 'Mexico', code: 'MX'},{name: 'Micronesia, Federated States of', code: 'FM'},{name: 'Moldova, Republic of', code: 'MD'},{name: 'Monaco', code: 'MC'},{name: 'Mongolia', code: 'MN'},{name: 'Montenegro', code: 'ME'},{name: 'Montserrat', code: 'MS'},{name: 'Morocco', code: 'MA'},{name: 'Mozambique', code: 'MZ'},{name: 'Myanmar', code: 'MM'},{name: 'Namibia', code: 'NA'},{name: 'Nauru', code: 'NR'},{name: 'Nepal', code: 'NP'},{name: 'Netherlands', code: 'NL'},{name: 'Netherlands Antilles', code: 'AN'},{name: 'New Caledonia', code: 'NC'},{name: 'New Zealand', code: 'NZ'},{name: 'Nicaragua', code: 'NI'},{name: 'Niger', code: 'NE'},{name: 'Nigeria', code: 'NG'},{name: 'Niue', code: 'NU'},{name: 'Norfolk Island', code: 'NF'},{name: 'Northern Mariana Islands', code: 'MP'},{name: 'Norway', code: 'NO'},{name: 'Oman', code: 'OM'},{name: 'Pakistan', code: 'PK'},{name: 'Palau', code: 'PW'},{name: 'Palestinian Territory, Occupied', code: 'PS'},{name: 'Panama', code: 'PA'},{name: 'Papua New Guinea', code: 'PG'},{name: 'Paraguay', code: 'PY'},{name: 'Peru', code: 'PE'},{name: 'Philippines', code: 'PH'},{name: 'Pitcairn', code: 'PN'},{name: 'Poland', code: 'PL'},{name: 'Portugal', code: 'PT'},{name: 'Puerto Rico', code: 'PR'},{name: 'Qatar', code: 'QA'},{name: 'Reunion', code: 'RE'},{name: 'Romania', code: 'RO'},{name: 'Russian Federation', code: 'RU'},{name: 'Rwanda', code: 'RW'},{name: 'Saint Helena', code: 'SH'},{name: 'Saint Kitts and Nevis', code: 'KN'},{name: 'Saint Lucia', code: 'LC'},{name: 'Saint Pierre and Miquelon', code: 'PM'},{name: 'Saint Vincent and the Grenadines', code: 'VC'},{name: 'Samoa', code: 'WS'},{name: 'San Marino', code: 'SM'},{name: 'Sao Tome and Principe', code: 'ST'},{name: 'Saudi Arabia', code: 'SA'},{name: 'Senegal', code: 'SN'},{name: 'Serbia', code: 'RS'},{name: 'Seychelles', code: 'SC'},{name: 'Sierra Leone', code: 'SL'},{name: 'Singapore', code: 'SG'},{name: 'Slovakia', code: 'SK'},{name: 'Slovenia', code: 'SI'},{name: 'Solomon Islands', code: 'SB'},{name: 'Somalia', code: 'SO'},{name: 'South Africa', code: 'ZA'},{name: 'South Georgia and the South Sandwich Islands', code: 'GS'},{name: 'Spain', code: 'ES'},{name: 'Sri Lanka', code: 'LK'},{name: 'Sudan', code: 'SD'},{name: 'Suriname', code: 'SR'},{name: 'Svalbard and Jan Mayen', code: 'SJ'},{name: 'Swaziland', code: 'SZ'},{name: 'Sweden', code: 'SE'},{name: 'Switzerland', code: 'CH'},{name: 'Syrian Arab Republic', code: 'SY'},{name: 'Taiwan, Province of China', code: 'TW'},{name: 'Tajikistan', code: 'TJ'},{name: 'Tanzania, United Republic of', code: 'TZ'},{name: 'Thailand', code: 'TH'},{name: 'Timor-Leste', code: 'TL'},{name: 'Togo', code: 'TG'},{name: 'Tokelau', code: 'TK'},{name: 'Tonga', code: 'TO'},{name: 'Trinidad and Tobago', code: 'TT'},{name: 'Tunisia', code: 'TN'},{name: 'Turkey', code: 'TR'},{name: 'Turkmenistan', code: 'TM'},{name: 'Turks and Caicos Islands', code: 'TC'},{name: 'Tuvalu', code: 'TV'},{name: 'Uganda', code: 'UG'},{name: 'Ukraine', code: 'UA'},{name: 'United Arab Emirates', code: 'AE'},{name: 'United Kingdom', code: 'GB'},{name: 'United States', code: 'US'},{name: 'United States Minor Outlying Islands', code: 'UM'},{name: 'Uruguay', code: 'UY'},{name: 'Uzbekistan', code: 'UZ'},{name: 'Vanuatu', code: 'VU'},{name: 'Venezuela', code: 'VE'},{name: 'Vietnam', code: 'VN'},{name: 'Virgin Islands, British', code: 'VG'},{name: 'Virgin Islands, U.S.', code: 'VI'},{name: 'Wallis and Futuna', code: 'WF'},{name: 'Western Sahara', code: 'EH'},{name: 'Yemen', code: 'YE'},{name: 'Zambia', code: 'ZM'},{name: 'Zimbabwe', code: 'ZW'}];

        // Methods
        vm.citizenshipAllowed = citizenshipAllowed;
        vm.termsAccepted = termsAccepted;
        vm.kyc = kyc;
        vm.saveEtherAddress = saveEtherAddress;
        vm.validateFile = validateFile;

        //////////
        function citizenshipAllowed(e) {
            e.preventDefault();
            vm.dataLoading.citizenshipAllowed = true;

            var formData = new FormData();
            formData.append('is_citizenship_allowed', 1);
            formData.append('token', session.data.token);

            api.initial.setCitizenhipAllowed(formData).$promise.then(
                //success
                function(response){
                    if (response.success) {
                        vm.dataLoading.citizenshipAllowed = false;
                        $rootScope.user.is_citizenship_allowed = 1;
                        closeDialog();
                    } else {
                        vm.dataLoading.citizenshipAllowed = false;
                        api.showToast('error', response.message[0]);
                    }
                },
                //error
                function(response){
                    console.error(response);
                }
            );
        }

        function termsAccepted(e) {
            e.preventDefault();
            vm.dataLoading.termsAccepted = true;

            var formData = new FormData();
            formData.append('is_terms_accepted', 1);
            formData.append('token', session.data.token);

            api.initial.setTermsAccepted(formData).$promise.then(
                //success
                function(response){
                    if (response.success) {
                        vm.dataLoading.termsAccepted = false;
                        $rootScope.user.is_terms_accepted = 1;
                        closeDialog();
                    } else {
                        vm.dataLoading.termsAccepted = false;
                        api.showToast('error', response.message[0]);
                    }
                },
                //error
                function(response){
                    console.error(response);
                }
            );
        }

        function kyc(e) {
            e.preventDefault();
            vm.dataLoading.kyc = true;

            var formData = new FormData(document.getElementById('kycForm'));
            var fileInputs = angular.element(document.getElementById('kycForm').querySelectorAll('input[data-hidden-file-input="1"]'));
            formData.append('date_of_birth', vm.kyc.date_of_birth);
            formData.append('token', session.data.token);
            angular.forEach(fileInputs, function(fileInput) {
                formData.append(fileInput.id, fileInput.files[0]);
            });

            api.initial.setKyc(formData).$promise.then(
                //success
                function(response){
                    if (response.success) {
                        $rootScope.user.show_kyc = false;
                        $rootScope.user.kyc_status = 1;
                        vm.dataLoading.kyc = false;
                        closeDialog();
                        api.showToast('success', response.message[0]);
                    } else {
                        vm.dataLoading.kyc = false;
                        api.showToast('error', response.message[0]);
                    }
                },
                //error
                function(response){
                    console.error(response);
                }
            );
        }

        function validateFile(e) {
            var files = e.target.files;
            if(typeof(files[0].type) !== 'undefined') {
                if((files[0].type != 'image/jpeg' && files[0].type != 'image/png') || files[0].size > 15728640)
                    vm.fileError[e.target.id] = true;
                else
                    vm.fileError[e.target.id] = false;
            }
        }

        function saveEtherAddress(e) {
            e.preventDefault();
            vm.dataLoading.saveEtherAddress = true;

            var formData = new FormData(document.getElementById('ethAddressForm'));
            formData.append('token', session.data.token);

            api.initial.setEthAddress(formData).$promise.then(
                //success
                function(response){
                    if (response.success) {
                        vm.dataLoading.saveEtherAddress = false;
                        $rootScope.user.ether_address = vm.ether_address;
                        closeDialog();
                        api.showToast('success', response.message[0]);
                    } else {
                        vm.dataLoading.saveEtherAddress = false;
                        api.showToast('error', response.message[0]);
                    }
                },
                //error
                function(response){
                    console.error(response);
                }
            );
        }

        function closeDialog() {
            if ($rootScope.user.is_citizenship_allowed && $rootScope.user.is_terms_accepted && $rootScope.user.ether_address){
                $mdDialog.cancel();
            }
        }

        // API resources
        api.initial = $resource(null, null, {
            'setEthAddress': {
                method          : 'POST',
                url             : api.baseUrl+'account/set_eth_address',
                withCredentials : true,
                headers         : { 'Content-Type': undefined},
                transformRequest: angular.identity
            },
            'setCitizenhipAllowed': {
                method          : 'POST',
                url             : api.baseUrl+'account/set_citizenship_allowed',
                withCredentials : true,
                headers         : { 'Content-Type': undefined},
                transformRequest: angular.identity
            },
            'setKyc': {
                method          : 'POST',
                url             : api.baseUrl+'account/kyc',
                withCredentials : true,
                headers         : { 'Content-Type': undefined},
                transformRequest: angular.identity
            },
            'setTermsAccepted': {
                method          : 'POST',
                url             : api.baseUrl+'account/set_terms_accepted',
                withCredentials : true,
                headers         : { 'Content-Type': undefined},
                transformRequest: angular.identity
            }
        });
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.activate-2fa', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider, USER_ROLES)
    {
        // State
        $stateProvider
            .state('app.activate-2fa', {
                url    : '/activate-2fa',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/activate-2fa/activate-2fa.html',
                        controller : 'Activate2faController as vm'
                    }
                },
                data: {
                    authorizedRoles: [USER_ROLES.god, USER_ROLES.admin, USER_ROLES.user]
                }
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/activate-2fa');

        // Navigation
        msNavigationServiceProvider.saveItem('activate-2fa', {
            title    : 'Activate 2FA',
            icon     : 'icon-cellphone-link',
            state    : 'app.activate-2fa',
            translate: 'ACTIVATE-2FA.ACTIVATE-2FA_NAV',
            weight   : 4
        });
    }
})();
(function ()
{
    'use strict';

    angular.module('app.activate-2fa')
        .controller('TwoFactorAuthDialogController', TwoFactorAuthDialogController);

    /** @ngInject */
    function TwoFactorAuthDialogController($mdDialog, gaData, api, session)
    {
        var vm = this;
        
        // Data
        gaData.isVerified = 0;
        
        //Get user data
        api.auth.getGoogleAuthData().$promise.then(
            //success
            function(response){
                if (response.success)
                    vm.gaData = response.data;
                else
                    vm.errorMessages = response.message;
            },
            //error
            function(response){
                console.error(response);
            }
        );

        // Methods
        vm.closeDialog = closeDialog;
        vm.verifyGaCode = verifyGaCode;

        //////////
        function verifyGaCode(e) {
            e.preventDefault();
            var formData = new FormData(document.getElementById('twoFactorForm'));
            formData.append('token', session.data.token);

            api.auth.verifyGoogleAuthCode(formData).$promise.then(
                //success
                function(response){
                    if (response.success) {
                        gaData.isVerified = 1;
                        api.showToast('success', response.message[0]);
                        closeDialog();
                    } else
                        api.showToast('error', response.message[0]);
                },
                //error
                function(response){
                    console.error(response);
                }
            );
        }

        function closeDialog()
        {
            $mdDialog.hide();
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core',
            [
                'ngAnimate',
                'ngAria',
                'ngCookies',
                'ngMessages',
                'ngResource',
                'ngSanitize',
                'ngMaterial',
                'pascalprecht.translate',
                'ui.router'
            ]);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular.module('app.deposit')
        .controller('KycDialogController', KycDialogController);

    /** @ngInject */
    function KycDialogController($mdDialog, api, $resource, session, $rootScope)
    {
        var vm = this;

        // Data
        vm.kyc = {};
        vm.dataLoading = {};
        vm.fileError = {};
        vm.date = new Date();
        vm.max_date_of_birth = new Date(
            vm.date.getFullYear() - 18,
            vm.date.getMonth(),
            vm.date.getDate()
        );
        vm.countries = [{name: 'Afghanistan', code: 'AF'},{name: 'Åland Islands', code: 'AX'},{name: 'Albania', code: 'AL'},{name: 'Algeria', code: 'DZ'},{name: 'American Samoa', code: 'AS'},{name: 'Andorra', code: 'AD'},{name: 'Angola', code: 'AO'},{name: 'Anguilla', code: 'AI'},{name: 'Antarctica', code: 'AQ'},{name: 'Antigua and Barbuda', code: 'AG'},{name: 'Argentina', code: 'AR'},{name: 'Armenia', code: 'AM'},{name: 'Aruba', code: 'AW'},{name: 'Australia', code: 'AU'},{name: 'Austria', code: 'AT'},{name: 'Azerbaijan', code: 'AZ'},{name: 'Bahamas', code: 'BS'},{name: 'Bahrain', code: 'BH'},{name: 'Bangladesh', code: 'BD'},{name: 'Barbados', code: 'BB'},{name: 'Belarus', code: 'BY'},{name: 'Belgium', code: 'BE'},{name: 'Belize', code: 'BZ'},{name: 'Benin', code: 'BJ'},{name: 'Bermuda', code: 'BM'},{name: 'Bhutan', code: 'BT'},{name: 'Bolivia', code: 'BO'},{name: 'Bosnia and Herzegovina', code: 'BA'},{name: 'Botswana', code: 'BW'},{name: 'Bouvet Island', code: 'BV'},{name: 'Brazil', code: 'BR'},{name: 'British Indian Ocean Territory', code: 'IO'},{name: 'Brunei Darussalam', code: 'BN'},{name: 'Bulgaria', code: 'BG'},{name: 'Burkina Faso', code: 'BF'},{name: 'Burundi', code: 'BI'},{name: 'Cambodia', code: 'KH'},{name: 'Cameroon', code: 'CM'},{name: 'Canada', code: 'CA'},{name: 'Cape Verde', code: 'CV'},{name: 'Cayman Islands', code: 'KY'},{name: 'Central African Republic', code: 'CF'},{name: 'Chad', code: 'TD'},{name: 'Chile', code: 'CL'},{name: 'China', code: 'CN'},{name: 'Christmas Island', code: 'CX'},{name: 'Cocos (Keeling) Islands', code: 'CC'},{name: 'Colombia', code: 'CO'},{name: 'Comoros', code: 'KM'},{name: 'Congo', code: 'CG'},{name: 'Congo, The Democratic Republic of the', code: 'CD'},{name: 'Cook Islands', code: 'CK'},{name: 'Costa Rica', code: 'CR'},{name: 'Cote D\'Ivoire', code: 'CI'},{name: 'Croatia', code: 'HR'},{name: 'Cuba', code: 'CU'},{name: 'Cyprus', code: 'CY'},{name: 'Czech Republic', code: 'CZ'},{name: 'Denmark', code: 'DK'},{name: 'Djibouti', code: 'DJ'},{name: 'Dominica', code: 'DM'},{name: 'Dominican Republic', code: 'DO'},{name: 'Ecuador', code: 'EC'},{name: 'Egypt', code: 'EG'},{name: 'El Salvador', code: 'SV'},{name: 'Equatorial Guinea', code: 'GQ'},{name: 'Eritrea', code: 'ER'},{name: 'Estonia', code: 'EE'},{name: 'Ethiopia', code: 'ET'},{name: 'Falkland Islands (Malvinas)', code: 'FK'},{name: 'Faroe Islands', code: 'FO'},{name: 'Fiji', code: 'FJ'},{name: 'Finland', code: 'FI'},{name: 'France', code: 'FR'},{name: 'French Guiana', code: 'GF'},{name: 'French Polynesia', code: 'PF'},{name: 'French Southern Territories', code: 'TF'},{name: 'Gabon', code: 'GA'},{name: 'Gambia', code: 'GM'},{name: 'Georgia', code: 'GE'},{name: 'Germany', code: 'DE'},{name: 'Ghana', code: 'GH'},{name: 'Gibraltar', code: 'GI'},{name: 'Greece', code: 'GR'},{name: 'Greenland', code: 'GL'},{name: 'Grenada', code: 'GD'},{name: 'Guadeloupe', code: 'GP'},{name: 'Guam', code: 'GU'},{name: 'Guatemala', code: 'GT'},{name: 'Guernsey', code: 'GG'},{name: 'Guinea', code: 'GN'},{name: 'Guinea-Bissau', code: 'GW'},{name: 'Guyana', code: 'GY'},{name: 'Haiti', code: 'HT'},{name: 'Heard Island and Mcdonald Islands', code: 'HM'},{name: 'Holy See (Vatican City State)', code: 'VA'},{name: 'Honduras', code: 'HN'},{name: 'Hong Kong', code: 'HK'},{name: 'Hungary', code: 'HU'},{name: 'Iceland', code: 'IS'},{name: 'India', code: 'IN'},{name: 'Indonesia', code: 'ID'},{name: 'Iran, Islamic Republic Of', code: 'IR'},{name: 'Iraq', code: 'IQ'},{name: 'Ireland', code: 'IE'},{name: 'Isle of Man', code: 'IM'},{name: 'Israel', code: 'IL'},{name: 'Italy', code: 'IT'},{name: 'Jamaica', code: 'JM'},{name: 'Japan', code: 'JP'},{name: 'Jersey', code: 'JE'},{name: 'Jordan', code: 'JO'},{name: 'Kazakhstan', code: 'KZ'},{name: 'Kenya', code: 'KE'},{name: 'Kiribati', code: 'KI'},{name: 'Korea, Democratic People\'s Republic of', code: 'KP'},{name: 'Korea, Republic of', code: 'KR'},{name: 'Kuwait', code: 'KW'},{name: 'Kyrgyzstan', code: 'KG'},{name: 'Lao People\'s Democratic Republic', code: 'LA'},{name: 'Latvia', code: 'LV'},{name: 'Lebanon', code: 'LB'},{name: 'Lesotho', code: 'LS'},{name: 'Liberia', code: 'LR'},{name: 'Libyan Arab Jamahiriya', code: 'LY'},{name: 'Liechtenstein', code: 'LI'},{name: 'Lithuania', code: 'LT'},{name: 'Luxembourg', code: 'LU'},{name: 'Macao', code: 'MO'},{name: 'Macedonia, The Former Yugoslav Republic of', code: 'MK'},{name: 'Madagascar', code: 'MG'},{name: 'Malawi', code: 'MW'},{name: 'Malaysia', code: 'MY'},{name: 'Maldives', code: 'MV'},{name: 'Mali', code: 'ML'},{name: 'Malta', code: 'MT'},{name: 'Marshall Islands', code: 'MH'},{name: 'Martinique', code: 'MQ'},{name: 'Mauritania', code: 'MR'},{name: 'Mauritius', code: 'MU'},{name: 'Mayotte', code: 'YT'},{name: 'Mexico', code: 'MX'},{name: 'Micronesia, Federated States of', code: 'FM'},{name: 'Moldova, Republic of', code: 'MD'},{name: 'Monaco', code: 'MC'},{name: 'Mongolia', code: 'MN'},{name: 'Montenegro', code: 'ME'},{name: 'Montserrat', code: 'MS'},{name: 'Morocco', code: 'MA'},{name: 'Mozambique', code: 'MZ'},{name: 'Myanmar', code: 'MM'},{name: 'Namibia', code: 'NA'},{name: 'Nauru', code: 'NR'},{name: 'Nepal', code: 'NP'},{name: 'Netherlands', code: 'NL'},{name: 'Netherlands Antilles', code: 'AN'},{name: 'New Caledonia', code: 'NC'},{name: 'New Zealand', code: 'NZ'},{name: 'Nicaragua', code: 'NI'},{name: 'Niger', code: 'NE'},{name: 'Nigeria', code: 'NG'},{name: 'Niue', code: 'NU'},{name: 'Norfolk Island', code: 'NF'},{name: 'Northern Mariana Islands', code: 'MP'},{name: 'Norway', code: 'NO'},{name: 'Oman', code: 'OM'},{name: 'Pakistan', code: 'PK'},{name: 'Palau', code: 'PW'},{name: 'Palestinian Territory, Occupied', code: 'PS'},{name: 'Panama', code: 'PA'},{name: 'Papua New Guinea', code: 'PG'},{name: 'Paraguay', code: 'PY'},{name: 'Peru', code: 'PE'},{name: 'Philippines', code: 'PH'},{name: 'Pitcairn', code: 'PN'},{name: 'Poland', code: 'PL'},{name: 'Portugal', code: 'PT'},{name: 'Puerto Rico', code: 'PR'},{name: 'Qatar', code: 'QA'},{name: 'Reunion', code: 'RE'},{name: 'Romania', code: 'RO'},{name: 'Russian Federation', code: 'RU'},{name: 'Rwanda', code: 'RW'},{name: 'Saint Helena', code: 'SH'},{name: 'Saint Kitts and Nevis', code: 'KN'},{name: 'Saint Lucia', code: 'LC'},{name: 'Saint Pierre and Miquelon', code: 'PM'},{name: 'Saint Vincent and the Grenadines', code: 'VC'},{name: 'Samoa', code: 'WS'},{name: 'San Marino', code: 'SM'},{name: 'Sao Tome and Principe', code: 'ST'},{name: 'Saudi Arabia', code: 'SA'},{name: 'Senegal', code: 'SN'},{name: 'Serbia', code: 'RS'},{name: 'Seychelles', code: 'SC'},{name: 'Sierra Leone', code: 'SL'},{name: 'Singapore', code: 'SG'},{name: 'Slovakia', code: 'SK'},{name: 'Slovenia', code: 'SI'},{name: 'Solomon Islands', code: 'SB'},{name: 'Somalia', code: 'SO'},{name: 'South Africa', code: 'ZA'},{name: 'South Georgia and the South Sandwich Islands', code: 'GS'},{name: 'Spain', code: 'ES'},{name: 'Sri Lanka', code: 'LK'},{name: 'Sudan', code: 'SD'},{name: 'Suriname', code: 'SR'},{name: 'Svalbard and Jan Mayen', code: 'SJ'},{name: 'Swaziland', code: 'SZ'},{name: 'Sweden', code: 'SE'},{name: 'Switzerland', code: 'CH'},{name: 'Syrian Arab Republic', code: 'SY'},{name: 'Taiwan, Province of China', code: 'TW'},{name: 'Tajikistan', code: 'TJ'},{name: 'Tanzania, United Republic of', code: 'TZ'},{name: 'Thailand', code: 'TH'},{name: 'Timor-Leste', code: 'TL'},{name: 'Togo', code: 'TG'},{name: 'Tokelau', code: 'TK'},{name: 'Tonga', code: 'TO'},{name: 'Trinidad and Tobago', code: 'TT'},{name: 'Tunisia', code: 'TN'},{name: 'Turkey', code: 'TR'},{name: 'Turkmenistan', code: 'TM'},{name: 'Turks and Caicos Islands', code: 'TC'},{name: 'Tuvalu', code: 'TV'},{name: 'Uganda', code: 'UG'},{name: 'Ukraine', code: 'UA'},{name: 'United Arab Emirates', code: 'AE'},{name: 'United Kingdom', code: 'GB'},{name: 'United States', code: 'US'},{name: 'United States Minor Outlying Islands', code: 'UM'},{name: 'Uruguay', code: 'UY'},{name: 'Uzbekistan', code: 'UZ'},{name: 'Vanuatu', code: 'VU'},{name: 'Venezuela', code: 'VE'},{name: 'Vietnam', code: 'VN'},{name: 'Virgin Islands, British', code: 'VG'},{name: 'Virgin Islands, U.S.', code: 'VI'},{name: 'Wallis and Futuna', code: 'WF'},{name: 'Western Sahara', code: 'EH'},{name: 'Yemen', code: 'YE'},{name: 'Zambia', code: 'ZM'},{name: 'Zimbabwe', code: 'ZW'}];

        // Methods
        vm.kyc = kyc;
        vm.validateFile = validateFile;
        vm.closeDialog = closeDialog;

        //////////

        function kyc(e) {
            e.preventDefault();
            vm.dataLoading.kyc = true;

            var formData = new FormData(document.getElementById('kycForm'));
            var fileInputs = angular.element(document.getElementById('kycForm').querySelectorAll('input[data-hidden-file-input="1"]'));
            formData.append('date_of_birth', vm.kyc.date_of_birth);
            formData.append('token', session.data.token);
            angular.forEach(fileInputs, function(fileInput) {
                formData.append(fileInput.id, fileInput.files[0]);
            });

            api.kyc.setKyc(formData).$promise.then(
                //success
                function(response){
                    if (response.success) {
                        $rootScope.user.show_kyc = false;
                        $rootScope.user.kyc_status = 1;
                        vm.dataLoading.kyc = false;
                        closeDialog();
                        api.showToast('success', response.message[0]);
                    } else {
                        vm.dataLoading.kyc = false;
                        api.showToast('error', response.message[0]);
                    }
                },
                //error
                function(response){
                    console.error(response);
                }
            );
        }

        function validateFile(e) {
            var files = e.target.files;
            if(typeof(files[0].type) !== 'undefined') {
                if((files[0].type != 'image/jpeg' && files[0].type != 'image/png') || files[0].size > 15728640)
                    vm.fileError[e.target.id] = true;
                else
                    vm.fileError[e.target.id] = false;
            }
        }

        function closeDialog() {
            $mdDialog.cancel();
        }

        // API resources
        api.kyc = $resource(null, null, {
            'setKyc': {
                method          : 'POST',
                url             : api.baseUrl+'account/kyc',
                withCredentials : true,
                headers         : { 'Content-Type': undefined},
                transformRequest: angular.identity
            }
        });
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.auth.register', [
            'vcRecaptcha'
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider, USER_ROLES, $translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.register', {
            url      : '/register',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.register': {
                    templateUrl: 'app/main/auth/register/register.html',
                    controller : 'RegisterController as vm'
                }
            },
            data: {
                authorizedRoles: [USER_ROLES.guest]
            },
            bodyClass: 'register'
        });

        // Translate
        $translatePartialLoaderProvider.addPart('app/main/auth/register');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.auth.register')
        .controller('RegisterController', RegisterController);

    /** @ngInject */
    function RegisterController($state, $rootScope, session, AUTH_EVENTS, api, icoConfig, vcRecaptchaService)
    {
        var vm = this;

        // Data
        vm.site = icoConfig.getConfig('site');
        vm.recaptcha = icoConfig.getConfig('recaptcha');
        vm.clientCountry = session.data.clientCountry;

        // Methods
        vm.signup = signup;
        vm.setWidgetId = setWidgetId;

        //////////

        function setWidgetId(widgetId) {
            vm.widgetId = widgetId;
        }

        function signup(e) {
            e.preventDefault();
            vm.dataLoading = true;
            var formData = new FormData(document.getElementById('registerForm'));
            formData.append('token', session.data.token);

            api.auth.signup(formData).$promise.then(
                //success
                function(response){
                    if (response.success) {
                        session.create(response.data);
                        $rootScope.$broadcast(AUTH_EVENTS.loginSuccess, response.data);
                        $state.go('app.wallet');
                    } else {
                        if (vm.site.isCaptchaEnabled)
                            vcRecaptchaService.reload(vm.widgetId);
                        vm.errorMessages = response.message;
                        $rootScope.$broadcast(AUTH_EVENTS.loginFailed);
                        vm.dataLoading = false;
                    }
                },
                //error
                function(response){
                    if (vm.site.isCaptchaEnabled)
                        vcRecaptchaService.reload(vm.widgetId);
                    console.error(response);
                    vm.dataLoading = false;
                }
            );
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.deposit')
        .filter('toDate', toDate);

    /** @ngInject */
    function toDate()
    {
        return function (input) {
            return new Date(input);
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.deposit')
        .filter('moment', moment);

    /** @ngInject */
    function moment()
    {
        return function (input, momentFn) {
            var args = Array.prototype.slice.call(arguments, 2),
                momentObj = moment(input);
            return momentObj[momentFn].apply(momentObj, args);
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.auth.reset-password', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, USER_ROLES, $translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.reset-password', {
            url      : '/reset-password/:id/:secret',
            views    : {
                'main@'                                : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.reset-password': {
                    templateUrl: 'app/main/auth/reset-password/reset-password.html',
                    controller : 'ResetPasswordController as vm'
                }
            },
            data: {
                authorizedRoles: [USER_ROLES.guest]
            },
            bodyClass: 'reset-password'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/auth/reset-password');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.auth.reset-password')
        .controller('ResetPasswordController', ResetPasswordController);

    /** @ngInject */
    function ResetPasswordController($stateParams, api, session, $resource, $rootScope, $state, AUTH_EVENTS)
    {
        var vm = this;

        // Data

        // Methods
        vm.passwordRecoveryForm = passwordRecoveryForm;

        //////////
        function passwordRecoveryForm(e) {
            e.preventDefault();
            vm.dataLoading = true;
            var formData = new FormData(document.getElementById('resetPasswordForm'));
            formData.append('token', session.data.token);
            formData.append('id', $stateParams.id);
            formData.append('secret', $stateParams.secret);

            api.account.passwordRecoveryForm(formData).$promise.then(
                //success
                function(response){
                    if (response.success) {
                        api.showToast('success', response.message[0]);
                        session.create(response.data);
                        $rootScope.$broadcast(AUTH_EVENTS.loginSuccess, response.data);
                        $state.go('app.wallet');
                    } else
                        api.showToast('error', response.message[0]);
                    vm.dataLoading = false;
                },
                //error
                function(response){
                    console.error(response);
                    vm.dataLoading = false;
                }
            );
        }

        // API resources
        api.account = $resource(null, null, {
            'passwordRecoveryForm': {
                method          : 'POST',
                url             : api.baseUrl+'account/password_recovery_form',
                withCredentials : true,
                headers         : {'Content-Type': undefined},
                transformRequest: angular.identity
            }
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.auth.login', [
            'vcRecaptcha'
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider, USER_ROLES, $translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.login', {
            url      : '/login',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.login': {
                    templateUrl: 'app/main/auth/login/login.html',
                    controller : 'LoginController as vm'
                }
            },
            data: {
                authorizedRoles: [USER_ROLES.guest]
            },
            bodyClass: 'login'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/auth/login');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.auth.login')
        .controller('LoginController', LoginController);

    /** @ngInject */
    function LoginController($state, $rootScope, session, AUTH_EVENTS, api, icoConfig, vcRecaptchaService)
    {
        var vm = this;

        // Data
        vm.site = icoConfig.getConfig('site');
        vm.recaptcha = icoConfig.getConfig('recaptcha');
        vm.clientCountry = session.data.clientCountry;
        vm.signup_enabled = session.data.signup_enabled;

        // Methods
        vm.login = login;
        vm.setWidgetId = setWidgetId;

        //////////

        function setWidgetId(widgetId) {
            vm.widgetId = widgetId;
        }

        function login(e) {
            e.preventDefault();
            vm.dataLoading = true;
            var formData = new FormData(document.getElementById('loginForm'));
            formData.append('token', session.data.token);

            api.auth.login(formData).$promise.then(
                //success
                function(response){
                    if (response.success) {
                        session.create(response.data);
                        $rootScope.$broadcast(AUTH_EVENTS.loginSuccess, response.data);
                        $state.go('app.wallet');
                    } else {
                        if (response.data.two_factor_needed){
                            vm.twoFactor = response.data.two_factor_needed;
                            vm.errorMessages = {};
                        } else {
                            if (vm.site.isCaptchaEnabled)
                                vcRecaptchaService.reload(vm.widgetId);
                            vm.errorMessages = response.message;
                            $rootScope.$broadcast(AUTH_EVENTS.loginFailed);
                        }
                        vm.dataLoading = false;
                    }
                },
                //error
                function(){
                    if (vm.site.isCaptchaEnabled)
                        vcRecaptchaService.reload(vm.widgetId);
                    $rootScope.$broadcast(AUTH_EVENTS.loginFailed);
                    vm.dataLoading = false;
                }
            );
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.auth.forgot-password', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, USER_ROLES, $translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.forgot-password', {
            url      : '/forgot-password',
            views    : {
                'main@'                                 : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.forgot-password': {
                    templateUrl: 'app/main/auth/forgot-password/forgot-password.html',
                    controller : 'ForgotPasswordController as vm'
                }
            },
            data: {
                authorizedRoles: [USER_ROLES.guest]
            },
            bodyClass: 'forgot-password'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/auth/forgot-password');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.auth.forgot-password')
        .controller('ForgotPasswordController', ForgotPasswordController);

    /** @ngInject */
    function ForgotPasswordController(api, session, $resource)
    {
        var vm = this;

        // Data

        // Methods
        vm.passwordRecoveryRequest = passwordRecoveryRequest;

        //////////
        function passwordRecoveryRequest(e) {
            e.preventDefault();
            vm.dataLoading = true;
            var formData = new FormData(document.getElementById('forgotPasswordForm'));
            formData.append('token', session.data.token);

            api.account.passwordRecoveryRequest(formData).$promise.then(
                //success
                function(response){
                    if (response.success) {
                        api.showToast('success', response.message[0]);
                    } else
                        api.showToast('error', response.message[0]);
                    vm.dataLoading = false;
                },
                //error
                function(response){
                    console.error(response);
                    vm.dataLoading = false;
                }
            );
        }

        // API resources
        api.account = $resource(null, null, {
            'passwordRecoveryRequest': {
                method          : 'POST',
                url             : api.baseUrl+'account/password_recovery_request',
                withCredentials : true,
                headers         : {'Content-Type': undefined},
                transformRequest: angular.identity
            }
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.account.balance',
            [
                // 3rd Party Dependencies
                'nvd3',
                'datatables'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider, USER_ROLES)
    {
        // State
        $stateProvider.state('app.account_balance', {
            url      : '/account-balance',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/account/balance/account-balance.html',
                    controller : 'AccountBalanceController as vm'
                }
            },
            data: {
                authorizedRoles: [USER_ROLES.god, USER_ROLES.admin, USER_ROLES.user]
            },
            resolve  : {
                BalanceData: function (msApi)
                {
                    return msApi.resolve('account.balance@getBalanceData');
                }
            },
            bodyClass: 'account-balance'
        });

        // Api
        msApiProvider.register('account.balance', ['balance', null, {
            'getBalanceData': {
                method          : 'GET',
                withCredentials : true
            }
        }]);
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.account.balance')
        .controller('AccountBalanceController', AccountBalanceController);

    /** @ngInject */
    function AccountBalanceController(BalanceData)
    {
        var vm = this;

        // Data
        vm.balanceData = BalanceData.data;

        vm.dtInstance = {};
        vm.dtOptions = {
            //dom         : 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            paging: false,
            bFilter: false,
            bInfo: false,
            order: [[ 1, "desc" ]],
            columnDefs  : [
                {
                    "targets": [0],
                    "orderable": false
                },
                {
                    "targets": [4],
                    "orderable": false
                }
            ],
            initComplete: function ()
            {

            },
            language: {
                search: "_INPUT_",
                searchPlaceholder: "Search",
                emptyTable: "No data available"
            },
            pageLength  : 10,
            autoWidth: false,
            responsive  : true,
            bLengthChange: false
        };
        // Methods


        //////////
        
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                msTimeline: '=?',
                loadMore  : '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Default config
                    var config = {
                        scrollEl: '#content'
                    };

                    // Extend the configuration
                    config = angular.extend(config, scope.msTimeline, {});
                    
                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element(config.scrollEl);
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsStepperController', MsStepperController)
        .directive('msHorizontalStepper', msHorizontalStepperDirective)
        .directive('msHorizontalStepperStep', msHorizontalStepperStepDirective)
        .directive('msVerticalStepper', msVerticalStepperDirective)
        .directive('msVerticalStepperStep', msVerticalStepperStepDirective);

    /** @ngInject */
    function MsStepperController($timeout)
    {
        var vm = this;

        // Data
        vm.mainForm = undefined;

        vm.orientation = 'horizontal';
        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;

        // Methods
        vm.setOrientation = setOrientation;
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;

        vm.setCurrentStep = setCurrentStep;

        vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepHidden = isStepHidden;
        vm.filterHiddenStep = filterHiddenStep;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;

        //////////

        /**
         * Set the orientation of the stepper
         *
         * @param orientation
         */
        function setOrientation(orientation)
        {
            vm.orientation = orientation || 'horizontal';
        }

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form)
        {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form)
        {
            var step = {
                element           : element,
                scope             : scope,
                form              : form,
                stepNumber        : scope.step || (vm.steps.length + 1),
                stepTitle         : scope.stepTitle,
                stepTitleTranslate: scope.stepTitleTranslate
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b)
            {
                return a.stepNumber - b.stepNumber;
            });

            return step;
        }

        /**
         * Setup steps for the first time
         */
        function setupSteps()
        {
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm()
        {
            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            $timeout(function ()
            {
                // Reset all the steps
                for ( var x = 0; x < vm.steps.length; x++ )
                {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                // Go to first step
                gotoFirstStep();
            });
        }

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return;
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;

            if ( vm.orientation === 'horizontal' )
            {
                // Hide all steps
                for ( var i = 0; i < vm.steps.length; i++ )
                {
                    vm.steps[i].element.hide();
                }

                // Show the current step
                vm.steps[vm.currentStepNumber - 1].element.show();
            }
            else if ( vm.orientation === 'vertical' )
            {
                // Hide all step content
                for ( var j = 0; j < vm.steps.length; j++ )
                {
                    vm.steps[j].element.find('.ms-stepper-step-content').hide();
                }

                // Show the current step content
                vm.steps[vm.currentStepNumber - 1].element.find('.ms-stepper-step-content').show();
            }
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        function gotoStep(stepNumber)
        {
            // If the step we are about to go
            // is hidden, bail...
            if ( isStepHidden(stepNumber) )
            {
                return;
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep()
        {
            var stepNumber = vm.currentStepNumber - 1;

            // Test the previous steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s >= 1; s-- )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the next step
         */
        function gotoNextStep()
        {
            var stepNumber = vm.currentStepNumber + 1;

            // Test the following steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s <= vm.steps.length; s++ )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep()
        {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep()
        {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            var disabled = false;

            for ( var i = 1; i < stepNumber; i++ )
            {
                if ( !isStepValid(i) )
                {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is hidden
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepHidden(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return !!vm.steps[stepNumber - 1].scope.hideStep;
        }

        /**
         * Check if the given step is hidden as a filter
         *
         * @param step
         * @returns {boolean}
         */
        function filterHiddenStep(step)
        {
            return !isStepHidden(step.stepNumber);
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            // If the step is optional, always return true
            if ( isStepOptional(stepNumber) )
            {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber)
        {
            return !(angular.isUndefined(stepNumber) || stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid()
        {
            return vm.mainForm.$valid;
        }
    }

    /** @ngInject */
    function msHorizontalStepperDirective()
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msHorizontalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time
                    MsStepperCtrl.setOrientation('horizontal');
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        };
    }

    /** @ngInject */
    function msHorizontalStepperStepDirective()
    {
        return {
            restrict: 'E',
            require : ['form', '^msHorizontalStepper'],
            priority: 1000,
            scope   : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            compile : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperDirective($timeout)
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msVerticalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/vertical/vertical.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time

                    // Timeout is required in vertical stepper
                    // as we are using transclusion in steps.
                    // We have to wait for them to be transcluded
                    // and registered to the controller
                    $timeout(function ()
                    {
                        MsStepperCtrl.setOrientation('vertical');
                        MsStepperCtrl.registerMainForm(FormCtrl);
                        MsStepperCtrl.setupSteps();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperStepDirective()
    {
        return {
            restrict   : 'E',
            require    : ['form', '^msVerticalStepper'],
            priority   : 1000,
            scope      : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            transclude : true,
            templateUrl: 'app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    scope.stepInfo = MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Expose the controller to the scope
                    scope.MsStepper = MsStepperCtrl;

                    // Hide the step content by default
                    iElement.find('.ms-stepper-step-content').hide();
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
/**
 * @ngdoc module
 * @name material.components.slider
 */
SliderDirective.$inject = ["$$rAF", "$window", "$mdAria", "$mdUtil", "$mdConstant", "$mdTheming", "$mdGesture", "$parse", "$log", "$timeout"];
angular
    .module('app.core')
    .directive('msSlider', SliderDirective)
    .directive('msSliderContainer', SliderContainerDirective);

/**
 * @ngdoc directive
 * @name msSliderContainer
 * @module material.components.slider
 * @restrict E
 * @description
 * The `<ms-slider-container>` contains slider with two other elements.
 *
 *
 * @usage
 * <h4>Normal Mode</h4>
 * <hljs lang="html">
 * </hljs>
 */
function SliderContainerDirective() {
    return {
        controller: function () {},
        compile: function (elem) {
            var slider = elem.find('ms-slider');

            if (!slider) {
                return;
            }

            var vertical = slider.attr('ms-vertical');

            if (vertical !== undefined) {
                elem.attr('ms-vertical', '');
            }

            if(!slider.attr('flex')) {
                slider.attr('flex', '');
            }

            return function postLink(scope, element, attr, ctrl) {
                element.addClass('_md');     // private md component indicator for styling

                // We have to manually stop the $watch on ngDisabled because it exists
                // on the parent scope, and won't be automatically destroyed when
                // the component is destroyed.
                function setDisable(value) {
                    element.children().attr('disabled', value);
                    element.find('input').attr('disabled', value);
                }

                var stopDisabledWatch = angular.noop;

                if (attr.disabled) {
                    setDisable(true);
                }
                else if (attr.ngDisabled) {
                    stopDisabledWatch = scope.$watch(attr.ngDisabled, function (value) {
                        setDisable(value);
                    });
                }

                scope.$on('$destroy', function () {
                    stopDisabledWatch();
                });

                var initialMaxWidth;

                ctrl.fitInputWidthToTextLength = function (length) {
                    var input = element[0].querySelector('md-input-container');

                    if (input) {
                        var computedStyle = getComputedStyle(input);
                        var minWidth = parseInt(computedStyle.minWidth);
                        var padding = parseInt(computedStyle.padding) * 2;

                        initialMaxWidth = initialMaxWidth || parseInt(computedStyle.maxWidth);
                        var newMaxWidth = Math.max(initialMaxWidth, minWidth + padding + (minWidth / 2 * length));

                        input.style.maxWidth = newMaxWidth + 'px';
                    }
                };
            };
        }
    };
}

/**
 * @ngdoc directive
 * @name msSlider
 * @module material.components.slider
 * @restrict E
 * @description
 * The `<ms-slider>` component allows the user to choose from a range of
 * values.
 *
 * As per the [material design spec](http://www.google.com/design/spec/style/color.html#color-ui-color-application)
 * the slider is in the accent color by default. The primary color palette may be used with
 * the `ms-primary` class.
 *
 * It has two modes: 'normal' mode, where the user slides between a wide range
 * of values, and 'discrete' mode, where the user slides between only a few
 * select values.
 *
 * To enable discrete mode, add the `ms-discrete` attribute to a slider,
 * and use the `step` attribute to change the distance between
 * values the user is allowed to pick.
 *
 * @usage
 * <h4>Normal Mode</h4>
 * <hljs lang="html">
 * <ms-slider ng-model="myValue" min="5" max="500">
 * </ms-slider>
 * </hljs>
 * <h4>Discrete Mode</h4>
 * <hljs lang="html">
 * <ms-slider ms-discrete ng-model="myDiscreteValue" step="10" min="10" max="130">
 * </ms-slider>
 * </hljs>
 * <h4>Invert Mode</h4>
 * <hljs lang="html">
 * <ms-slider ms-invert ng-model="myValue" step="10" min="10" max="130">
 * </ms-slider>
 * </hljs>
 *
 * @param {boolean=} ms-discrete Whether to enable discrete mode.
 * @param {boolean=} ms-invert Whether to enable invert mode.
 * @param {number=} step The distance between values the user is allowed to pick. Default 1.
 * @param {number=} min The minimum value the user is allowed to pick. Default 0.
 * @param {number=} max The maximum value the user is allowed to pick. Default 100.
 * @param {number=} round The amount of numbers after the decimal point, maximum is 6 to prevent scientific notation. Default 3.
 */
function SliderDirective($$rAF, $window, $mdAria, $mdUtil, $mdConstant, $mdTheming, $mdGesture, $parse, $log, $timeout) {
    // **********************************************************
    // Data
    // **********************************************************
    var vm = this;
    vm.groups = [];
    return {
        scope: {},
        require: ['?ngModel', '?^msSliderContainer'],
        template:
        '<div class="ms-slider-wrapper">' +
        '<div class="ms-slider-content">' +
        '<div class="ms-track-container">' +
        '<div class="ms-track"></div>' +
        '<div class="ms-track ms-track-fill"></div>' +
        '<div class="ms-track-ticks"></div>' +
        '</div>' +
        '<div class="ms-thumb-container">' +
        '<div class="ms-thumb"></div>' +
        '<div class="ms-focus-thumb"></div>' +
        '<div class="ms-focus-ring"></div>' +
        '<div class="ms-sign">' +
        '<span class="ms-thumb-text"></span>' +
        '</div>' +
        '<div class="ms-disabled-thumb"></div>' +
        '</div>' +
        '</div>' +
        '</div>',
        compile: compile
    };

    // **********************************************************
    // Private Methods
    // **********************************************************

    function compile (tElement, tAttrs) {
        var wrapper = angular.element(tElement[0].getElementsByClassName('ms-slider-wrapper'));

        var tabIndex = tAttrs.tabindex || 0;
        wrapper.attr('tabindex', tabIndex);

        if (tAttrs.disabled || tAttrs.ngDisabled) wrapper.attr('tabindex', -1);

        wrapper.attr('role', 'slider');

        $mdAria.expect(tElement, 'aria-label');

        return postLink;
    }

    function postLink(scope, element, attr, ctrls) {
        $mdTheming(element);
        var ngModelCtrl = ctrls[0] || {
                // Mock ngModelController if it doesn't exist to give us
                // the minimum functionality needed
                $setViewValue: function(val) {
                    this.$viewValue = val;
                    this.$viewChangeListeners.forEach(function(cb) { cb(); });
                },
                $parsers: [],
                $formatters: [],
                $viewChangeListeners: []
            };

        var containerCtrl = ctrls[1];
        var container = angular.element($mdUtil.getClosest(element, '_ms-slider-container', true));
        var isDisabled = attr.ngDisabled ? angular.bind(null, $parse(attr.ngDisabled), scope.$parent) : function () {
            return element[0].hasAttribute('disabled');
        };

        var thumb = angular.element(element[0].querySelector('.ms-thumb'));
        var thumbText = angular.element(element[0].querySelector('.ms-thumb-text'));
        var thumbContainer = thumb.parent();
        var trackContainer = angular.element(element[0].querySelector('.ms-track-container'));
        var activeTrack = angular.element(element[0].querySelector('.ms-track-fill'));
        var tickContainer = angular.element(element[0].querySelector('.ms-track-ticks'));
        var wrapper = angular.element(element[0].getElementsByClassName('ms-slider-wrapper'));
        var content = angular.element(element[0].getElementsByClassName('ms-slider-content'));
        var throttledRefreshDimensions = $mdUtil.throttle(refreshSliderDimensions, 5000);

        // Default values, overridable by attrs
        var DEFAULT_ROUND = 3;
        var vertical = angular.isDefined(attr.msVertical);
        var discrete = angular.isDefined(attr.msDiscrete);
        var invert = angular.isDefined(attr.msInvert);
        angular.isDefined(attr.min) ? attr.$observe('min', updateMin) : updateMin(0);
        angular.isDefined(attr.max) ? attr.$observe('max', updateMax) : updateMax(100);
        angular.isDefined(attr.shared) ? attr.$observe('shared', updateShared) : null;
        angular.isDefined(attr.step) ? attr.$observe('step', updateStep) : updateStep(1);
        angular.isDefined(attr.round)? attr.$observe('round', updateRound) : updateRound(DEFAULT_ROUND);
        angular.isDefined(attr.group)? attr.$observe('group', updateGroup) : null;

        // We have to manually stop the $watch on ngDisabled because it exists
        // on the parent scope, and won't be automatically destroyed when
        // the component is destroyed.
        var stopDisabledWatch = angular.noop;
        if (attr.ngDisabled) {
            stopDisabledWatch = scope.$parent.$watch(attr.ngDisabled, updateAriaDisabled);
        }

        $mdGesture.register(wrapper, 'drag', { horizontal: !vertical });

        scope.mouseActive = false;
        wrapper
            .on('keydown', keydownListener)
            .on('mousedown', mouseDownListener)
            .on('focus', focusListener)
            .on('blur', blurListener)
            .on('$md.pressdown', onPressDown)
            .on('$md.pressup', onPressUp)
            .on('$md.dragstart', onDragStart)
            .on('$md.drag', onDrag)
            .on('$md.dragend', onDragEnd);

        // On resize, recalculate the slider's dimensions and re-render
        function updateAll() {
            refreshSliderDimensions();
            ngModelRender();
        }
        setTimeout(updateAll, 0);

        var debouncedUpdateAll = $$rAF.throttle(updateAll);
        angular.element($window).on('resize', debouncedUpdateAll);

        scope.$on('$destroy', function() {
            angular.element($window).off('resize', debouncedUpdateAll);
            vm.groups = [];
        });

        ngModelCtrl.$render = ngModelRender;
        ngModelCtrl.$viewChangeListeners.push(ngModelRender);
        ngModelCtrl.$formatters.push(minMaxValidator);
        ngModelCtrl.$formatters.push(stepValidator);

        /**
         * Attributes
         */
        var min;
        var max;
        var shared;
        var step;
        var round;
        var group;
        function updateMin(value) {
            min = parseFloat(value);
            element.attr('aria-valuemin', value);
            updateAll();
        }
        function updateMax(value) {
            max = parseFloat(value);
            element.attr('aria-valuemax', value);
            updateAll();
        }
        function updateShared(value) {
            shared = parseFloat(value);
            element.attr('aria-valueshared', value);
            updateAll();
        }
        function updateStep(value) {
            step = parseFloat(value);
        }
        function updateRound(value) {
            // Set max round digits to 6, after 6 the input uses scientific notation
            round = minMaxValidator(parseInt(value), 0, 6);
        }
        function updateGroup(value) {
            if(typeof(value) !== 'undefined' && value != null){
                group = value;
                updateAll();

                if(typeof(vm.groups[value]) === 'undefined' || vm.groups[value] == null){
                    vm.groups[value] = [];
                    vm.groups[value].sliders = [];
                    vm.groups[value].order = [];
                }
                vm.groups[value].sliders.push({element:element, ngModelCtrl:ngModelCtrl});
                vm.groups[value].order.push(vm.groups[value].sliders.length-1);
            }

        }
        function updateAriaDisabled() {
            element.attr('aria-disabled', !!isDisabled());
        }

        // Draw the ticks with canvas.
        // The alternative to drawing ticks with canvas is to draw one element for each tick,
        // which could quickly become a performance bottleneck.
        var tickCanvas, tickCtx;
        function redrawTicks() {
            if (!discrete || isDisabled()) return;
            if ( angular.isUndefined(step) )         return;

            if ( step <= 0 ) {
                var msg = 'Slider step value must be greater than zero when in discrete mode';
                $log.error(msg);
                throw new Error(msg);
            }

            var numSteps = Math.floor( (max - min) / step );
            if (!tickCanvas) {
                tickCanvas = angular.element('<canvas>').css('position', 'absolute');
                tickContainer.append(tickCanvas);

                tickCtx = tickCanvas[0].getContext('2d');
            }

            var dimensions = getSliderDimensions();

            // If `dimensions` doesn't have height and width it might be the first attempt so we will refresh dimensions
            if (dimensions && !dimensions.height && !dimensions.width) {
                refreshSliderDimensions();
                dimensions = sliderDimensions;
            }

            tickCanvas[0].width = dimensions.width;
            tickCanvas[0].height = dimensions.height;

            var distance;
            for (var i = 0; i <= numSteps; i++) {
                var trackTicksStyle = $window.getComputedStyle(tickContainer[0]);
                tickCtx.fillStyle = trackTicksStyle.color || 'black';

                distance = Math.floor((vertical ? dimensions.height : dimensions.width) * (i / numSteps));

                tickCtx.fillRect(vertical ? 0 : distance - 1,
                    vertical ? distance - 1 : 0,
                    vertical ? dimensions.width : 2,
                    vertical ? 2 : dimensions.height);
            }
        }

        function clearTicks() {
            if(tickCanvas && tickCtx) {
                var dimensions = getSliderDimensions();
                tickCtx.clearRect(0, 0, dimensions.width, dimensions.height);
            }
        }

        /**
         * Refreshing Dimensions
         */
        var sliderDimensions = {};
        refreshSliderDimensions();
        function refreshSliderDimensions() {
            sliderDimensions = trackContainer[0].getBoundingClientRect();
        }
        function getSliderDimensions() {
            throttledRefreshDimensions();
            return sliderDimensions;
        }

        /**
         * left/right/up/down arrow listener
         */
        function keydownListener(ev) {
            if (isDisabled()) return;

            var changeAmount;
            if (vertical ? ev.keyCode === $mdConstant.KEY_CODE.DOWN_ARROW : ev.keyCode === $mdConstant.KEY_CODE.LEFT_ARROW) {
                changeAmount = -step;
            } else if (vertical ? ev.keyCode === $mdConstant.KEY_CODE.UP_ARROW : ev.keyCode === $mdConstant.KEY_CODE.RIGHT_ARROW) {
                changeAmount = step;
            }
            changeAmount = invert ? -changeAmount : changeAmount;
            if (changeAmount) {
                if (ev.metaKey || ev.ctrlKey || ev.altKey) {
                    changeAmount *= 4;
                }
                ev.preventDefault();
                ev.stopPropagation();
                scope.$evalAsync(function() {
                    setModelValue(ngModelCtrl.$viewValue + changeAmount);
                });
            }
        }

        function mouseDownListener(ev) {
            ev.preventDefault();
            redrawTicks();
            scope.mouseActive = true;
            wrapper.removeClass('ms-focused');

            $timeout(function() {
                scope.mouseActive = false;
            }, 100);
        }

        function focusListener() {
            if (scope.mouseActive === false) {
                wrapper.addClass('ms-focused');
            }
        }

        function blurListener() {
            wrapper.removeClass('ms-focused');
            element.removeClass('ms-active');
            clearTicks();
        }

        /**
         * ngModel setters and validators
         */
        function setModelValue(value) {
            ngModelCtrl.$setViewValue( minMaxValidator(stepValidator(value)) );
            //Shared slider?
            if(angular.isDefined(attr.group) && vm.groups[attr.group].sliders.length > 1) {

                var currentSharedSliderId = getCurrentSharedSliderId();
                var index = currentSharedSliderId;
                var excess = shared;

                angular.forEach(vm.groups[attr.group].sliders, function(slider) {
                    excess -= slider.ngModelCtrl.$viewValue;
                });
                if (currentSharedSliderId != vm.groups[attr.group].order[vm.groups[attr.group].order.length-1]){
                    vm.groups[attr.group].order.splice(vm.groups[attr.group].order.indexOf(currentSharedSliderId), 1);
                    vm.groups[attr.group].order.push(currentSharedSliderId);
                }

                for (var i = 0; i < vm.groups[attr.group].sliders.length; i++) {
                    if (index != currentSharedSliderId) {
                        var slider = vm.groups[attr.group].sliders[index];
                        var val = slider.ngModelCtrl.$viewValue;
                        var newVal = 0;

                        newVal = Math.min(Math.max(val + excess, slider.element.attr('aria-valuemin')), slider.element.attr('aria-valuemax'));
                        slider.ngModelCtrl.$setViewValue(newVal);
                        excess -= (newVal - val);
                        if (excess == 0)
                            break;
                    }

                    index = vm.groups[attr.group].order[i];
                }
            }
        }

        function ngModelRender() {
            if (isNaN(ngModelCtrl.$viewValue)) {
                ngModelCtrl.$viewValue = ngModelCtrl.$modelValue;
            }

            ngModelCtrl.$viewValue = minMaxValidator(ngModelCtrl.$viewValue);

            var percent = valueToPercent(ngModelCtrl.$viewValue);
            scope.modelValue = ngModelCtrl.$viewValue;
            element.attr('aria-valuenow', ngModelCtrl.$viewValue);
            setSliderPercent(percent);
            thumbText.text( ngModelCtrl.$viewValue );
        }

        function minMaxValidator(value, minValue, maxValue) {
            if (angular.isNumber(value)) {
                minValue = angular.isNumber(minValue) ? minValue : min;
                maxValue = angular.isNumber(maxValue) ? maxValue : max;

                return Math.max(minValue, Math.min(maxValue, value));
            }
        }

        function stepValidator(value) {
            if (angular.isNumber(value)) {
                var formattedValue = (Math.round((value - min) / step) * step + min);
                formattedValue = (Math.round(formattedValue * Math.pow(10, round)) / Math.pow(10, round));

                if (formattedValue + step > max)
                    formattedValue = max;
                if (formattedValue - step < min)
                    formattedValue = min;

                if (containerCtrl && containerCtrl.fitInputWidthToTextLength){
                    $mdUtil.debounce(function () {
                        containerCtrl.fitInputWidthToTextLength(formattedValue.toString().length);
                    }, 100)();
                }

                return formattedValue;
            }
        }

        /**
         * @param percent 0-1
         */
        function setSliderPercent(percent) {

            percent = clamp(percent);

            var thumbPosition = (percent * 100) + '%';
            var activeTrackPercent = invert ? (1 - percent) * 100 + '%' : thumbPosition;

            if (vertical) {
                thumbContainer.css('bottom', thumbPosition);
            }
            else {
                $mdUtil.bidiProperty(thumbContainer, 'left', 'right', thumbPosition);
            }


            activeTrack.css(vertical ? 'height' : 'width', activeTrackPercent);

            element.toggleClass((invert ? 'ms-max' : 'ms-min'), percent === 0);
            element.toggleClass((invert ? 'ms-min' : 'ms-max'), percent === 1);
        }

        function getCurrentSharedSliderId() {
            var currentSharedSliderGroup = attr.group;
            var sharedSliders = angular.isDefined(vm.groups[currentSharedSliderGroup].sliders) ? vm.groups[currentSharedSliderGroup].sliders : [];

            for (var i = 0; i < sharedSliders.length; i++) {
                if (sharedSliders[i].element == element)
                    return i;
            }
        }

        /**
         * Slide listeners
         */
        var isDragging = false;

        function onPressDown(ev) {
            if (isDisabled()) return;

            //element.addClass('ms-active');
            element[0].focus();
            refreshSliderDimensions();

            var exactVal = percentToValue( positionToPercent( vertical ? ev.pointer.y : ev.pointer.x ));
            var closestVal = minMaxValidator( stepValidator(exactVal) );
            scope.$apply(function() {
                setModelValue( closestVal );
                setSliderPercent( valueToPercent(closestVal));
            });
        }
        function onPressUp(ev) {
            if (isDisabled()) return;

            element.removeClass('ms-dragging');

            var exactVal = percentToValue( positionToPercent( vertical ? ev.pointer.y : ev.pointer.x ));
            var closestVal = minMaxValidator( stepValidator(exactVal) );
            scope.$apply(function() {
                setModelValue(closestVal);
                ngModelRender();
            });
        }
        function onDragStart(ev) {
            if (isDisabled()) return;
            isDragging = true;
            ev.stopPropagation();

            element.addClass('ms-dragging');
            setSliderFromEvent(ev);
        }
        function onDrag(ev) {
            if (!isDragging) return;
            ev.stopPropagation();
            setSliderFromEvent(ev);
        }
        function onDragEnd(ev) {
            if (!isDragging) return;
            ev.stopPropagation();
            isDragging = false;
        }

        function setSliderFromEvent(ev) {
            // While panning discrete, update only the
            // visual positioning but not the model value.
            if ( discrete ) adjustThumbPosition( vertical ? ev.pointer.y : ev.pointer.x );
            else            doSlide( vertical ? ev.pointer.y : ev.pointer.x );
        }

        /**
         * Slide the UI by changing the model value
         * @param x
         */
        function doSlide( x ) {
            scope.$evalAsync( function() {
                setModelValue( percentToValue( positionToPercent(x) ));
            });
        }

        /**
         * Slide the UI without changing the model (while dragging/panning)
         * @param x
         */
        function adjustThumbPosition( x ) {
            var exactVal = percentToValue( positionToPercent( x ));
            var closestVal = minMaxValidator( stepValidator(exactVal) );
            setSliderPercent( positionToPercent(x) );
            thumbText.text( closestVal );
        }

        /**
         * Clamps the value to be between 0 and 1.
         * @param {number} value The value to clamp.
         * @returns {number}
         */
        function clamp(value) {
            return Math.max(0, Math.min(value || 0, 1));
        }

        /**
         * Convert position on slider to percentage value of offset from beginning...
         * @param position
         * @returns {number}
         */
        function positionToPercent( position ) {
            var offset = vertical ? sliderDimensions.top : sliderDimensions.left;
            var size = vertical ? sliderDimensions.height : sliderDimensions.width;
            var calc = (position - offset) / size;

            if (!vertical && $mdUtil.bidi() === 'rtl') {
                calc = 1 - calc;
            }

            return Math.max(0, Math.min(1, vertical ? 1 - calc : calc));
        }

        /**
         * Convert percentage offset on slide to equivalent model value
         * @param percent
         * @returns {*}
         */
        function percentToValue( percent ) {
            var adjustedPercent = invert ? (1 - percent) : percent;
            return (min + adjustedPercent * (max - min));
        }

        function valueToPercent( val ) {
            var percent = (val - min) / (max - min);
            return invert ? (1 - percent) : percent;
        }
    }
}
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsShortcutsController', MsShortcutsController)
        .directive('msShortcuts', msShortcutsDirective);

    /** @ngInject */
    function MsShortcutsController($scope, $cookies, $document, $timeout, $q, msNavigationService)
    {
        var vm = this;

        // Data
        vm.query = '';
        vm.queryOptions = {
            debounce: 300
        };
        vm.resultsLoading = false;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;
        vm.mobileBarActive = false;

        vm.results = null;
        vm.shortcuts = [];

        vm.sortableOptions = {
            ghostClass   : 'ghost',
            forceFallback: true,
            fallbackClass: 'dragging',
            onSort       : function ()
            {
                vm.saveShortcuts();
            }
        };

        // Methods
        vm.populateResults = populateResults;
        vm.loadShortcuts = loadShortcuts;
        vm.saveShortcuts = saveShortcuts;
        vm.addShortcut = addShortcut;
        vm.removeShortcut = removeShortcut;
        vm.handleResultClick = handleResultClick;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;
        vm.toggleMobileBar = toggleMobileBar;

        //////////

        init();

        function init()
        {
            // Load the shortcuts
            vm.loadShortcuts().then(
                // Success
                function (response)
                {
                    vm.shortcuts = response;

                    // Add shortcuts as results by default
                    if ( vm.shortcuts.length > 0 )
                    {
                        vm.results = response;
                    }
                }
            );

            // Watch the model changes to trigger the search
            $scope.$watch('MsShortcuts.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                // Show the loader
                vm.resultsLoading = true;

                // Populate the results
                vm.populateResults().then(
                    // Success
                    function (response)
                    {
                        vm.results = response;
                    },
                    // Error
                    function ()
                    {
                        vm.results = [];
                    }
                ).finally(
                    function ()
                    {
                        // Hide the loader
                        vm.resultsLoading = false;
                    }
                );
            });
        }

        /**
         * Populate the results
         */
        function populateResults()
        {
            var results = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    results.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the results
            if ( vm.query )
            {
                results = results.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(vm.query)) > -1 )
                    {
                        return true;
                    }
                });

                // Iterate through one last time and
                // add required properties to items
                for ( var i = 0; i < results.length; i++ )
                {
                    // Add false to hasShortcut by default
                    results[i].hasShortcut = false;

                    // Test if the item is in the shortcuts list
                    for ( var y = 0; y < vm.shortcuts.length; y++ )
                    {
                        if ( vm.shortcuts[y]._id === results[i]._id )
                        {
                            results[i].hasShortcut = true;
                            break;
                        }
                    }
                }
            }
            else
            {
                // If the query is empty, that means
                // there is nothing to search for so
                // we will populate the results with
                // current shortcuts if there is any
                if ( vm.shortcuts.length > 0 )
                {
                    results = vm.shortcuts;
                }
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Fake the service delay
            $timeout(function ()
            {
                // Resolve the promise
                deferred.resolve(results);
            }, 250);

            // Return a promise
            return deferred.promise;
        }

        /**
         * Load shortcuts
         */
        function loadShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // load the shortcuts from the cookies.
            // But here you can make an API call
            // to load them from the DB.
            var shortcuts = angular.fromJson($cookies.get('ICO.shortcuts'));

            // No cookie available. Generate one
            // for the demo purposes...
            if ( angular.isUndefined(shortcuts) )
            {
                shortcuts = [
                    {
                        'title'      : 'Sample',
                        'icon'       : 'icon-tile-four',
                        'state'      : 'app.sample',
                        'weight'     : 1,
                        'children'   : [],
                        '_id'        : 'sample',
                        '_path'      : 'apps.sample',
                        'uisref'     : 'app.sample',
                        'hasShortcut': true
                    }
                ];

                $cookies.put('ICO.shortcuts', angular.toJson(shortcuts));
            }

            // Resolve the promise
            deferred.resolve(shortcuts);

            return deferred.promise;
        }

        /**
         * Save the shortcuts
         */
        function saveShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // keep the shortcuts in the cookies.
            // But here you can make an API call
            // to save them to the DB.
            $cookies.put('ICO.shortcuts', angular.toJson(vm.shortcuts));

            // Fake the service delay
            $timeout(function ()
            {
                deferred.resolve({'success': true});
            }, 250);

            return deferred.promise;
        }

        /**
         * Add item as shortcut
         *
         * @param item
         */
        function addShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = true;

            // Add as a shortcut
            vm.shortcuts.push(item);

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Remove item from shortcuts
         *
         * @param item
         */
        function removeShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = false;

            // Remove the shortcut
            for ( var x = 0; x < vm.shortcuts.length; x++ )
            {
                if ( vm.shortcuts[x]._id === item._id )
                {
                    // Remove the x-th item from the array
                    vm.shortcuts.splice(x, 1);

                    // If we aren't searching for anything...
                    if ( !vm.query )
                    {
                        // If all the shortcuts have been removed,
                        // null-ify the results
                        if ( vm.shortcuts.length === 0 )
                        {
                            vm.results = null;
                        }
                        // Otherwise update the selected index
                        else
                        {
                            if ( x >= vm.shortcuts.length )
                            {
                                vm.selectedResultIndex = vm.shortcuts.length - 1;
                            }
                        }
                    }
                }
            }

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            // Add or remove the shortcut
            if ( item.hasShortcut )
            {
                vm.removeShortcut(item);
            }
            else
            {
                vm.addShortcut(item);
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $document.find('#ms-shortcut-add-menu').find('.results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }

        /**
         * Toggle mobile bar
         */
        function toggleMobileBar()
        {
            vm.mobileBarActive = !vm.mobileBarActive;
        }
    }

    /** @ngInject */
    function msShortcutsDirective()
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msShortcuts',
            controller      : 'MsShortcutsController as MsShortcuts',
            bindToController: {},
            templateUrl     : 'app/core/directives/ms-shortcuts/ms-shortcuts.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-shortcuts');

                return function postLink(scope, iElement)
                {
                    // Data

                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSelectOnClick', ['$window', msSelectOnClick]);

    /** @ngInject */
    function msSelectOnClick($window)
    {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                element.on('click', function () {
                    if (!$window.getSelection().toString()) {
                        // Required for mobile Safari
                        this.setSelectionRange(0, this.value.length)
                    }
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsSearchBarController', MsSearchBarController)
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function MsSearchBarController($scope, $element, $timeout)
    {
        var vm = this;

        // Data
        vm.collapsed = true;
        vm.query = '';
        vm.queryOptions = {
            debounce: vm.debounce || 0
        };
        vm.resultsLoading = false;
        vm.results = null;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;

        // Methods
        vm.populateResults = populateResults;

        vm.expand = expand;
        vm.collapse = collapse;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.handleResultClick = handleResultClick;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;

        //////////

        init();

        function init()
        {
            // Watch the model changes to trigger the search
            $scope.$watch('MsSearchBar.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                if ( vm.collapsed )
                {
                    return;
                }

                // Evaluate the onSearch function to access the
                // function itself
                var onSearchEvaluated = $scope.$parent.$eval(vm.onSearch, {query: current}),
                    isArray = angular.isArray(onSearchEvaluated),
                    isPromise = (onSearchEvaluated && !!onSearchEvaluated.then);

                if ( isArray )
                {
                    // Populate the results
                    vm.populateResults(onSearchEvaluated);
                }

                if ( isPromise )
                {
                    // Show the loader
                    vm.resultsLoading = true;

                    onSearchEvaluated.then(
                        // Success
                        function (response)
                        {
                            // Populate the results
                            vm.populateResults(response);
                        },
                        // Error
                        function ()
                        {
                            // Assign an empty array to show
                            // the no-results screen
                            vm.populateResults([]);
                        }
                    ).finally(function ()
                        {
                            // Hide the loader
                            vm.resultsLoading = false;
                        }
                    );
                }
            });
        }

        /**
         * Populate the results
         *
         * @param results
         */
        function populateResults(results)
        {
            // Before doing anything,
            // make sure the search bar is expanded
            if ( vm.collapsed )
            {
                return;
            }

            var isArray = angular.isArray(results),
                isNull = results === null;

            // Only accept arrays and null values
            if ( !isArray && !isNull )
            {
                return;
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Populate the results
            vm.results = results;
        }

        /**
         * Expand
         */
        function expand()
        {
            // Set collapsed status
            vm.collapsed = false;

            // Call expand on scope
            $scope.expand();

            // Callback
            if ( vm.onExpand && angular.isFunction(vm.onExpand) )
            {
                vm.onExpand();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Empty the query
            vm.query = '';

            // Empty results to hide the results view
            vm.populateResults(null);

            // Set collapsed status
            vm.collapsed = true;

            // Call collapse on scope
            $scope.collapse();

            // Callback
            if ( vm.onCollapse && angular.isFunction(vm.onCollapse) )
            {
                vm.onCollapse();
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [27, 38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Escape
                case 27:

                    // Collapse the search bar
                    vm.collapse();

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    if ( !vm.results )
                    {
                        return;
                    }

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            if ( vm.onResultClick )
            {
                vm.onResultClick({item: item});
            }

            // Collapse the search bar
            vm.collapse();
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $element.find('.ms-search-bar-results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }
    }

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msSearchBar',
            controller      : 'MsSearchBarController as MsSearchBar',
            bindToController: {
                debounce     : '=?',
                onSearch     : '@',
                onResultClick: '&?',
                onExpand     : '&?',
                onCollapse   : '&?'
            },
            templateUrl     : 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    // Data
                    var inputEl,
                        bodyEl = $document.find('body');

                    // Methods
                    scope.collapse = collapse;
                    scope.expand = expand;

                    //////////

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Grab the input element
                        inputEl = iElement.find('#ms-search-bar-input');
                    }

                    /**
                     * Expand action
                     */
                    function expand()
                    {
                        // Add expanded class
                        iElement.addClass('expanded');

                        // Add helper class to the body
                        bodyEl.addClass('ms-search-bar-expanded');

                        // Focus on the input
                        inputEl.focus();
                    }

                    /**
                     * Collapse action
                     */
                    function collapse()
                    {
                        // Remove expanded class
                        iElement.removeClass('expanded');

                        // Remove helper class from the body
                        bodyEl.removeClass('ms-search-bar-expanded');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, icoConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( icoConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( icoConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider)
        .controller('MsNavigationController', MsNavigationController)
        // Vertical
        .directive('msNavigation', msNavigationDirective)
        .controller('MsNavigationNodeController', MsNavigationNodeController)
        .directive('msNavigationNode', msNavigationNodeDirective)
        .directive('msNavigationItem', msNavigationItemDirective)
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationServiceProvider()
    {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for ( var i = 0; i < parent.length; i++ )
            {
                if ( parent[i]._id === id )
                {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if ( updateItem )
            {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else
            {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if ( angular.isUndefined(item.weight) || !angular.isNumber(item.weight) )
                {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for ( var p = 0; p < parts.length; p++ )
            {
                var id = parts[p];

                for ( var i = 0; i < item.length; i++ )
                {
                    if ( item[i]._id === id )
                    {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if ( item[i]._path === path )
                        {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent)
        {
            // If parent not provided, sort the root items
            if ( !parent )
            {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for ( var i = 0; i < parent.length; i++ )
            {
                var children = parent[i].children;

                if ( children.length > 1 )
                {
                    children.sort(_byWeight);
                }

                if ( children.length > 0 )
                {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts)
        {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if ( parts.length === 1 )
            {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for ( var i = 0; i < parts.length; i++ )
            {
                var _id = parts[i],
                    createParent = true;

                for ( var p = 0; p < parent.length; p++ )
                {
                    if ( parent[p]._id === _id )
                    {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if ( createParent )
                {
                    var item = {
                        _id     : _id,
                        _path   : parts.join('.'),
                        title   : _id,
                        weight  : 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y)
        {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item)
        {
            var uisref = '';

            if ( angular.isDefined(item.state) )
            {
                uisref = item.state;

                if ( angular.isDefined(item.stateParams) && angular.isObject(item.stateParams) )
                {
                    uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function ()
        {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null;

            var service = {
                saveItem          : saveItem,
                deleteItem        : deleteItem,
                sort              : sortByWeight,
                clearNavigation   : clearNavigation,
                setActiveItem     : setActiveItem,
                getActiveItem     : getActiveItem,
                getNavigation     : getNavigation,
                getFlatNavigation : getFlatNavigation,
                setNavigationScope: setNavigationScope,
                setFolded         : setFolded,
                getFolded         : getFolded,
                setFoldedOpen     : setFoldedOpen,
                getFoldedOpen     : getFoldedOpen,
                toggleFolded      : toggleFolded
            };

            return service;

            //////////

            /**
             * Clear the entire navigation
             */
            function clearNavigation()
            {
                // Clear the navigation array
                navigation = [];

                // Clear the vm.navigation from main controller
                if ( navigationScope )
                {
                    navigationScope.vm.navigation = navigation;
                }
            }

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope)
            {
                activeItem = {
                    node : node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem()
            {
                return activeItem;
            }

            /**
             * Return navigation array
             *
             * @param root
             * @returns Array
             */
            function getNavigation(root)
            {
                if ( root )
                {
                    for ( var i = 0; i < navigation.length; i++ )
                    {
                        if ( navigation[i]._id === root )
                        {
                            return [navigation[i]];
                        }
                    }

                    return null;
                }

                return navigation;
            }

            /**
             * Return flat navigation array
             *
             * @param root
             * @returns Array
             */
            function getFlatNavigation(root)
            {
                // Get the correct navigation array
                var navigation = getNavigation(root);

                // Flatten the navigation object
                return _flattenNavigation(navigation);
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope)
            {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status)
            {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded()
            {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status)
            {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen()
            {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded()
            {
                navigationScope.toggleFolded();
            }

            /**
             * Flatten the given navigation
             *
             * @param navigation
             * @private
             */
            function _flattenNavigation(navigation)
            {
                var flatNav = [];

                for ( var x = 0; x < navigation.length; x++ )
                {
                    // Copy and clear the children of the
                    // navigation that we want to push
                    var navToPush = angular.copy(navigation[x]);
                    navToPush.children = [];

                    // Push the item
                    flatNav.push(navToPush);

                    // If there are child items in this navigation,
                    // do some nested function magic
                    if ( navigation[x].children.length > 0 )
                    {
                        flatNav = flatNav.concat(_flattenNavigation(navigation[x].children));
                    }
                }

                return flatNav;
            }
        };
    }

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService)
    {
        var vm = this;

        // Data
        if ( $scope.root )
        {
            vm.navigation = msNavigationService.getNavigation($scope.root);
        }
        else
        {
            vm.navigation = msNavigationService.getNavigation();
        }

        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                folded: '=',
                root  : '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if ( msNavigationService.getFolded() === null )
                        {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if ( msNavigationService.getFolded() )
                        {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function ()
                            {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function ()
                    {
                        return sidenav.isLockedOpen();
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if ( folded )
                        {
                            if ( current )
                            {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            }
                            else
                            {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if ( activeItem )
                                {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded)
                    {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if ( folded )
                        {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                        else
                        {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if ( activeItem )
                            {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander()
                    {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function ()
                        {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser()
                    {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser()
                    {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if ( activeItem )
                        {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                        bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function ()
                    {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    scope.$on('$stateChangeStart', function ()
                    {
                        // Close the sidenav
                        sidenav.close();
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';

        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;
        vm.isHidden = isHidden;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Is collapsable?
            if ( !vm.hasChildren || vm.group )
            {
                vm.collapsable = false;
            }
            else
            {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if ( !vm.collapsable )
            {
                vm.collapsed = false;
            }
            else
            {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Expand if the current scope is collapsable and is collapsed
                if ( vm.collapsable && vm.collapsed )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function (event, path)
            {
                if ( vm.collapsed || !vm.collapsable )
                {
                    return;
                }

                // If there is no path defined, collapse
                if ( angular.isUndefined(path) )
                {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else
                {
                    var givenPathParts = path.split('.'),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if ( activeItem )
                    {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if ( givenPathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    // Test for active path
                    if ( activePathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }

                // Expand the parents if we the current
                // state is a child of the node's state
                if ( $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Emit the stateMatched
                    $scope.$emit('msNavigation::stateMatched');
                }
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed()
        {
            if ( vm.collapsed )
            {
                vm.expand();
            }
            else
            {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl,
                    {
                        'display': 'block',
                        'height' : height + 'px'
                    },
                    {
                        'height': '0px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height' : ''
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand()
        {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position'  : 'absolute',
                'visibility': 'hidden',
                'display'   : 'block',
                'height'    : 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position'  : '',
                'visibility': '',
                'display'   : '',
                'height'    : ''
            });

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl,
                    {
                        'display': 'block',
                        'height' : '0px'
                    },
                    {
                        'height': height + 'px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }

        /**
         * Check if node should be hidden
         *
         * @returns {boolean}
         */
        function isHidden()
        {
            if ( angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden) )
            {
                return vm.node.hidden();
            }

            return false;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller      : 'MsNavigationNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective()
    {
        return {
            restrict: 'A',
            require : '^msNavigationNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // If the item is collapsable...
                    if ( MsNavigationNodeCtrl.collapsable )
                    {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                root: '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope)
                {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Mark as active if has children
                if ( vm.hasChildren )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function ()
            {
                if ( !vm.hasChildren )
                {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if ( activeItem )
                {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if ( activePathParts.indexOf(vm.node._id) > -1 )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
                else
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller      : 'MsNavigationHorizontalNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationHorizontalNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia)
    {
        return {
            restrict: 'A',
            require : '^msNavigationHorizontalNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    iElement.on('click', onClick);

                    function onClick()
                    {
                        if ( !MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md') )
                        {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMasonryController', msMasonryController)
        .directive('msMasonry', msMasonry)
        .directive('msMasonryItem', msMasonryItem);

    /** @ngInject */
    function msMasonryController($scope, $window, $mdMedia, $timeout)
    {
        var vm = this,
            defaultOpts = {
                columnCount     : 5,
                respectItemOrder: false,
                reLayoutDebounce: 400,
                responsive      : {
                    md: 3,
                    sm: 2,
                    xs: 1
                }
            },
            reLayoutTimeout = true;

        vm.options = null;
        vm.container = [];
        vm.containerPos = '';
        vm.columnWidth = '';
        vm.items = [];

        // Methods
        vm.reLayout = reLayout;
        vm.initialize = initialize;
        vm.waitImagesLoaded = waitImagesLoaded;

        function initialize()
        {
            vm.options = !vm.options ? defaultOpts : angular.extend(defaultOpts, vm.options);


            watchContainerResize();
        }

        $scope.$on('msMasonry:relayout', function ()
        {
            reLayout();
        });

        function waitImagesLoaded(element, callback)
        {
            if ( typeof imagesLoaded !== 'undefined' )
            {
                var imgLoad = $window.imagesLoaded(element);

                imgLoad.on('done', function ()
                {
                    callback();
                });
            }
            else
            {
                callback();
            }
        }

        function watchContainerResize()
        {
            $scope.$watch(
                function ()
                {
                    return vm.container.width();
                },
                function (newValue, oldValue)
                {
                    if ( newValue !== oldValue )
                    {
                        reLayout();
                    }
                }
            );
        }

        function reLayout()
        {
            // Debounce for relayout
            if ( reLayoutTimeout )
            {
                $timeout.cancel(reLayoutTimeout);
            }

            reLayoutTimeout = $timeout(function ()
            {
                start();

                $scope.$broadcast('msMasonry:relayoutFinished');

            }, vm.options.reLayoutDebounce);

            // Start relayout
            function start()
            {
                vm.containerPos = vm.container[0].getBoundingClientRect();

                updateColumnOptions();

                $scope.$broadcast('msMasonry:relayoutStarted');

                vm.items = vm.container.find('ms-masonry-item');

                //initialize lastRowBottomArr
                var referenceArr = Array.apply(null, new Array(vm.columnCount)).map(function ()
                {
                    return 0;
                });

                // set item positions
                for ( var i = 0; i < vm.items.length; i++ )
                {
                    var item = vm.items[i],
                        xPos, yPos, column, refTop;

                    item = angular.element(item);

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:startReLayout');
                    }

                    item.css({'width': vm.columnWidth});

                    if ( vm.options.respectItemOrder )
                    {
                        column = i % vm.columnCount;
                        refTop = referenceArr[column];
                    }
                    else
                    {
                        refTop = Math.min.apply(Math, referenceArr);
                        column = referenceArr.indexOf(refTop);
                    }

                    referenceArr[column] = refTop + item[0].getBoundingClientRect().height;

                    xPos = Math.round(column * vm.columnWidth);
                    yPos = refTop;

                    item.css({'transform': 'translate3d(' + xPos + 'px,' + yPos + 'px,0px)'});
                    item.addClass('placed');

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:finishReLayout');
                    }
                }
            }
        }

        function updateColumnOptions()
        {
            vm.columnCount = vm.options.columnCount;

            if ( $mdMedia('gt-md') )
            {
                vm.columnCount = vm.options.columnCount;
            }
            else if ( $mdMedia('md') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.md ? vm.options.responsive.md : vm.columnCount);
            }
            else if ( $mdMedia('sm') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.sm ? vm.options.responsive.sm : vm.columnCount);
            }
            else
            {
                vm.columnCount = vm.options.responsive.xs;
            }

            vm.columnWidth = vm.containerPos.width / vm.columnCount;

        }
    }

    /** @ngInject */
    function msMasonry($timeout)
    {
        return {
            restrict  : 'AEC',
            controller: 'msMasonryController',
            compile   : compile
        };
        function compile(element, attributes)
        {
            return {
                pre : function preLink(scope, iElement, iAttrs, controller)
                {
                    controller.options = angular.fromJson(attributes.options || '{}');
                    controller.container = element;
                },
                post: function postLink(scope, iElement, iAttrs, controller)
                {
                    $timeout(function ()
                    {
                        controller.initialize();
                    });
                }
            };
        }
    }

    /** @ngInject */
    function msMasonryItem()
    {
        return {
            restrict: 'AEC',
            require : '^msMasonry',
            priority: 1,
            link    : link
        };

        function link(scope, element, attributes, controller)
        {
            controller.waitImagesLoaded(element, function ()
            {
                controller.reLayout();

            });

            scope.$on('msMasonryItem:finishReLayout', function ()
            {
                scope.$watch(function ()
                {
                    return element.height();
                }, function (newVal, oldVal)
                {
                    if ( newVal !== oldVal )
                    {
                        controller.reLayout();
                    }
                });
            });

            element.on('$destroy', function ()
            {
                controller.reLayout();
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMaterialColorPickerController', msMaterialColorPickerController)
        .directive('msMaterialColorPicker', msMaterialColorPicker);

    /** @ngInject */
    function msMaterialColorPickerController($scope, $mdColorPalette, $mdMenu, icoGenerator)
    {
        var vm = this;
        vm.palettes = $mdColorPalette; // Material Color Palette
        vm.selectedPalette = false;
        vm.selectedHues = false;
        $scope.$selectedColor = {};

        // Methods
        vm.activateHueSelection = activateHueSelection;
        vm.selectColor = selectColor;
        vm.removeColor = removeColor;

        /**
         * Initialize / Watch model changes
         */
        $scope.$watch('ngModel', setSelectedColor);

        /**
         * Activate Hue Selection
         * @param palette
         * @param hues
         */
        function activateHueSelection(palette, hues)
        {
            vm.selectedPalette = palette;
            vm.selectedHues = hues;
        }

        /**
         * Select Color
         * @type {selectColor}
         */
        function selectColor(palette, hue)
        {
            // Update Selected Color
            updateSelectedColor(palette, hue);

            // Update Model Value
            updateModel();

            // Hide The picker
            $mdMenu.hide();
        }

        function removeColor()
        {
            vm.selectedColor = {
                palette: '',
                hue    : '',
                class  : ''
            };

            activateHueSelection(false, false);

            updateModel();
        }

        /**
         * Set SelectedColor by model type
         */
        function setSelectedColor()
        {
            if ( !vm.modelCtrl.$viewValue || vm.modelCtrl.$viewValue === '' )
            {
                removeColor();
                return;
            }

            var palette, hue;

            // If ModelType Class
            if ( vm.msModelType === 'class' )
            {
                var color = vm.modelCtrl.$viewValue.split('-');
                if ( color.length >= 5 )
                {
                    palette = color[1] + '-' + color[2];
                    hue = color[3];
                }
                else
                {
                    palette = color[1];
                    hue = color[2];
                }
            }

            // If ModelType Object
            else if ( vm.msModelType === 'obj' )
            {
                palette = vm.modelCtrl.$viewValue.palette;
                hue = vm.modelCtrl.$viewValue.hue || 500;
            }

            // Update Selected Color
            updateSelectedColor(palette, hue);
        }

        /**
         * Update Selected Color
         * @param palette
         * @param hue
         */
        function updateSelectedColor(palette, hue)
        {
            vm.selectedColor = {
                palette     : palette,
                hue         : hue,
                class       : 'md-' + palette + '-' + hue + '-bg',
                bgColorValue: icoGenerator.rgba(vm.palettes[palette][hue].value),
                fgColorValue: icoGenerator.rgba(vm.palettes[palette][hue].contrast)
            };

            // If Model object not Equals the selectedColor update it
            // it can be happen when the model only have pallete and hue values
            if ( vm.msModelType === 'obj' && !angular.equals(vm.selectedColor, vm.modelCtrl.$viewValue) )
            {
                // Update Model Value
                updateModel();
            }

            activateHueSelection(palette, vm.palettes[palette]);

            $scope.$selectedColor = vm.selectedColor;
        }

        /**
         * Update Model Value by model type
         */
        function updateModel()
        {
            if ( vm.msModelType === 'class' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor.class);
            }
            else if ( vm.msModelType === 'obj' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor);
            }
        }
    }

    /** @ngInject */
    function msMaterialColorPicker()
    {
        return {
            require    : ['msMaterialColorPicker', 'ngModel'],
            restrict   : 'E',
            scope      : {
                ngModel    : '=',
                msModelType: '@?'
            },
            controller : 'msMaterialColorPickerController as vm',
            transclude : true,
            templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
            link       : function (scope, element, attrs, controllers, transclude)
            {
                var ctrl = controllers[0];

                /**
                 *  Pass model controller to directive controller
                 */
                ctrl.modelCtrl = controllers[1];

                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                ctrl.msModelType = scope.msModelType || 'class';

                transclude(scope, function (clone)
                {
                    clone = clone.filter(function (i, el)
                    {
                        return ( el.nodeType === 1 ) ? true : false;
                    });

                    if ( clone.length )
                    {
                        element.find('ms-color-picker-button').replaceWith(clone);
                    }
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.firstStep = firstStep;
        vm.lastStep = lastStep;

        vm.totalSteps = totalSteps;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.previousStepInvalid = previousStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            if ( isFirstStep() )
            {
                return;
            }

            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            if ( isLastStep() )
            {
                return;
            }

            vm.selectedIndex++;
        }

        /**
         * Go to first step
         */
        function firstStep()
        {
            vm.selectedIndex = 0;
        }

        /**
         * Go to last step
         */
        function lastStep()
        {
            vm.selectedIndex = totalSteps() - 1;
        }

        /**
         * Return total steps
         *
         * @returns {int}
         */
        function totalSteps()
        {
            return vm.forms.length;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === totalSteps() - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Is previous step invalid?
         *
         * @returns {boolean}
         */
        function previousStepInvalid()
        {
            return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to the first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msInfoBar', msInfoBarDirective);

    /** @ngInject */
    function msInfoBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : {},
            transclude : true,
            templateUrl: 'app/core/directives/ms-info-bar/ms-info-bar.html',
            link       : function (scope, iElement)
            {
                var body = $document.find('body'),
                    bodyClass = 'ms-info-bar-active';

                // Add body class
                body.addClass(bodyClass);

                /**
                 * Remove the info bar
                 */
                function removeInfoBar()
                {
                    body.removeClass(bodyClass);
                    iElement.remove();
                    scope.$destroy();
                }

                // Expose functions
                scope.removeInfoBar = removeInfoBar;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider)
        .directive('msDatepickerFix', msDatepickerFix);

    /** @ngInject */
    function msDatepickerFixConfigProvider()
    {
        var service = this;

        // Default configuration
        var defaultConfig = {
            // To view
            formatter: function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return val === '' ? val : new Date(val);
            },
            // To model
            parser   : function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return moment(val).add(moment(val).utcOffset(), 'm').toDate();
            }
        };

        // Methods
        service.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfig = angular.extend({}, defaultConfig, configuration);
        }

        /**
         * Service
         */
        service.$get = function ()
        {
            return defaultConfig;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig)
    {
        return {
            require : 'ngModel',
            priority: 1,
            link    : function (scope, elem, attrs, ngModel)
            {
                ngModel.$formatters.push(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.push(msDatepickerFixConfig.parser); // to model
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msClickCopy', ['ngCopy', msClickCopy]);

    /** @ngInject */
    function msClickCopy(ngCopy)
    {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                element.bind('click', function (e) {
                    ngCopy(attrs.msClickCopy);
                });
            }
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msChooseFile', msChooseFileDirective);

    /** @ngInject */
    function msChooseFileDirective()
    {
        return {
            require : '^form',
            link: function (scope, elm, attrs, formCtrl) {
                var button = elm.find('button');
                var input = angular.element(elm[0].querySelector('input[data-hidden-file-input="1"]'));
                button.bind('click', function() {
                    input[0].click();
                });
                input.on('change', function(e) {
                    scope.$apply(function() {
                        var files = e.target.files;
                        if (files[0]) {
                            scope[input[0].id+'_fileName'] = files[0].name;
                            formCtrl.$setDirty();
                        } else {
                            scope[input[0].id+'_fileName'] = null;
                            formCtrl.$setPristine();
                        }
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msChange', msChangeDirective);

    /** @ngInject */
    function msChangeDirective()
    {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var onChangeHandler = scope.$eval(attrs.msChange);
                element.on('change', onChangeHandler);
                element.on('$destroy', function() {
                    element.off();
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel',
                vm          : '=viewModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation', [])
        .config(config);

    /** @ngInject */
    function config()
    {
        
    }

})();

(function ()
{
    'use strict';

    angular.module('app.navigation')
        .controller('ToastsController', ToastsController);

    function ToastsController($mdToast, data)
    {
        var vm = this;
        // Data
        vm.data = data;

        // Methods
        vm.closeToast = closeToast;

        //////////

        /**
         * Close toast
         */
        function closeToast()
        {
            $mdToast
                .hide()
                .then(function() {
                });
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.user-info', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider, USER_ROLES)
    {
        // State
        $stateProvider
            .state('app.user-info', {
                url    : '/user-info',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/user-info/user-info.html',
                        controller : 'UserinfoController as vm'
                    }
                },
                data: {
                    authorizedRoles: [USER_ROLES.god, USER_ROLES.admin, USER_ROLES.user]
                }
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/user-info');

        // Navigation
        msNavigationServiceProvider.saveItem('user-info', {
            title    : 'User Info',
            icon     : 'icon-account',
            state    : 'app.user-info',
            translate: 'USER-INFO.USER-INFO_NAV',
            weight   : 1
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.user-info')
        .controller('UserinfoController', UserinfoController);

    /** @ngInject */
    function UserinfoController($rootScope, api, session)
    {
        var vm = this;

        // Data
        vm.accountData = [];
        vm.dataLoading = {};
        angular.copy($rootScope.user, vm.accountData);

        // Methods
        vm.changeSettings = changeSettings;

        //////////

        function changeSettings(e) {
            e.preventDefault();
            vm.dataLoading.settings = true;
            var formData = new FormData(document.getElementById('accountForm'));
            formData.append('token', session.data.token);

            api.auth.changeSettings(formData).$promise.then(
                //success
                function(response){
                    if (response.success) {
                        $rootScope.user.name = vm.accountData.name;
                        $rootScope.user.surname = vm.accountData.surname;
                        $rootScope.user.mobile_phone = vm.accountData.mobile_phone;
                        $rootScope.user.home_phone = vm.accountData.home_phone;
                        $rootScope.user.ether_address = vm.accountData.ether_address;

                        api.showToast('success', response.message[0]);
                    } else
                        api.showToast('error', response.message[0]);
                    vm.dataLoading.settings = false;
                },
                //error
                function(response){
                    console.error(response);
                    vm.dataLoading.settings = false;
                }
            );
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.wallet', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider, USER_ROLES)
    {
        // State
        $stateProvider
            .state('app.wallet', {
                url    : '/wallet',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/wallet/wallet.html',
                        controller : 'WalletController as vm'
                    }
                },
                data: {
                    authorizedRoles: [USER_ROLES.god, USER_ROLES.admin, USER_ROLES.user]
                }
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/wallet');

        // Navigation
        msNavigationServiceProvider.saveItem('wallet', {
            title    : 'Wallet',
            icon     : 'icon-cash-multiple',
            state    : 'app.wallet',
            translate: 'WALLET.WALLET_NAV',
            weight   : 2
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.wallet')
        .controller('WalletController', WalletController);

    /** @ngInject */
    function WalletController($rootScope, api, icoConfig, $http)
    {
        var vm = this;

        // Data
        vm.accountData = [];
        vm.dataLoading = {};
        vm.site = icoConfig.getConfig('site');
        angular.copy($rootScope.user, vm.accountData);

        $http.get(api.baseUrl+'/../integration')
            .then(function(response){
                vm.integrationData = response.data.data;
                vm.integrationData.progressBar.goals.unshift({amount: 0, title: 'Token sales start'});
                vm.integrationData.progressBar.goals.sort(function(a, b) {return (a.amount>b.amount)?1:((b.amount>a.amount)?-1:0)});
                vm.integrationData.progressBar.setCurrentGoal = function (num, arr) {
                    vm.integrationData.progressBar.currentGoal = {};

                    for (var i = 0; i < arr.length; i++) {
                        if (num >= arr[i].amount) {
                            vm.integrationData.progressBar.goals[i].passed = true;
                            if(vm.integrationData.progressBar.goals[i-1] && vm.integrationData.progressBar.goals[i-1].current)
                                vm.integrationData.progressBar.goals[i-1].current = false;
                            vm.integrationData.progressBar.goals[i].current = true;

                            vm.integrationData.progressBar.currentGoal.index = i<arr.length-1?i:i-1;
                            vm.integrationData.progressBar.currentGoal.amount = i<arr.length-1?vm.integrationData.progressBar.goals[i].amount:vm.integrationData.progressBar.goals[i-1].amount;
                            vm.integrationData.progressBar.currentGoal.nextGoalAmount = i<arr.length-1?vm.integrationData.progressBar.goals[i+1].amount:vm.integrationData.progressBar.goals[i].amount;
                        }
                    }
                };

                vm.integrationData.progressBar.setCurrentGoal(vm.integrationData.progressBar.totalCoinValue, vm.integrationData.progressBar.goals);
                
                return response.data.data;
            });

        // Methods
        vm.getWalletInfo = getWalletInfo;
        //////////

        function getWalletInfo() {
            api.auth.getAccountData().$promise.then(
                //success
                function(response){
                    if (response.success) {
                        vm.accountData.tokensBalance = response.data.tokensBalance;
                    } else
                        api.showToast('error', response.message[0]);
                    vm.dataLoading.settings = false;
                },
                //error
                function(response){
                    console.error(response);
                    vm.dataLoading.settings = false;
                }
            );

        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.transaction-history',
            [
                // 3rd Party Dependencies
                'nvd3',
                'datatables'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider, USER_ROLES)
    {
        // State
        $stateProvider
            .state('app.transaction-history', {
                url    : '/transaction-history',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/transaction-history/transaction-history.html',
                        controller : 'TransactionhistoryController as vm'
                    }
                },
                data: {
                    authorizedRoles: [USER_ROLES.god, USER_ROLES.admin, USER_ROLES.user]
                }
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/transaction-history');

        // Navigation
        msNavigationServiceProvider.saveItem('transaction-history', {
            title    : 'Transaction History',
            icon     : 'icon-view-list',
            state    : 'app.transaction-history',
            translate: 'TRANSACTION-HISTORY.TRANSACTION-HISTORY_NAV',
            weight   : 5
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.transaction-history')
        .controller('TransactionhistoryController', TransactionhistoryController);

    /** @ngInject */
    function TransactionhistoryController(api)
    {
        var vm = this;

        // Data
        // vm.dtColumns = [
        //     //DTColumnBuilder.newColumn('id').withTitle('ID'),
        //     DTColumnBuilder.newColumn('type').withTitle('Type').withOption('defaultContent', ' '),
        //     DTColumnBuilder.newColumn('date_time_created').withTitle('Date').withOption('defaultContent', ' '),
        //     DTColumnBuilder.newColumn('status').withTitle('Status').withOption('defaultContent', ' '),
        //     DTColumnBuilder.newColumn('amount').withTitle('Amount').withOption('defaultContent', ' ')
        // ];
        vm.dtColumns = [
            {
                defaultContent: "",
                mData: "kind",
                sTitle: "Type",
                render: function(data, type, row){
                    var kinds = {1:'Deposit', 2:'Token Issue', 3: 'Affiliate Reward', 4: 'Airdrop'};
                    return (typeof kinds[row.kind] !== 'undefined')?kinds[row.kind]:row.kind;
                }
            },
            {
                defaultContent: "",
                mData: "date_time_created",
                sTitle: "Date"
            },
            {
                defaultContent: "",
                mData: "status",
                sTitle: "Status",
                render: function(data, type, row){
                    var statuses = {1:'Pending', 2:'Done'};
                    return (typeof statuses[row.status] !== 'undefined')?statuses[row.status]:row.status;
                }
            },
            {
                defaultContent: "",
                mData: "amount",
                sTitle: "Amount"
            }
        ];
        vm.dtInstance = {};
        vm.dtOptions = {
            //dom         : 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            order: [[ 0, "desc" ]],
            columnDefs  : [],
            initComplete: function ()
            {

            },
            language: {
                search: "_INPUT_",
                searchPlaceholder: "Search",
                emptyTable: "No data available"
            },
            pageLength : 10,
            autoWidth: false,
            responsive: true,
            bLengthChange: false,
            processing: true,
            serverSide: true,
            bFilter: false, //remove search
            ajax: {
                url: api.baseUrl+'account/transactions',
                type: 'POST',
                dataSrc: 'data',
                dataFilter: function(data){
                    var json = jQuery.parseJSON(data);
                    if (typeof json.data.data === 'undefined' || json.data.data.length < 1)
                        json.data.data = [];
                    // return JSON string
                    return JSON.stringify(json.data);
                }
            }
        };
        // Methods


        //////////

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.send', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider, USER_ROLES)
    {
        // State
        $stateProvider
            .state('app.send', {
                url    : '/send',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/send/send.html',
                        controller : 'SendController as vm'
                    }
                },
                data: {
                    authorizedRoles: [USER_ROLES.god, USER_ROLES.admin, USER_ROLES.user]
                }
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/send');

        // Navigation
        msNavigationServiceProvider.saveItem('send', {
            title    : 'Send',
            icon     : 'icon-send',
            state    : 'app.send',
            /*stateParams: {
                'param1': 'page'
             },*/
            translate: 'SEND.SEND_NAV',
            weight   : 1
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.send')
        .controller('SendController', SendController);

    /** @ngInject */
    function SendController($rootScope)
    {
        var vm = this;

        // Data
        vm.sendData = $rootScope.user;
        vm.sendData.fullName = vm.sendData.name +' '+ vm.sendData.surname;

        // Methods

        //////////
        
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.support', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider, USER_ROLES)
    {
        // State
        $stateProvider
            .state('app.support', {
                url    : '/support',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/support/support.html',
                        controller : 'SupportController as vm'
                    }
                },
                data: {
                    authorizedRoles: [USER_ROLES.god, USER_ROLES.admin, USER_ROLES.user]
                }
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/support');

        // Navigation
        msNavigationServiceProvider.saveItem('support', {
            title    : 'Contact Us',
            icon     : 'icon-comment-multipe-outline',
            state    : 'app.support',
            /*stateParams: {
                'param1': 'page'
             },*/
            translate: 'SUPPORT.SUPPORT_NAV',
            weight   : 6
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.support')
        .controller('SupportController', SupportController);

    /** @ngInject */
    function SupportController($rootScope, api, session, $resource, $state)
    {
        var vm = this;

        // Data
        vm.supportData = {};
        vm.dataLoading = {};
        angular.copy($rootScope.user, vm.supportData);

        // Methods
        vm.submitMessage = submitMessage;

        //////////

        function submitMessage(e) {
            e.preventDefault();
            vm.dataLoading.submitMessage = true;

            var formData = new FormData(document.getElementById('contactForm'));
            formData.append('token', session.data.token);

            api.support.submitMessage(formData).$promise.then(
                //success
                function(response){
                    if (response.success) {
                        api.showToast('success', response.message[0]);
                        vm.dataLoading.submitMessage = false;
                        vm.supportData.message = "";
                        $state.go('app.wallet');
                    } else {
                        api.showToast('error', response.message[0]);
                        vm.dataLoading.submitMessage = false;
                    }
                },
                //error
                function(response){
                    console.error(response);
                }
            );
        }

        // API resources
        api.support = $resource(null, null, {
            'submitMessage': {
                method          : 'POST',
                url             : api.baseUrl+'support/submit',
                withCredentials : true,
                headers         : {'Content-Type': undefined},
                transformRequest: angular.identity
            }
        });
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.kyc', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, USER_ROLES)
    {
        // State
        $stateProvider
            .state('app.kyc', {
                url    : '/deposit/kyc',
                data: {
                    authorizedRoles: [USER_ROLES.god, USER_ROLES.admin, USER_ROLES.user]
                }
            });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.kyc')
        .controller('KycController', KycController);

    /** @ngInject */
    function KycController($rootScope)
    {
        var vm = this;

        // Data
        vm.kycData = $rootScope.user;

        // Methods

        //////////
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.password-change', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider, USER_ROLES)
    {
        // State
        $stateProvider
            .state('app.password-change', {
                url    : '/password-change',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/password-change/password-change.html',
                        controller : 'PasswordchangeController as vm'
                    }
                },
                data: {
                    authorizedRoles: [USER_ROLES.god, USER_ROLES.admin, USER_ROLES.user]
                }
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/password-change');

        // Navigation
        msNavigationServiceProvider.saveItem('password-change', {
            title    : 'Change Password',
            icon     : 'icon-key-change',
            state    : 'app.password-change',
            translate: 'PASSWORD-CHANGE.PASSWORD-CHANGE_NAV',
            weight   : 3
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.password-change')
        .controller('PasswordchangeController', PasswordchangeController);

    /** @ngInject */
    function PasswordchangeController(session, api)
    {
        var vm = this;

        // Data
        vm.dataLoading = {};

        // Methods
        vm.changePassword = changePassword;

        //////////
        function changePassword(e) {
            e.preventDefault();
            vm.dataLoading.password = true;
            var formData = new FormData(document.getElementById('passwordForm'));
            formData.append('token', session.data.token);

            api.auth.changePassword(formData).$promise.then(
                //success
                function(response){
                    if (response.success) {
                        api.showToast('success', response.message[0]);
                    } else
                        api.showToast('error', response.message[0]);
                    vm.dataLoading.password = false;
                },
                //error
                function(response){
                    console.error(response);
                    vm.dataLoading.password = false;
                }
            );
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.deposit')
        .controller('DepositController', DepositController);

    /** @ngInject */
    function DepositController(DepositData, $mdDialog, $rootScope, api, $resource, session, icoConfig)
    {
        var vm = this;

        // Data
        vm.DepositData = DepositData.data;
        vm.isLoading = false;
        vm.settings = {};
        vm.isEscrowEnabled = false;

        vm.site = icoConfig.getConfig('site');
        vm.srverTimezone = vm.site.timezone;
        vm.serverDate = moment(new Date(DepositData.server_date)).add(moment().utcOffset(vm.srverTimezone)._offset, 'minutes');
        vm.clientDate = moment.utc().add(moment().utcOffset(), 'minutes');
        vm.serverClientDateOffset = vm.clientDate-vm.serverDate;

        console.log('server-client offset (h): ' + vm.serverClientDateOffset/3600000);

        // Methods
        vm.switchCurrency = switchCurrency;
        vm.donationDetails = donationDetails;
        vm.getDuration = getDuration;
        vm.getDaysLeft = getDaysLeft;
        vm.isDateInRange = isDateInRange;
        vm.isDateInPast = isDateInPast;

        //////////

        function switchCurrency(currencyCode) {
            vm.activeTab = currencyCode;
            if(typeof vm.DepositData.currencies[currencyCode].address === "undefined")
                vm.donationDetails(currencyCode);
        }

        function donationDetails(currencyCode) {
            vm.isLoading = true;
            vm.currencyToBuy = vm.DepositData.tokenCode;

            var formData = new FormData();
            formData.append('token', session.data.token);
            formData.append('currency_code', currencyCode);
            formData.append('currency_to_buy', vm.currencyToBuy);

            api.deposit.donationDetails(formData).$promise.then(
                //success
                function(response){
                    if (response.success) {
                        vm.DepositData.currencies[currencyCode].address = response.data.address;
                        vm.DepositData.currencies[currencyCode].rate_per_token = response.data.rate_per_token;
                        vm.isLoading = false;
                    } else {
                        console.error(response.message);
                        vm.isLoading = false;
                    }
                },
                //error
                function(response){
                    console.error(response);
                    vm.isLoading = false;
                }
            );
        }

        function getDuration(startDate, endDate) {
            return ((moment.duration(moment.utc(endDate) - moment.utc(startDate))).humanize());
        }

        function isDateInRange(startDate, endDate) {
            return vm.serverDate.isBetween(moment.utc(startDate), moment.utc(endDate));
        }

        function isDateInPast(endDate) {
            return (vm.serverDate > moment.utc(endDate));
        }

        function getDaysLeft(endDate) {
            return moment(endDate).add(vm.serverClientDateOffset, 'milliseconds').fromNow();
        }

        function showInitialDialog() {
            $mdDialog.show({
                controller         : 'InitialDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/deposit/dialogs/initial/initial-dialog.html',
                //parent             : angular.element('#content-container'),
                fullscreen         : false, // Only for -xs, -sm breakpoints.
                clickOutsideToClose: false,
                escapeToClose      : false,
                onRemoving: function () {
                    vm.isDepositUnavailable = false;
                }
            });
        }

        //Run initial dialog (citizenship confirmation, terms, kyc and eth address)
        if (!$rootScope.user.is_citizenship_allowed || !$rootScope.user.is_terms_accepted || !$rootScope.user.ether_address) {
            vm.isDepositUnavailable = true;
            showInitialDialog();
        }

        // API resources
        api.deposit = $resource(null, null, {
            'donationDetails': {
                method          : 'POST',
                url             : api.baseUrl+'deposit/donation_details',
                withCredentials : true,
                headers         : {'Content-Type': undefined},
                transformRequest: angular.identity
            },
            'getCurrentBonus': {
                method          : 'POST',
                url             : api.baseUrl+'deposit/current_bonus',
                withCredentials : true,
                headers         : {'Content-Type': undefined},
                transformRequest: angular.identity
            }
        });

        //set active tab to default currency
        switchCurrency(DepositData.data.defaultDepositCurrencyCode);

        //Refresh bonuses
        //var bonus_eta = (moment(vm.DepositData.currentBonus.to_date).unix() - moment().unix())*1000 - vm.serverClientDateOffset;

        if(vm.DepositData.bonuses && vm.DepositData.currentBonus) {
            var bonus_eta = moment(vm.DepositData.currentBonus.to_date).add(vm.serverClientDateOffset, 'milliseconds') - moment();

            console.log('bonus ETA (h): '+bonus_eta/3600000);
            if (bonus_eta > 0) {
                var responseCount = 0;
                var refreshBonusTimeout = setTimeout(function(){
                    var refreshBonusInterval = setInterval(function(){
                        api.deposit.getCurrentBonus().$promise.then(
                            //success
                            function(response){
                                if (response.success) {
                                    responseCount++;
                                    if (typeof response.data.currentBonus !== 'undefined' && response.data.currentBonus &&
                                        response.data.currentBonus.id != vm.DepositData.currentBonus.id) {
                                        vm.donationDetails(vm.activeTab);
                                        vm.DepositData.bonuses = response.data.bonuses;
                                        vm.DepositData.currentBonus = response.data.currentBonus;
                                        vm.DepositData.currentBonusFactor = response.data.currentBonusFactor;
                                        bonus_eta = (moment(vm.DepositData.currentBonus.to_date).unix()
                                            - moment().unix())*1000 - vm.serverClientDateOffset;
                                        clearInterval(refreshBonusInterval);
                                    }
                                    if (responseCount > 10)
                                        clearInterval(refreshBonusInterval);
                                } else {
                                    console.error(response.message);
                                    clearInterval(refreshBonusInterval);
                                }
                            },
                            //error
                            function(response){
                                console.error(response);
                                clearInterval(refreshBonusInterval);
                            }
                        );
                    }, 6000);
                }, bonus_eta);
            }
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.affiliate', [
            'datatables'
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider, $translatePartialLoaderProvider, msNavigationServiceProvider, USER_ROLES)
    {
        // State
        $stateProvider
            .state('app.affiliate', {
                url    : '/affiliate',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/affiliate/affiliate.html',
                        controller : 'AffiliateController as vm'
                    }
                },
                data: {
                    authorizedRoles: [USER_ROLES.god, USER_ROLES.admin, USER_ROLES.user]
                },
                resolve  : {
                    AffiliateData: function (msApi)
                    {
                        return msApi.resolve('affiliate@getAffiliateData');
                    }
                },
                bodyClass: 'affiliate'
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/affiliate');

        // Api
        msApiProvider.register('affiliate', ['affiliate', null, {
            'getAffiliateData': {
                method          : 'GET',
                withCredentials : true
            }
        }]);

        // Navigation
        msNavigationServiceProvider.saveItem('affiliate', {
            title    : 'Affiliate',
            icon     : 'icon-account-switch',
            state    : 'app.affiliate',
            translate: 'AFFILIATE.AFFILIATE_NAV',
            hidden   : function () {
                return true;
            },
            weight   : 2
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.affiliate')
        .controller('AffiliateController', AffiliateController);

    /** @ngInject */
    function AffiliateController(AffiliateData, $resource, api, session, DTOptionsBuilder)
    {
        var vm = this;

        // Data
        vm.affiliateFilters = {
            filter: [{
                field: 'kind',
                data: {
                    type: 'numeric',
                    comparison: 'eq',
                    value: '3'
                }
            }]
        };

        vm.affiliateData = {
            "widget5": {
                "ranges": {
                    "W": "Week",
                    "M": "Month",
                    "3M": "3 Months"
                },
                "mainChart": [
                    {
                        "key": "Purchases",
                        "values": {
                            "3M": [
                                {"x": "5.01", "y": 9},
                                {"x": "6.01", "y": 12},
                                {"x": "7.01", "y": 9},
                                {"x": "8.01", "y": 12},
                                {"x": "9.01", "y": 7},
                                {"x": "10.01", "y": 8},
                                {"x": "11.01", "y": 16},
                                {"x": "12.01", "y": 12},
                                {"x": "13.01", "y": 8},
                                {"x": "14.01", "y": 7},
                                {"x": "15.01", "y": 13},
                                {"x": "16.01", "y": 7},
                                {"x": "17.01", "y": 6},
                                {"x": "18.01", "y": 10}
                            ],
                            "M": [
                                {"x": "Mon", "y": 12},
                                {"x": "Tue", "y": 8},
                                {"x": "Wed", "y": 7},
                                {"x": "Thu", "y": 13},
                                {"x": "Fri", "y": 7},
                                {"x": "Sat", "y": 6},
                                {"x": "Sun", "y": 10}
                            ],
                            "W": [
                                {"x": "Mon", "y": 11},
                                {"x": "Tue", "y": 10},
                                {"x": "Wed", "y": 8},
                                {"x": "Thu", "y": 11},
                                {"x": "Fri", "y": 8},
                                {"x": "Sat", "y": 10},
                                {"x": "Sun", "y": 17}
                            ]
                        }
                    },
                    {
                        "key": "Registrations",
                        "values": {
                            "3M": [
                                {"x": "5.01", "y": 37},
                                {"x": "6.01", "y": 32},
                                {"x": "7.01", "y": 39},
                                {"x": "8.01", "y": 27},
                                {"x": "9.01", "y": 18},
                                {"x": "10.01", "y": 24},
                                {"x": "11.01", "y": 20},
                                {"x": "12.01", "y": 37},
                                {"x": "13.01", "y": 32},
                                {"x": "14.01", "y": 39},
                                {"x": "15.01", "y": 27},
                                {"x": "16.01", "y": 18},
                                {"x": "17.01", "y": 24},
                                {"x": "18.01", "y": 20}
                            ],
                            "M": [
                                {"x": "Mon", "y": 37},
                                {"x": "Tue", "y": 24},
                                {"x": "Wed", "y": 51},
                                {"x": "Thu", "y": 31},
                                {"x": "Fri", "y": 29},
                                {"x": "Sat", "y": 17},
                                {"x": "Sun", "y": 31}
                            ],
                            "W": [
                                {"x": "Mon", "y": 42},
                                {"x": "Tue", "y": 28},
                                {"x": "Wed", "y": 43},
                                {"x": "Thu", "y": 34},
                                {"x": "Fri", "y": 20},
                                {"x": "Sat", "y": 25},
                                {"x": "Sun", "y": 22}
                            ]
                        }
                    }
                ],
                "supporting": {
                    "conversion": {
                        "label": "CONVERSION",
                        "count": {
                            "3M": "0.71%",
                            "M": "0.62%",
                            "W": "0.98%"
                        },
                        "chart": {
                            "key": "Conversion",
                            "values": {
                                "3M": [
                                    {"x": 0, "y": 6},
                                    {"x": 1, "y": 3},
                                    {"x": 2, "y": 7},
                                    {"x": 3, "y": 5},
                                    {"x": 4, "y": 5},
                                    {"x": 5, "y": 4},
                                    {"x": 6, "y": 7},
                                    {"x": 7, "y": 6},
                                    {"x": 8, "y": 3},
                                    {"x": 9, "y": 7},
                                    {"x": 10, "y": 5},
                                    {"x": 11, "y": 5},
                                    {"x": 12, "y": 4},
                                    {"x": 13, "y": 7}
                                ],
                                "M": [
                                    {"x": 0, "y": 5},
                                    {"x": 1, "y": 7},
                                    {"x": 2, "y": 8},
                                    {"x": 3, "y": 8},
                                    {"x": 4, "y": 6},
                                    {"x": 5, "y": 4},
                                    {"x": 6, "y": 1}
                                ],
                                "W": [
                                    {"x": 0, "y": 3},
                                    {"x": 1, "y": 2},
                                    {"x": 2, "y": 1},
                                    {"x": 3, "y": 4},
                                    {"x": 4, "y": 8},
                                    {"x": 5, "y": 8},
                                    {"x": 6, "y": 4}
                                ]
                            }
                        }
                    }
                }
            },
            "codes":[
                {
                    "name": "Referral code",
                    "code": "EEB91123",
                    "bonus": "10%",
                    "visits": "0",
                    "registrations": "0",
                    "purchases": "0",
                    "conversion": "0%",
                    "earnings": "0 BTC",
                    "date": "10.01.17 09:16",
                    "status": true
                },
                {
                    "name": "Another referral code",
                    "code": "EEB91123-codename",
                    "bonus": "10%",
                    "visits": "0",
                    "registrations": "0",
                    "purchases": "0",
                    "conversion": "0%",
                    "earnings": "0 BTC",
                    "date": "12.01.17 07:34",
                    "status": false
                }
            ]
        };

        // Widget 5
        vm.widget5 = {
            title       : vm.affiliateData.widget5.title,
            mainChart   : {
                config : {
                    refreshDataOnly: true,
                    deepWatchData  : true
                },
                options: {
                    chart: {
                        type        : 'multiBarChart',
                        color       : ['#039be5', '#b3e5fc'],
                        height      : 360,
                        margin      : {
                            top   : 8,
                            right : 16,
                            bottom: 32,
                            left  : 32
                        },
                        clipEdge    : true,
                        groupSpacing: 0.3,
                        reduceXTicks: false,
                        stacked     : true,
                        duration    : 10,
                        showLegend  : false,
                        x           : function (d)
                        {
                            return d.x;
                        },
                        y           : function (d)
                        {
                            return d.y;
                        },
                        yAxis       : {
                            tickFormat: function (d)
                            {
                                return d;
                            }
                        },
                        legend      : {
                            margin: {
                                top   : 8,
                                bottom: 32
                            }
                        },
                        controls    : {
                            margin: {
                                top   : 8,
                                bottom: 32
                            }
                        },
                        tooltip     : {
                            gravity: 's',
                            classes: 'gravity-s'
                        }
                    }
                },
                data   : []
            },
            supporting  : {
                widgets: {
                    conversion : {
                        data : vm.affiliateData.widget5.supporting.conversion,
                        chart: {
                            data: []
                        }
                    }
                },
                chart  : {
                    config : {
                        refreshDataOnly: true,
                        deepWatchData  : true
                    },
                    options: {
                        chart: {
                            type                   : 'lineChart',
                            color                  : ['#03A9F4'],
                            height                 : 50,
                            margin                 : {
                                top   : 8,
                                right : 0,
                                bottom: 0,
                                left  : 0
                            },
                            isArea                 : true,
                            interpolate            : 'cardinal',
                            clipEdge               : true,
                            showXAxis              : false,
                            showYAxis              : false,
                            showLegend             : false,
                            useInteractiveGuideline: true,
                            x                      : function (d)
                            {
                                return d.x;
                            },
                            y                      : function (d)
                            {
                                return d.y;
                            },
                            yDomain                : [0, 9],
                            xAxis                  : {
                                tickFormat: function (d)
                                {
                                    return vm.widget5.days[d];
                                }
                            },
                            interactiveLayer       : {
                                tooltip: {
                                    gravity: 'e',
                                    classes: 'gravity-e'
                                }
                            }
                        }
                    },
                    data   : []
                }
            },
            days        : ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
            ranges      : vm.affiliateData.widget5.ranges,
            currentRange: '',
            changeRange : function (range)
            {
                vm.widget5.currentRange = range;

                /**
                 * Update main chart data by iterating through the
                 * chart dataset and separately adding every single
                 * dataset by hand.
                 *
                 * You MUST NOT swap the entire data object by doing
                 * something similar to this:
                 * vm.widget.mainChart.data = chartData
                 *
                 * It would be easier but it won't work with the
                 * live updating / animated charts due to how d3
                 * works.
                 *
                 * If you don't need animated / live updating charts,
                 * you can simplify these greatly.
                 */
                angular.forEach(vm.affiliateData.widget5.mainChart, function (chartData, index)
                {
                    vm.widget5.mainChart.data[index] = {
                        key   : chartData.key,
                        values: chartData.values[range]
                    };
                });

                /**
                 * Do the same thing for the supporting widgets but they
                 * only have 1 dataset so we can do [0] without needing to
                 * iterate through in their data arrays
                 */
                angular.forEach(vm.affiliateData.widget5.supporting, function (widget, name)
                {
                    vm.widget5.supporting.widgets[name].chart.data[0] = {
                        key   : widget.chart.key,
                        values: widget.chart.values[range]
                    };
                });
            },
            init        : function ()
            {
                // Run this function once to initialize widget

                /**
                 * Update the range for the first time
                 */
                vm.widget5.changeRange('W');
            }
        };

        //*******************//

        vm.AffiliateData = AffiliateData.data;
        vm.dataLoading = {};

        vm.dtInstance = {};
        vm.dtColumns = [
            {
                defaultContent: "",
                mData: "date_time_created",
                sTitle: "Date"
            },
            {
                defaultContent: "",
                mData: "status",
                sTitle: "Status",
                render: function(data, type, row){
                    var statuses = {1:'Pending', 2:'Done'};
                    return (typeof statuses[row.status] !== 'undefined')?statuses[row.status]:row.status;
                }
            },
            {
                defaultContent: "",
                mData: "amount + currency_code",
                sTitle: "Amount",
                render: function(data, type, row){
                    return row.amount + ' ' + row.currency_code;
                }
            },
            {
                defaultContent: "",
                mData: "subid",
                sTitle: "SubId"
            }
        ];

        vm.dtOptions = {
            dom         : 'lrtip',
            order: [[ 0, "desc" ]],
            columnDefs  : [],
            initComplete: function ()
            {

            },
            language: {
                search: "_INPUT_",
                searchPlaceholder: "Search",
                emptyTable: "No data available"
            },
            pageLength : 10,
            autoWidth: false,
            responsive: true,
            bLengthChange: false,
            processing: true,
            serverSide: true,
            //bFilter: false, //remove search
            ajax: {
                url: api.baseUrl+'account/transactions',
                type: 'POST',
                dataSrc: 'data',
                data : vm.affiliateFilters,
                dataFilter: function(data){
                    var json = jQuery.parseJSON(data);
                    if (typeof json.data.data === 'undefined' || json.data.data.length < 1)
                        json.data.data = [];
                    // return JSON string
                    return JSON.stringify(json.data);
                }
            }
        };

        // Methods

        vm.showToast = api.showToast;
        vm.setSubId = setSubId;

        //////////

        function setSubId(e) {
            e.preventDefault();
            vm.dataLoading.subId = true;
            var formData = new FormData(document.getElementById('subIdForm'));
            formData.append('token', session.data.token);

            api.affiliate.setSubId(formData).$promise.then(
                //success
                function(response){
                    if (response.success) {
                        vm.dataLoading.subId = false;
                        api.showToast('success', response.message[0]);
                    } else {
                        vm.dataLoading.subId = false;
                        api.showToast('error', response.message[0]);
                    }
                },
                //error
                function(response){
                    console.error(response);
                }
            );
        }

        // Initialize Widget 5
        vm.widget5.init();

        // API resources
        api.affiliate = $resource(null, null, {
            'setSubId': {
                method          : 'POST',
                url             : api.baseUrl+'affiliate/',
                withCredentials : true,
                headers         : {'Content-Type': undefined},
                transformRequest: angular.identity
            }
        });
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('icoTheming', icoThemingService);

    /** @ngInject */
    function icoThemingService($cookies, $log, $mdTheming)
    {
        var service = {
            getRegisteredPalettes: getRegisteredPalettes,
            getRegisteredThemes  : getRegisteredThemes,
            setActiveTheme       : setActiveTheme,
            setThemesList        : setThemesList,
            themes               : {
                list  : {},
                active: {
                    'name' : '',
                    'theme': {}
                }
            }
        };

        return service;

        //////////

        /**
         * Get registered palettes
         *
         * @returns {*}
         */
        function getRegisteredPalettes()
        {
            return $mdTheming.PALETTES;
        }

        /**
         * Get registered themes
         *
         * @returns {*}
         */
        function getRegisteredThemes()
        {
            return $mdTheming.THEMES;
        }

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // If theme does not exist, fallback to the default theme
            if ( angular.isUndefined(service.themes.list[themeName]) )
            {
                // If there is no theme called "default"...
                if ( angular.isUndefined(service.themes.list.default) )
                {
                    $log.error('You must have at least one theme named "default"');
                    return;
                }

                $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                // Otherwise set theme to default theme
                service.themes.active.name = 'default';
                service.themes.active.theme = service.themes.list.default;
                $cookies.put('selectedTheme', service.themes.active.name);

                return;
            }

            service.themes.active.name = themeName;
            service.themes.active.theme = service.themes.list[themeName];
            $cookies.put('selectedTheme', themeName);
        }

        /**
         * Set available themes list
         *
         * @param themeList
         */
        function setThemesList(themeList)
        {
            service.themes.list = themeList;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider, icoPalettes, icoThemes)
    {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if ( customTheme )
        {
            icoThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(false);

        // Define custom palettes
        angular.forEach(icoPalettes, function (palette)
        {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(icoThemes, function (theme, themeName)
        {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });
    }

})();
(function ()
{
    'use strict';

    var icoThemes = {
        default  : {
            primary   : {
                name: 'grey',
                hues: {
                    'default': '900',
                    'hue-1'  : '500',
                    'hue-2'  : '600',
                    'hue-3'  : '400'
                }
            },
            accent    : {
                name: 'light-blue',
                hues: {
                    'default': '600',
                    'hue-1'  : '400',
                    'hue-2'  : '700',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'red'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'pinkTheme': {
            primary   : {
                name: 'blue-grey',
                hues: {
                    'default': '800',
                    'hue-1'  : '600',
                    'hue-2'  : '400',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'pink',
                hues: {
                    'default': '400',
                    'hue-1'  : '300',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'blue'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'tealTheme': {
            primary   : {
                name: 'ico-blue',
                hues: {
                    'default': '900',
                    'hue-1'  : '600',
                    'hue-2'  : '500',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'teal',
                hues: {
                    'default': '500',
                    'hue-1'  : '400',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'deep-orange'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        }
    };

    angular
        .module('app.core')
        .constant('icoThemes', icoThemes);
})();
(function () {
    'use strict';

    var icoPalettes = [
        {
            name: 'ico-blue',
            options: {
                '50': '#ebf1fa',
                '100': '#c2d4ef',
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#3470ca',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'ico-paleblue',
            options: {
                '50': '#ececee',
                '100': '#c5c6cb',
                '200': '#9ea1a9',
                '300': '#7d818c',
                '400': '#5c616f',
                '500': '#3c4252',
                '600': '#353a48',
                '700': '#2d323e',
                '800': '#262933',
                '900': '#1e2129',
                'A100': '#c5c6cb',
                'A200': '#9ea1a9',
                'A400': '#5c616f',
                'A700': '#2d323e',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        }
    ];

    angular
        .module('app.core')
        .constant('icoPalettes', icoPalettes);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('icoGenerator', icoGeneratorService);

    /** @ngInject */
    function icoGeneratorService($cookies, $log, icoTheming)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            // Get registered themes and palettes and copy
            // them so we don't modify the original objects
            var registeredThemes = angular.copy(icoTheming.getRegisteredThemes());
            var registeredPalettes = angular.copy(icoTheming.getRegisteredPalettes());

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            icoTheming.setThemesList(themes);

            // Remember selected theme.
            var selectedTheme = $cookies.get('selectedTheme');

            if ( selectedTheme )
            {
                icoTheming.setActiveTheme(selectedTheme);
            }
            else
            {
                icoTheming.setActiveTheme('default');
            }
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '/* Content hack because they wont fix */\n/* https://github.com/angular/material/pull/8067 */\n[md-theme="@themeName"] md-content.md-hue-1,\nmd-content.md-@themeName-theme.md-hue-1 {\n    color: @backgroundHue1Contrast1;\n    background-color: @backgroundHue1Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-2,\nmd-content.md-@themeName-theme.md-hue-2 {\n    color: @backgroundHue2Contrast1;\n    background-color: @backgroundHue2Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-3,\n md-content.md-@themeName-theme.md-hue-3 {\n    color: @backgroundHue3Contrast1;\n    background-color: @backgroundHue3Color;\n}\n\n/* Text Colors */\n[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if ( color.length === 3 )
            {
                return 'rgb(' + color.join(',') + ')';
            }
            else if ( color.length === 4 )
            {
                return 'rgba(' + color.join(',') + ')';
            }
            else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0 && color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.activate-2fa')
        .controller('Activate2faController', Activate2faController);

    /** @ngInject */
    function Activate2faController($rootScope, $mdDialog, api, session)
    {
        var vm = this;

        // Data
        vm.activate2faData = [];
        vm.dataLoading = {};
        vm.gaData = [];
        angular.copy($rootScope.user, vm.activate2faData);

        // Methods
        vm.changeSettings = changeSettings;
        vm.showTwoFactorAuthDialog = showTwoFactorAuthDialog;

        //////////

        function changeSettings(e) {
            e.preventDefault();
            vm.dataLoading.settings = true;
            var formData = new FormData(document.getElementById('activate2faForm'));
            formData.append('token', session.data.token);
            formData.append('two_factor_auth', vm.activate2faData.two_factor_auth); // md-checkbox component is not a standard html checkbox, need to append its value

            api.auth.activate2fa(formData).$promise.then(
                //success
                function(response){
                    if (response.success) {
                        $rootScope.user.two_factor_auth = vm.activate2faData.two_factor_auth;

                        api.showToast('success', response.message[0]);
                    } else
                        api.showToast('error', response.message[0]);
                    vm.dataLoading.settings = false;
                },
                //error
                function(response){
                    console.error(response);
                    vm.dataLoading.settings = false;
                }
            );
        }

        // Two factor auth dialog
        function showTwoFactorAuthDialog(e) {
            e.preventDefault();
            if (!$rootScope.user.two_factor_auth && !vm.activate2faData.two_factor_auth)
                $mdDialog.show({
                    controller         : 'TwoFactorAuthDialogController',
                    controllerAs       : 'vm',
                    templateUrl        : 'app/main/activate-2fa/dialogs/two-factor-auth/two-factor-auth-dialog.html',
                    parent             : angular.element('#content-container'),
                    fullscreen         : true, // Only for -xs, -sm breakpoints.
                    clickOutsideToClose: true,
                    escapeToClose      : true,
                    locals             : {
                        gaData         : vm.gaData
                    },
                    onRemoving         : function(){
                        vm.activate2faData.two_factor_auth = vm.gaData.isVerified;
                    }
                });
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsThemeOptionsController', MsThemeOptionsController)
        .directive('msThemeOptions', msThemeOptions);

    /** @ngInject */
    function MsThemeOptionsController($cookies, icoTheming)
    {
        var vm = this;

        // Data
        vm.themes = icoTheming.themes;

        vm.layoutModes = [
            {
                label: 'Boxed',
                value: 'boxed'
            },
            {
                label: 'Wide',
                value: 'wide'
            }
        ];
        vm.layoutStyles = [
            {
                label : 'Vertical Navigation',
                value : 'verticalNavigation',
                figure: '/assets/images/theme-options/vertical-nav.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar',
                value : 'verticalNavigationFullwidthToolbar',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar 2',
                value : 'verticalNavigationFullwidthToolbar2',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar-2.jpg'
            },
            {
                label : 'Horizontal Navigation',
                value : 'horizontalNavigation',
                figure: '/assets/images/theme-options/horizontal-nav.jpg'
            },
            {
                label : 'Content with Toolbar',
                value : 'contentWithToolbar',
                figure: '/assets/images/theme-options/content-with-toolbar.jpg'
            },
            {
                label : 'Content Only',
                value : 'contentOnly',
                figure: '/assets/images/theme-options/content-only.jpg'
            },
        ];

        vm.layoutMode = 'wide';
        vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        // Methods
        vm.setActiveTheme = setActiveTheme;
        vm.getActiveTheme = getActiveTheme;
        vm.updateLayoutMode = updateLayoutMode;
        vm.updateLayoutStyle = updateLayoutStyle;

        //////////

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            icoTheming.setActiveTheme(themeName);
        }

        /**
         * Get active theme
         *
         * @returns {service.themes.active|{name, theme}}
         */
        function getActiveTheme()
        {
            return icoTheming.themes.active;
        }

        /**
         * Update layout mode
         */
        function updateLayoutMode()
        {
            var bodyEl = angular.element('body');

            // Update class on body element
            bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
        }

        /**
         * Update layout style
         */
        function updateLayoutStyle()
        {
            // Update the cookie
            $cookies.put('layoutStyle', vm.layoutStyle);

            // Reload the page to apply the changes
            location.reload();
        }
    }

    /** @ngInject */
    function msThemeOptions($mdSidenav)
    {
        return {
            restrict   : 'E',
            scope      : {},
            controller : 'MsThemeOptionsController as vm',
            templateUrl: 'app/core/theme-options/theme-options.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-theme-options');

                return function postLink(scope)
                {
                    /**
                     * Toggle options sidenav
                     */
                    function toggleOptionsSidenav()
                    {
                        // Toggle the ico theme options panel
                        $mdSidenav('ico-theme-options').toggle();
                    }

                    // Expose the toggle function
                    scope.toggleOptionsSidenav = toggleOptionsSidenav;
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
                var match = tags.every(function (tag)
                {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag)
                    {
                        if ( itemTag.name === tag.name )
                        {
                            tagExists = true;
                            return;
                        }
                    });

                    return tagExists;
                });

                if ( match )
                {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByPropIds', filterByPropIds);

    /** @ngInject */
    function filterByPropIds()
    {
        return function (items, parameter, ids)
        {
            if ( items.length === 0 || !ids || ids.length === 0 )
            {
                return items;
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item[parameter].indexOf(id) > -1 )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByIds', filterByIds);

    /** @ngInject */
    function filterByIds()
    {
        return function (items, ids)
        {

            if ( items.length === 0 || !ids )
            {
                return items;
            }

            if ( ids.length === 0 )
            {
                return [];
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item.id === id )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter);

    /** @ngInject */
    function toTrustedFilter($sce)
    {
        return function (value)
        {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter()
    {
        return function (text)
        {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter()
    {
        return function (value)
        {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter()
    {
        return function (doc)
        {
            if ( !doc )
            {
                return;
            }
            if ( doc.type === 'directive' )
            {
                return doc.name.replace(/([A-Z])/g, function ($1)
                {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('altDate', altDate);

    /** @ngInject */
    function altDate()
    {
        return function (value)
        {
            var diff = Date.now() - new Date(value);

            /**
             * If in a hour
             * e.g. "2 minutes ago"
             */
            if ( diff < (60 * 60 * 1000) )
            {
                return moment(value).fromNow();
            }
            /*
             * If in the day
             * e.g. "11:23"
             */
            else if ( diff < (60 * 60 * 24 * 1000) )
            {
                return moment(value).format('HH:mm');
            }
            /*
             * If in week
             * e.g "Tuesday"
             */
            else if ( diff < (60 * 60 * 24 * 7 * 1000) )
            {
                return moment(value).format('dddd');
            }
            /*
             * If more than a week
             * e.g. 03/29/2016
             */
            else
            {
                return moment(value).calendar();
            }

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('session', session);

    /** @ngInject */
    function session($rootScope)
    {

        var service = this;

        //Data
        service.user = {};
        // Methods
        service.create = create;
        service.setData = setData;
        service.destroy = destroy;
        
        return service;

        //////////

        function create(user)
        {
            service.user = user;
            $rootScope.user = user;
        }

        function setData(data)
        {
            service.data = data;
        }

        function destroy()
        {
            service.user = {role:0};
            $rootScope.user = {role:0};
        }


    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('ngCopy', ['$window', ngCopy]);

    /** @ngInject */
    function ngCopy($window)
    {
        var body = angular.element($window.document.body);
        var textarea = angular.element('<textarea/>');
        textarea.css({
            position: 'fixed',
            opacity: '0'
        });

        return function (toCopy) {
            textarea.val(toCopy);
            body.append(textarea);
            textarea[0].select();

            try {
                var successful = document.execCommand('copy');
                if (!successful) throw successful;
            } catch (err) {
                window.prompt("Copy to clipboard: Ctrl+C, Enter", toCopy);
            }

            textarea.remove();
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window)
    {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists       : exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile     : isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list)
        {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser()
        {
            // If we already tested, do not test again
            if ( browserInfo )
            {
                return browserInfo;
            }

            var browserData = [
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Edge',
                    versionSearch: 'Edge',
                    identity     : 'Edge'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Chrome',
                    identity : 'Chrome'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'OmniWeb',
                    versionSearch: 'OmniWeb/',
                    identity     : 'OmniWeb'
                },
                {
                    string       : $window.navigator.vendor,
                    subString    : 'Apple',
                    versionSearch: 'Version',
                    identity     : 'Safari'
                },
                {
                    prop    : $window.opera,
                    identity: 'Opera'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'iCab',
                    identity : 'iCab'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'KDE',
                    identity : 'Konqueror'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Firefox',
                    identity : 'Firefox'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'Camino',
                    identity : 'Camino'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Netscape',
                    identity : 'Netscape'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'MSIE',
                    identity     : 'Explorer',
                    versionSearch: 'MSIE'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Trident/7',
                    identity     : 'Explorer',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Gecko',
                    identity     : 'Mozilla',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Mozilla',
                    identity     : 'Netscape',
                    versionSearch: 'Mozilla'
                }
            ];

            var osData = [
                {
                    string   : $window.navigator.platform,
                    subString: 'Win',
                    identity : 'Windows'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Mac',
                    identity : 'Mac'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Linux',
                    identity : 'Linux'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPhone',
                    identity : 'iPhone'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPod',
                    identity : 'iPod'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPad',
                    identity : 'iPad'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Android',
                    identity : 'Android'
                }
            ];

            var versionSearchString = '';

            function searchString(data)
            {
                for ( var i = 0; i < data.length; i++ )
                {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if ( dataString )
                    {
                        if ( dataString.indexOf(data[i].subString) !== -1 )
                        {
                            return data[i].identity;

                        }
                    }
                    else if ( dataProp )
                    {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString)
            {
                var index = dataString.indexOf(versionSearchString);

                if ( index === -1 )
                {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || 'unknown-browser';
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
            var os = searchString(osData) || 'unknown-os';

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os     : os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator()
        {
            var S4 = function ()
            {
                return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile()
        {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array)
        {
            if ( array.indexOf(item) === -1 )
            {
                array.push(item);
            }
            else
            {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msApi', msApiProvider);

    /** @ngInject **/
    function msApiProvider()
    {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject the $log service
        var $log = angular.injector(['ng']).get('$log');

        // Data
        var baseUrl = '';
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url)
        {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl()
        {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject()
        {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource)
        {
            if ( !angular.isString(key) )
            {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if ( !angular.isArray(resource) )
            {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Store the API object
            api[key] = {
                url          : baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions      : resource[2] || [],
                options      : resource[3] || {}
            };
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($log, $q, $resource, $rootScope)
        {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register  : register,
                resolve   : resolve,
                request   : request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::resolveStart');

                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(baseUrl + apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // Success
                        function (response)
                        {
                            deferred.resolve(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveSuccess');
                        },

                        // Error
                        function (response)
                        {
                            deferred.reject(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveError');
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::requestStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(baseUrl + apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // SUCCESS
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestSuccess');
                            
                            // Resolve the promise
                            deferred.resolve(response);

                            // Call the success function if there is one
                            if ( angular.isDefined(success) && angular.isFunction(success) )
                            {
                                success(response);
                            }
                        },

                        // ERROR
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestError');
                            
                            // Reject the promise
                            deferred.reject(response);

                            // Call the error function if there is one
                            if ( angular.isDefined(error) && angular.isFunction(error) )
                            {
                                error(response);
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('auth', auth);

    /** @ngInject */
    function auth($resource, session, api)
    {
        // Private variables
        var service = {
            isAuthenticated         : isAuthenticated,
            isAuthorized            : isAuthorized
        };

        //Data
        var baseUrl = api.baseUrl;

        api.auth = $resource(null, null, {
            'login': {
                method          : 'POST',
                url             : baseUrl+'account/login',
                withCredentials : true,
                headers         : { 'Content-Type': undefined},
                transformRequest: angular.identity
            },
            'logout': {
                method          : 'GET',
                url             : baseUrl+'account/logout',
                withCredentials : true
            },
            'signup': {
                method          : 'POST',
                url             : baseUrl+'account/signup',
                withCredentials : true,
                headers         : { 'Content-Type': undefined},
                transformRequest: angular.identity
            },
            'changePassword': {
                method          : 'POST',
                url             : baseUrl+'account/change_password',
                withCredentials : true,
                headers         : { 'Content-Type': undefined},
                transformRequest: angular.identity
            },
            'activate2fa': {
                method          : 'POST',
                url             : baseUrl+'account/activate_2fa',
                withCredentials : true,
                headers         : { 'Content-Type': undefined},
                transformRequest: angular.identity
            },
            'changeSettings': {
                method          : 'POST',
                url             : baseUrl+'account/change_settings',
                withCredentials : true,
                headers         : { 'Content-Type': undefined},
                transformRequest: angular.identity
            },
            'getAccountData': {
                method          : 'GET',
                url             : baseUrl+'account',
                withCredentials : true
            },
            'getGoogleAuthData': {
                method          : 'GET',
                url             : baseUrl+'account/google_auth_data',
                withCredentials : true
            },
            'verifyGoogleAuthCode': {
                method          : 'POST',
                url             : baseUrl+'account/verify_google_auth_code',
                withCredentials : true,
                headers         : { 'Content-Type': undefined},
                transformRequest: angular.identity
            }
        });
        
        return service;

        //////////

        /**
         * Checks if user is authenticated
         *
         * @returns (boolean)
         */
        function isAuthenticated()
        {
            return session.user?!!session.user.userId:false;
        }

        /**
         * Checks if user is authorized
         *
         * @param authorizedRoles
         * @returns (boolean)
         */

        function isAuthorized(authorizedRoles)
        {
            if (!angular.isArray(authorizedRoles))
                authorizedRoles = [authorizedRoles];
            return session.user?(authorizedRoles.indexOf(session.user.role) !== -1):false;
        }
    }
}());

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('authResolver', authResolverService);

    /** @ngInject */
    function authResolverService($q, $rootScope)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve auth
         */
        function resolve()
        {
            var deferred = $q.defer();
            var unwatch = $rootScope.$watch('user', function (user) {
                if (angular.isDefined(user)) {
                    if (user) {
                        deferred.resolve(user);
                    } else {
                        deferred.reject();
                    }
                    unwatch();
                }
            });
            
            //return the promise
            return deferred.promise;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('authInterceptor', authInterceptor);

    /** @ngInject **/
    function authInterceptor($rootScope, $q, AUTH_EVENTS)
    {
        return {
            responseError: function (response) {
                $rootScope.$broadcast({
                    401: AUTH_EVENTS.sessionTimeout,
                    403: AUTH_EVENTS.notAuthorized,
                    419: AUTH_EVENTS.sessionTimeout,
                    440: AUTH_EVENTS.sessionTimeout
                }[response.status], response);
                return $q.reject(response);
            }
        };

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiInterceptor', apiInterceptor);

    /** @ngInject **/
    function apiInterceptor($rootScope, $q, API_EVENTS)
    {
        return {
            responseError: function (response) {
                $rootScope.$broadcast(API_EVENTS.error, response);
                return $q.reject(response);
            }
        };

    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate) {
        return {
            restrict: 'E',
            compile : function (element, attr) {
                var code;
                //No attribute? code is the content
                if (!attr.code) {
                    code = element.html();
                    element.empty();
                }

                return function (scope, element, attr) {

                    if (attr.code) {
                        // Attribute? code is the evaluation
                        code = scope.$eval(attr.code);
                    }
                    var shouldInterpolate = scope.$eval(attr.shouldInterpolate);

                    $q.when(code).then(function (code) {
                        if (code) {
                            if (shouldInterpolate) {
                                code = $interpolate(code)(scope);
                            }
                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );
                            element.append(contentParent);
                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function () {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent) {

                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line) {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);
                        lines = lines.map(function (line) {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(attr.language || attr.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
    (function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('icoConfig', icoConfigProvider);

    /** @ngInject */
    function icoConfigProvider()
    {
        // Default configuration
        var icoConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true,
            'site'                           : {
                'name'                       : 'CEEK',
                'htmlName'                   : '<b>CEEK</b>',
                'shortName'                  : 'Ck',
                'tokenName'                  : 'CEEK',
                'tokenCode'                  : 'CEEK'
            },
            'recaptcha'                      : {
                'theme'                      : 'light',
                'key'                        : '6LdfCE8UAAAAAPCx5BeT6T-MV1_5POadBHkEXNkj'
            }
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            icoConfiguration = angular.extend({}, icoConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(icoConfiguration[configName]) )
                {
                    return false;
                }

                return icoConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                icoConfiguration[configName] = configValue;
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.toolbar', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/toolbar');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.toolbar')
        .controller('ToolbarController', ToolbarController);

    /** @ngInject */
    function ToolbarController($rootScope, $q, $state, $timeout, $mdSidenav, $mdDialog, $translate, msNavigationService, api, AUTH_EVENTS)
    {
        var vm = this;

        // Data
        $rootScope.global = {
            search: ''
        };

        vm.bodyEl = angular.element('body');

        vm.userStatusOptions = [
            {
                'title': 'Online',
                'icon' : 'icon-checkbox-marked-circle',
                'color': '#4CAF50'
            },
            {
                'title': 'Away',
                'icon' : 'icon-clock',
                'color': '#FFC107'
            },
            {
                'title': 'Do not Disturb',
                'icon' : 'icon-minus-circle',
                'color': '#F44336'
            },
            {
                'title': 'Invisible',
                'icon' : 'icon-checkbox-blank-circle-outline',
                'color': '#BDBDBD'
            },
            {
                'title': 'Offline',
                'icon' : 'icon-checkbox-blank-circle-outline',
                'color': '#616161'
            }
        ];
        vm.languages = {
            en: {
                'title'      : 'English',
                'translation': 'TOOLBAR.ENGLISH',
                'code'       : 'en',
                'flag'       : 'us'
            },
            es: {
                'title'      : 'Spanish',
                'translation': 'TOOLBAR.SPANISH',
                'code'       : 'es',
                'flag'       : 'es'
            },
            tr: {
                'title'      : 'Turkish',
                'translation': 'TOOLBAR.TURKISH',
                'code'       : 'tr',
                'flag'       : 'tr'
            }
        };
        vm.kycStatuses = {"0":"Not Provided", "1":"In Progress", "2":"Action Required", "3":"Approved", "4":"Declined"};
        vm.kycStatusBadges = {"0":"orange", "1":"blue", "2":"orange", "3":"green", "4":"red"};

        // Methods
        vm.showKycDialog = showKycDialog;
        vm.logout = logout;
        vm.toggleSidenav = toggleSidenav;
        vm.changeLanguage = changeLanguage;
        vm.setUserStatus = setUserStatus;
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;
        vm.search = search;
        vm.searchResultClick = searchResultClick;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Select the first status as a default
            vm.userStatus = vm.userStatusOptions[0];

            // Get the selected language directly from angular-translate module setting
            vm.selectedLanguage = vm.languages[$translate.preferredLanguage()];

            //show kyc dialog
            if (typeof $state.params !== 'undefined' && $state.params.param == 'kyc')
                showKycDialog();
        }

        /**
         * Show KYC dialog
         */

        function showKycDialog() {
            //if kyc not submitted
            if ($rootScope.user.show_kyc)
                $mdDialog.show({
                    controller         : 'KycDialogController',
                    controllerAs       : 'vm',
                    templateUrl        : 'app/toolbar/dialogs/kyc/kyc-dialog.html',
                    //parent             : angular.element('#content-container'),
                    fullscreen         : true, // Only for -xs, -sm breakpoints.
                    clickOutsideToClose: true,
                    escapeToClose      : true
                });
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Sets User Status
         * @param status
         */
        function setUserStatus(status)
        {
            vm.userStatus = status;
        }

        /**
         * Logout Function
         */
        function logout()
        {
            api.auth.logout().$promise.then(
                //success
                function(){
                    $rootScope.$broadcast(AUTH_EVENTS.logoutSuccess);
                },
                //error
                function(response){
                    console.error(response);
                }
            );
            
        }

        /**
         * Change Language
         */
        function changeLanguage(lang)
        {
            vm.selectedLanguage = lang;

            // Change the language
            $translate.use(lang.code);
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }

        /**
         * Toggle msNavigation folded
         */
        function toggleMsNavigationFolded()
        {
            msNavigationService.toggleFolded();
        }

        /**
         * Search action
         *
         * @param query
         * @returns {Promise}
         */
        function search(query)
        {
            var navigation = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    navigation.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the navigation;
            // otherwise we will return the entire navigation
            // list. Not exactly a good thing to do but it's
            // for demo purposes.
            if ( query )
            {
                navigation = navigation.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(query)) > -1 )
                    {
                        return true;
                    }
                });
            }

            // Fake service delay
            $timeout(function ()
            {
                deferred.resolve(navigation);
            }, 1000);

            return deferred.promise;
        }

        /**
         * Search result click action
         *
         * @param item
         */
        function searchResultClick(item)
        {
            // If item has a link
            if ( item.uisref )
            {
                // If there are state params,
                // use them...
                if ( item.stateParams )
                {
                    $state.go(item.state, item.stateParams);
                }
                else
                {
                    $state.go(item.state);
                }
            }
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation')
        .controller('NavigationController', NavigationController);

    /** @ngInject */
    function NavigationController($scope)
    {
        var vm = this;

        // Data
        vm.bodyEl = angular.element('body');
        vm.folded = false;
        vm.msScrollOptions = {
            suppressScrollX: true
        };

        // Methods
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;
        //////////

        /**
         * Toggle folded status
         */
        function toggleMsNavigationFolded()
        {
            vm.folded = !vm.folded;
        }

        // Close the mobile menu on $stateChangeSuccess
        $scope.$on('$stateChangeSuccess', function ()
        {
            vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active');
        });
    }
})();
(function ()
{
    'use strict';

    /**
     * Main module of the Ico
     */
    angular
        .module('ico', [

            // Core
            'app.core',

            // Navigation
            'app.navigation',

            // Toolbar
            'app.toolbar',

            // Deposit
            'app.deposit',

            // user-info
            'app.user-info',

            // user-info
            'app.wallet',

            // Affiliate
            'app.affiliate',

            // password-change
            'app.password-change',

            // activate-2fa
            'app.activate-2fa',

            // password-change
            'app.transaction-history',

            // documents
            'app.documents',

            // news-channel
            'app.social-channels',

            // Account
            //'app.account',

            // Support
            'app.support',
            
            // Authentication
            'app.auth.login',
            'app.auth.register',
            'app.auth.forgot-password',
            'app.auth.reset-password'
        ]);
})();
(function ()
{
    'use strict';

    angular
        .module('ico')
        .controller('MainController', MainController);

    /** @ngInject */
    function MainController($scope, $rootScope)
    {
        // Data

        //////////

        // Remove the splash screen
        $scope.$on('$viewContentAnimationEnded', function (event)
        {
            if ( event.targetScope.$id === $scope.$id )
            {
                $rootScope.$broadcast('msSplashScreen::remove');
            }
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, icoGenerator, icoConfig)
    {
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        icoGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( icoConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .constant('AUTH_EVENTS', {
            loginSuccess : 'auth-login-success',
            loginFailed : 'auth-login-failed',
            logoutSuccess : 'auth-logout-success',
            sessionTimeout : 'auth-session-timeout',
            notAuthenticated : 'auth-not-authenticated',
            notAuthorized : 'auth-not-authorized'
        })
        .constant('API_EVENTS', {
            error: 'api-error'
        })
        .constant('USER_ROLES', {
            all: "*",
            god: 30,
            admin: 20,
            user: 10,
            guest: 0
        })
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($ariaProvider, $logProvider, msScrollConfigProvider, icoConfigProvider, $compileProvider, $httpProvider)
    {

        // Enable debug logging
        $logProvider.debugEnabled(true);

        /*eslint-disable */

        $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|btc|bitcoin|eth|ether|ethereum|ltc|litecoin|dash):/);

        // http interceptors
        $httpProvider.interceptors.push('authInterceptor');
        $httpProvider.interceptors.push('apiInterceptor');

        // ng-aria configuration
        $ariaProvider.config({
            tabindex: false
        });

        // Ico theme configurations
        icoConfigProvider.config({
            'disableCustomScrollbars'        : false,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile'     : true
        });

        // msScroll configuration
        msScrollConfigProvider.config({
            wheelPropagation: true
        });

        /*eslint-enable */
    }
})();
(function ()
{
    'use strict';

    angular
        .module('ico')
        .run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, $timeout, $state, $window, $mdDialog, api, session, auth, AUTH_EVENTS, API_EVENTS)
    {
        var toState = {},
            fromState = {};

        // Activate loading indicator
        var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function (event, currentState, stateParams, previousState)
        {
            if (currentState.external) {
                event.preventDefault();
                $window.open(currentState.url, currentState.blank?'_blank':'_self');
            } else {
                toState = currentState;
                toState.params = stateParams;
                fromState = previousState;

                var authorizedRoles = currentState.data.authorizedRoles;

                if (!auth.isAuthorized(authorizedRoles) ||
                    (angular.isDefined(session.data) && !session.data.signup_enabled && toState.name == 'app.register')) {
                    event.preventDefault();
                    if (angular.isDefined(session.user) && angular.isDefined(session.user.role)){
                        if (auth.isAuthenticated()) {
                            //user is not allowed
                            $rootScope.$broadcast(AUTH_EVENTS.notAuthorized);
                        } else {
                            //user is not logged in
                            $rootScope.$broadcast(AUTH_EVENTS.notAuthenticated);
                        }
                    }
                } else {
                    $mdDialog.cancel();
                    $rootScope.loadingProgress = true;
                }
            }
        });

        //Get user data
        api.auth.getAccountData().$promise.then(
            //success
            function(response){
                if (response.success){
                    session.setData(response.data);
                    if (angular.isDefined(response.data.userId)){
                        response.data.toState = toState;
                        $rootScope.$broadcast(AUTH_EVENTS.loginSuccess, response.data);
                    } else
                        $rootScope.$broadcast(AUTH_EVENTS.notAuthenticated, toState);
                } else {
                    $rootScope.$broadcast(API_EVENTS.error, {status:'Can\'t get session data'});
                }
            },
            //error
            function(response){
                console.error(response);
            }
        );

        // De-activate loading indicator
        var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
        {
            $timeout(function ()
            {
                $rootScope.loadingProgress = false;
            });
        });

        // Store state in the root scope for easy access
        $rootScope.state = $state;

        // Cleanup
        $rootScope.$on('$destroy', function ()
        {
            stateChangeStartEvent();
            stateChangeSuccessEvent();
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('ico')
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider, $locationProvider)
    {
        $locationProvider.html5Mode(true);

        //$urlRouterProvider.otherwise('/deposit/');
        $urlRouterProvider.otherwise(function($injector) {
            var $state = $injector.get("$state");
            $state.go("app.register");
        });

        /**
         * Layout Style Switcher
         *
         * This code is here for demonstration purposes.
         * If you don't need to switch between the layout
         * styles like in the demo, you can set one manually by
         * typing the template urls into the `State definitions`
         * area and remove this code
         */
        // Inject $cookies
        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Get active layout
        var layoutStyle = 'verticalNavigationFullwidthToolbar2';

        var layouts = {
            verticalNavigationFullwidthToolbar2  : {
                main      : 'app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html'
            }
        };
        // END - Layout Style Switcher

        // State definitions
        $stateProvider
            .state('app', {
                abstract: true,
                views   : {
                    'main@'         : {
                        templateUrl: layouts[layoutStyle].main,
                        controller : 'MainController as vm'
                    },
                    'toolbar@app'   : {
                        templateUrl: layouts[layoutStyle].toolbar,
                        controller : 'ToolbarController as vm'
                    },
                    'navigation@app': {
                        templateUrl: layouts[layoutStyle].navigation,
                        controller : 'NavigationController as vm'
                    }
                },
                resolve: {
                    auth: function resolveAuthentication(authResolver) {
                        return authResolver.resolve();
                    }
                }
            });
    }

})();

(function ()
{
    'use strict';

    angular
        .module('ico')
        .controller('IndexController', IndexController);

    /** @ngInject */
    function IndexController(icoTheming, $scope, $state, $rootScope, session, USER_ROLES, AUTH_EVENTS, API_EVENTS, auth, icoConfig)
    {
        var vm = this;

        // Data
        vm.themes = icoTheming.themes;
        $rootScope.apiError = null;
        $rootScope.user = null;
        $rootScope.site = icoConfig.getConfig('site');
        $scope.userRoles = USER_ROLES;
        //$scope.isAuthorized = auth.isAuthorized;

        // Methods
        vm.loginSuccess = loginSuccess;
        vm.logoutSuccess = logoutSuccess;
        vm.notAuthorized = notAuthorized;
        vm.notAuthenticated = notAuthenticated;
        vm.sessionTimeout = sessionTimeout;
        vm.showApiError = showApiError;

        //listen to auth events
        $rootScope.$on(AUTH_EVENTS.notAuthorized, vm.notAuthorized);
        $rootScope.$on(AUTH_EVENTS.notAuthenticated, vm.notAuthenticated);
        $rootScope.$on(AUTH_EVENTS.sessionTimeout, vm.sessionTimeout);
        $rootScope.$on(AUTH_EVENTS.logoutSuccess, vm.logoutSuccess);
        $rootScope.$on(AUTH_EVENTS.loginSuccess, vm.loginSuccess);

        //listen to api events
        $rootScope.$on(API_EVENTS.error, vm.showApiError);

        //////////

        function loginSuccess(event, data) {
            session.create(data);
            //continue state change?
            if (data.toState)
                $state.go(data.toState.name, data.toState.params);
        }

        function logoutSuccess() {
            session.destroy();
            $state.go('app.login');
        }

        function showApiError(event, data) {
            $rootScope.apiError = data;
            $rootScope.apiError.message = 'response status code is '+data.status;
        }

        function notAuthorized() {
            session.user.role>0?$state.go('app.wallet'):$state.go('app.login');
        }

        function notAuthenticated(event, data) {
            session.destroy();
            //continue state change?
            if (data)
                $state.go(data.name, data.params);
            else
                $state.go('app.login');
        }

        function sessionTimeout() {
            session.destroy();
            $state.go('app.login');
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('ico');
})();

(function ()
{
    'use strict';

    angular
        .module('ico')
        .config(config);

    /** @ngInject */
    function config($translateProvider, msApiProvider)
    {
        // Put your common app configurations here

        // angular-translate configuration
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: '{part}/i18n/{lang}.json'
        });
        $translateProvider.preferredLanguage('en');
        $translateProvider.useSanitizeValueStrategy('sanitize');
        
        // API base URL
        msApiProvider.setBaseUrl('api/api__');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('ico')
        .factory('api', apiService);

    /** @ngInject */
    function apiService($resource, msApi, $mdToast)
    {
        /**
         * You can use this service to define your API urls. The "api" service
         * is designed to work in parallel with "apiResolver" service which you can
         * find in the "app/core/services/api-resolver.service.js" file.
         *
         * You can structure your API urls whatever the way you want to structure them.
         * You can either use very simple definitions, or you can use multi-dimensional
         * objects.
         *
         * Here's a very simple API url definition example:
         *
         *      api.getBlogList = $resource('http://api.example.com/getBlogList');
         *
         * While this is a perfectly valid $resource definition, most of the time you will
         * find yourself in a more complex situation where you want url parameters:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'});
         *
         * You can also define your custom methods. Custom method definitions allow you to
         * add hardcoded parameters to your API calls that you want to sent every time you
         * make that API call:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'}, {
         *         'getFromHomeCategory' : {method: 'GET', params: {blogCategory: 'home'}}
         *      });
         *
         * In addition to these definitions, you can also create multi-dimensional objects.
         * They are nothing to do with the $resource object, it's just a more convenient
         * way that we have created for you to packing your related API urls together:
         *
         *      api.blog = {
         *                   list     : $resource('http://api.example.com/blog'),
         *                   getById  : $resource('http://api.example.com/blog/:id', {id: '@id'}),
         *                   getByDate: $resource('http://api.example.com/blog/:date', {id: '@date'}, {
         *                       get: {
         *                            method: 'GET',
         *                            params: {
         *                                getByDate: true
         *                            }
         *                       }
         *                   })
         *       }
         *
         * If you look at the last example from above, we overrode the 'get' method to put a
         * hardcoded parameter. Now every time we make the "getByDate" call, the {getByDate: true}
         * object will also be sent along with whatever data we are sending.
         *
         * All the above methods are using standard $resource service. You can learn more about
         * it at: https://docs.angularjs.org/api/ngResource/service/$resource
         *
         * -----
         *
         * After you defined your API urls, you can use them in Controllers, Services and even
         * in the UIRouter state definitions.
         *
         * If we use the last example from above, you can do an API call in your Controllers and
         * Services like this:
         *
         *      function MyController (api)
         *      {
         *          // Get the blog list
         *          api.blog.list.get({},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the id of 3
         *          var id = 3;
         *          api.blog.getById.get({'id': id},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the date by using custom defined method
         *          var date = 112314232132;
         *          api.blog.getByDate.get({'date': date},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *      }
         *
         * Because we are directly using $resource service, all your API calls will return a
         * $promise object.
         *
         * --
         *
         * If you want to do the same calls in your UI Router state definitions, you need to use
         * "apiResolver" service we have prepared for you:
         *
         *      $stateProvider.state('app.blog', {
         *          url      : '/blog',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver)
         *              {
         *                  return apiResolver.resolve('blog.list@get');
         *              }
         *          }
         *      });
         *
         *  You can even use parameters with apiResolver service:
         *
         *      $stateProvider.state('app.blog.show', {
         *          url      : '/blog/:id',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver, $stateParams)
         *              {
         *                  return apiResolver.resolve('blog.getById@get', {'id': $stateParams.id);
         *              }
         *          }
         *      });
         *
         *  And the "Blog" object will be available in your BlogController:
         *
         *      function BlogController(Blog)
         *      {
         *          var vm = this;
         *
         *          // Data
         *          vm.blog = Blog;
         *
         *          ...
         *      }
         */

        var api = {};

        // Base Url
        api.baseUrl = msApi.getBaseUrl();


        api.showToast = function(type, message) {
            $mdToast.show({
                hideDelay   : 3500,
                position    : 'top right',
                controller  : 'ToastsController',
                controllerAs: 'vm',
                locals             : {
                    data         : {message: message}
                },
                templateUrl : 'app/navigation/toasts/'+type+'.html'
            });
        };

        return api;
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.social-channels.twitter', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.social-channels_twitter', {
                url    : 'https://twitter.com/ceek',
                external: true,
                blank: true
            });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.social-channels.telegram', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.social-channels_telegram', {
                url    : 'https://t.me/ceekvrtokensale',
                external: true,
                blank: true
            });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.social-channels.reddit', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.social-channels_reddit', {
                url    : 'https://www.reddit.com/r/Ceek/',
                external: true,
                blank: true
            });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.social-channels.facebook', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.social-channels_facebook', {
                url    : 'https://www.facebook.com/ceekapp/',
                external: true,
                blank: true
            });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.documents.privacy-terms', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.documents_privacy-terms', {
                url    : 'api/CGI_Privacy_Terms_V2.html',
                external: true,
                blank: true
            });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.documents.white-paper', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.documents_white-paper', {
                url    : 'https://www.dropbox.com/s/1fibdgyjgbfiu6h/CEEK_Virtual%20Reality%20TGE%20White%20Paper.pdf?dl=0',
                external: true,
                blank: true
            });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.documents.circular', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.documents_circular', {
                url    : 'https://www.dropbox.com/s/wnr524yp1kbdnfj/CGI_Token_Sale_Circular_With_Terms.pdf?dl=0',
                external: true,
                blank: true
            });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.documents.aml', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.documents_aml', {
                url    : 'https://www.dropbox.com/s/946q7c5e25sekgq/CGI_ANTI%20%24%20LAUNDERING%20PROGRAM.pdf?dl=0',
                external: true,
                blank: true
            });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.social-channels',
            [
                'app.social-channels.facebook',
                'app.social-channels.twitter',
                'app.social-channels.reddit',
                'app.social-channels.telegram'
            ]
        )
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider, $translatePartialLoaderProvider)
    {

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/social-channels');

        // Navigation
        msNavigationServiceProvider.saveItem('social-channels', {
            title : 'Social Channels',
            icon  : 'icon-newspaper',
            weight: 100,
            translate: 'SOCIAL-CHANNELS.SOCIAL-CHANNELS'
        });

        msNavigationServiceProvider.saveItem('social-channels.facebook', {
            title: 'Facebook',
            icon  : 'icon-facebook',
            weight: 0,
            state: 'app.social-channels_facebook'
        });

        msNavigationServiceProvider.saveItem('social-channels.twitter', {
            title : 'Twitter',
            icon  : 'icon-twitter',
            weight: 1,
            state: 'app.social-channels_twitter'
        });

        msNavigationServiceProvider.saveItem('social-channels.reddit', {
            title : 'Reddit',
            icon  : 'icon-reddit',
            weight: 2,
            state: 'app.social-channels_reddit'
        });

        msNavigationServiceProvider.saveItem('social-channels.telegram', {
            title : 'Telegram',
            icon  : 'icon-telegram',
            weight: 3,
            state: 'app.social-channels_telegram'
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.documents',
            [
                'app.documents.white-paper',
                'app.documents.privacy-terms',
                'app.documents.circular',
                'app.documents.aml'
            ]
        )
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider, $translatePartialLoaderProvider)
    {

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/documents');

        // Navigation
        msNavigationServiceProvider.saveItem('documents', {
            title : 'Documents',
            icon  : 'icon-document',
            weight: 90,
            translate: 'DOCUMENTS.DOCUMENTS'
        });

        msNavigationServiceProvider.saveItem('documents.white-paper', {
            title: 'White paper',
            icon  : 'icon-file',
            weight: 0,
            state: 'app.documents_white-paper'
        });

        msNavigationServiceProvider.saveItem('documents.privacy-terms', {
            title : 'Privacy Terms',
            icon  : 'icon-file-document',
            weight: 1,
            state: 'app.documents_privacy-terms'
        });

        msNavigationServiceProvider.saveItem('documents.circular', {
            title : 'Circular',
            icon  : 'icon-file-document',
            weight: 2,
            state: 'app.documents_circular'
        });

        msNavigationServiceProvider.saveItem('documents.aml', {
            title : 'AML',
            icon  : 'icon-file-document',
            weight: 3,
            state: 'app.documents_aml'
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.account',
            [
                'app.account.balance',
                'app.account.settings'
            ]
        )
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider, $translatePartialLoaderProvider)
    {

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/account');

        // Navigation
        msNavigationServiceProvider.saveItem('account', {
            title : 'Account',
            icon  : 'icon-account',
            weight: 3,
            translate: 'ACCOUNT.ACCOUNT'
        });

        // msNavigationServiceProvider.saveItem('account.balance', {
        //     title: 'Balance',
        //     icon  : 'icon-coin',
        //     weight: 1,
        //     state: 'app.account_balance'
        // });

        msNavigationServiceProvider.saveItem('account.settings', {
            title: 'Settings',
            icon  : 'icon-gear',
            weight: 0,
            state: 'app.account_settings'
        });
    }

})();
angular.module("ico").run(["$templateCache", function($templateCache) {$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex><div \nid=\"toolbar-navigation-container\" class=\"md-whiteframe-1dp\" layout=\"column\" layout-align=\"space-between start\">\n<md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"horizontal-navigation\" ui-view=\"navigation\" layout=\"row\" layout-align=\"start end\" flex></div></div><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar-2\" class=\"template-layout\" layout=\"column\" flex>{{userlo}}\n<md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-fade-in-out md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" \nclass=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll \nui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex layout=\"column\"><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ms-scroll ui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/theme-options/theme-options.html","<div class=\"ms-theme-options-button md-primary-bg\" ng-click=\"toggleOptionsSidenav()\"><md-icon md-font-icon=\"icon-cog\" \nclass=\"white-text\"></md-icon></div><md-sidenav md-component-id=\"ico-theme-options\" class=\"md-sidenav-right\"><div \nclass=\"ms-theme-options-list\" layout=\"column\"><div class=\"theme-option layout-options\"><div class=\"option-title\">\nLayout Style:</div><md-radio-group layout=\"row\" layout-align=\"start start\" layout-wrap ng-model=\"vm.layoutStyle\" \nng-change=\"vm.updateLayoutStyle()\"><md-radio-button ng-repeat=\"layoutStyle in vm.layoutStyles\" \nng-value=\"layoutStyle.value\"><div layout=\"column\" layout-align=\"center center\"><img ng-src=\"{{layoutStyle.figure}}\"> \n<span class=\"text-center font-size-12 mt-8\">{{layoutStyle.label}}</span></div></md-radio-button></md-radio-group></div>\n<md-divider></md-divider><div class=\"theme-option\"><div class=\"option-title\">Layout Mode:</div><md-radio-group \nlayout=\"row\" layout-align=\"start center\" ng-model=\"vm.layoutMode\" ng-change=\"vm.updateLayoutMode()\"><md-radio-button \nng-repeat=\"layoutMode in vm.layoutModes\" ng-value=\"layoutMode.value\">{{layoutMode.label}}</md-radio-button>\n</md-radio-group></div><md-divider></md-divider><div class=\"theme-option color-palettes\"><div class=\"option-title\">\nColor Palette:</div><div layout=\"row\" layout-align=\"start start\" layout-wrap><md-button \nng-repeat=\"(themeName, theme) in vm.themes.list\" class=\"md-raised theme-button\" layout=\"row\" \nlayout-align=\"center center\" aria-label=\"{{themeName}}\" ng-click=\"vm.setActiveTheme(themeName)\" \nng-style=\"{\'background-color\': theme.primary.color,\'border-color\': theme.accent.color,\'color\': theme.primary.contrast1}\" \nng-class=\"{active: vm.getActiveTheme().name === themeName}\"><md-icon ng-style=\"{\'color\': theme.primary.contrast1}\" \nmd-font-icon=\"icon-palette\" class=\"icon s32\"></md-icon></md-button></div></div></div></md-sidenav>");
$templateCache.put("app/main/deposit/deposit.html","<div id=\"deposit\" ng-class=\"{\'blur\': vm.isDepositUnavailable}\"><div class=\"tabs\"><div class=\"tab-links\"><ul><li \nng-repeat=\"(currencyCode, currency) in vm.DepositData.currencies\" ng-class=\"{ active: vm.activeTab == currencyCode }\">\n<a ng-click=\"vm.switchCurrency(currencyCode)\"><i \nng-class=\"[\'cryptoicon-{{currencyCode}}\', \'cryptoicon-{{currencyCode}}-bg\']\"></i> <span>{{currency.title}}</span></a>\n</li></ul></div><div ng-repeat=\"(currencyCode, currency) in vm.DepositData.currencies\" id=\"{{currencyCode}}\" \nng-if=\"vm.activeTab == currencyCode\" class=\"tab-content\"><div class=\"title\"><span class=\"currency-title\">\n{{currency.title}}</span><p class=\"token-price\">Rate per token: <span class=\"rate\">\n{{currency.rate_per_token}} {{currencyCode}}</span></p><p class=\"token-price\"><span ng-if=\"currency.usd_price_special\" \nclass=\"special-rate\">Special Rate: </span>1 {{currencyCode}} = <span class=\"rate\">{{currency.usd_price | currency:$:2}}\n</span></p></div><div class=\"deposit\" ng-class=\"{\'blur\': (!currency.address || vm.isLoading)}\"><form name=\"deposit\">\n<md-input-container class=\"md-block deposit-amount\"><input type=\"text\" name=\"amount\" ng-model=\"currency.amount\" \nplaceholder=\"Token calculator\" ng-pattern=\"/^(?!0\\d)\\d*(\\.\\d+)?$/\"><div ng-messages=\"deposit.amount.$error\" \nrole=\"alert\"><div ng-message=\"pattern\"><span>Amount must be numeric</span></div></div></md-input-container></form><div \nclass=\"deposit-info-container\"><div class=\"summary\" ng-if=\"currency.amount\">You\'ll receive <span class=\"amount\">\n{{vm.DepositData.bonuses !== undefined? ((currency.amount*1 + currency.amount/100*vm.DepositData.currentBonus.bonus)/currency.rate_per_token | number:4): (currency.amount/currency.rate_per_token | number:4)}} {{vm.DepositData.tokenCode}}*\n</span><div class=\"description\">\n{{vm.DepositData.bonuses !== undefined?(currency.amount/currency.rate_per_token | number:4) + \' \' + vm.DepositData.tokenCode + \' + \' + ((currency.amount/100*vm.DepositData.currentBonus.bonus/currency.rate_per_token | number: 4) + \' \' + vm.DepositData.tokenCode + \' (\' + vm.DepositData.currentBonus.bonus + \'% bonus)\'):\'\'}}\n</div></div><div class=\"deposit-qr-container\"><qrcode \ndata=\"{{currency.address?currency.urn + \':\' + currency.address + (currency.amount&&currencyCode!=\'ETH\'?\'?amount=\'+currency.amount:\'\')\r\n                                :\'Please wait while we generate your personal \' + currency.title + \' address\'}}\" \nsize=\"200\"></qrcode></div></div><div class=\"wallet-address\"><span>\nThis is your personal deposit address which will be matched to this account.<br>\nPlease send payment to this receiving address:</span> <a \nng-href=\"{{currency.address?currency.urn + \':\' + currency.address + (currency.amount&&currencyCode!=\'ETH\'?\'?amount=\'+currency.amount:\'\')\r\n                        :\'#\'}}\">\n{{currency.address?currency.address:\'Please wait while we generate your personal \' + currency.title + \' address\'}}</a>\n</div></div><div ng-if=\"!currency.address\" class=\"generating-address\"><div><md-progress-linear \nclass=\"md-accent md-hue-1\" md-mode=\"query\" ng-disabled=\"currency.address\"></md-progress-linear></div>\nPlease wait while we generate your personal {{currency.title}} deposit address</div><div class=\"disclaimer\" \nng-class=\"{\'blur\': (!currency.address || vm.isLoading)}\"><span>The Token Sale is Open to <b>Non US Residents Only</b>. \n</span><span ng-if=\"currencyCode == \'ETH\'\">Transfers from Coinbase and other exchanges <b>are welcome.</b>\n You will be able to set your ERC20-compatible wallet address later. </span><span>\n*Disclaimer: cryptocurrency rate may fluctuate during transaction processing. The amount provided for informational purposes only.\n</span></div></div><div ng-if=\"!vm.activeTab\" class=\"tab-content\"><div class=\"title\">Deposit funds</div><p \nclass=\"helper\">Select currency you wish to deposit to get your personal deposit address.</p></div><div \nclass=\"bonuses-timeline\" ng-if=\"vm.DepositData.bonuses && vm.DepositData.bonuses.length\"><span \nclass=\"bonuses-timeline-title\">Prices</span><section class=\"timeline\"><div class=\"timeline-block\" \nng-repeat=\"(currencyCode, bonus) in vm.DepositData.bonuses\" \nng-class=\"{\'active\':(bonus.id==vm.DepositData.currentBonus.id),\r\n                                \'past\':((bonus.kind==0?vm.isDateInPast(bonus.to_date):vm.DepositData.currentBonus.from_amount>=bonus.to_amount)\r\n                                && !(bonus.id==vm.DepositData.currentBonus.id))}\">\n<div class=\"timeline-content\"><div class=\"date\"><span class=\"uppercase\">\n{{bonus.kind==0?(bonus.from_date | toDate | date:\'d MMM\'):bonus.from_amount + \' \' + vm.DepositData.tokenCode}}</span> \n<span class=\"left\" \nng-if=\"vm.isDateInRange(bonus.from_date, bonus.to_date)\r\n                                                      && bonus.id==vm.DepositData.currentBonus.id\">\n{{bonus.kind==0?\'ends \'+(vm.getDaysLeft(bonus.to_date)): bonus.to_amount - vm.DepositData.currentTokenAmount + \' \' + vm.DepositData.tokenCode +\' left\'}}\n</span></div><div class=\"bonus\" layout=\"row\"><div><span class=\"amount\">{{bonus.bonus | number : 2}}%</span></div></div>\n<div class=\"token-info\"><span ng-if=\"bonus.token_price\">\n1 {{vm.DepositData.tokenCode}} = {{bonus.token_price | currency : \"$\"}}</span> <span ng-if=\"bonus.soft_cap\">\nSoft Cap: {{bonus.soft_cap | currency : \"$\"}}</span></div></div></div></section></div><div class=\"bonuses\" \nng-if=\"vm.DepositData.bonuses && vm.DepositData.bonuses.length && vm.settings.bonusDisplay == \'legacy\'\"><div \nclass=\"title\">Bonuses</div><div class=\"bonus\" ng-repeat=\"(currencyCode, bonus) in vm.DepositData.bonuses\" \nng-class=\"{\'current\':(bonus.id==vm.DepositData.currentBonus.id)}\"><div \nng-if=\"bonus.id==vm.DepositData.currentBonus.id\" class=\"time-left\"><i class=\"icon-clock s14\"></i> <span>\n{{bonus.kind==0?\'Ends \'+(vm.getDaysLeft(bonus.to_date)): bonus.to_amount - vm.DepositData.currentTokenAmount + \' \' + vm.DepositData.tokenCode +\' left\'}}\n</span></div><div class=\"bonus-header\">\n{{bonus.id==vm.DepositData.currentBonus.id?\'Current\': bonus.kind==0?vm.getDuration(bonus.from_date, bonus.to_date):bonus.to_amount - bonus.from_amount + \' \' + vm.DepositData.tokenCode}}\n</div><div class=\"bonus-body\">{{bonus.bonus | number : 2}}%</div><div class=\"bonus-footer\">\n{{bonus.kind==0?(bonus.to_date | toDate | date:\'d MMM\'):bonus.to_amount + \' \' + vm.DepositData.tokenCode}}</div></div>\n</div></div></div>");
$templateCache.put("app/main/send/send.html","<div id=\"send\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"header\"><span \nclass=\"md-display-1 font-weight-300\">Send</span></div><div class=\"content\"><div \nclass=\"form-wrapper md-whiteframe-1dp center\" layout=\"row\" layout-wrap><div layout=\"row\" flex=\"100\"><form \nname=\"sendForm\" class=\"md-inline-form\" novalidate flex><md-input-container class=\"md-block\"><input type=\"text\" \nname=\"address\" ng-model=\"vm.sendData.address\" placeholder=\"Address\" required></md-input-container><div \nclass=\"submit-right\"><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Send\" \nng-disabled=\"contactForm.$invalid || contactForm.$pristine\">Send</md-button></div></form></div></div></div></div>");
$templateCache.put("app/main/support/support.html","<div id=\"support\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"header\"><span \nclass=\"md-display-1 font-weight-300\">Contact Us</span></div><div class=\"content\"><md-tabs md-dynamic-height><md-tab \nlabel=\"Contact form\"><div class=\"form-wrapper md-whiteframe-1dp center\" layout=\"row\" layout-wrap><div layout=\"row\" \nflex=\"100\" flex-gt-sm=\"60\"><form id=\"contactForm\" name=\"contactForm\" class=\"md-inline-form\" novalidate flex>\n<md-input-container class=\"md-block\"><input type=\"text\" name=\"name\" ng-model=\"vm.supportData.name\" placeholder=\"Name\" \nrequired></md-input-container><md-input-container class=\"md-block\"><input type=\"text\" name=\"email\" \nng-model=\"vm.supportData.email\" placeholder=\"Email\" ng-pattern=\"/^.+@.+\\..+$/\" required></md-input-container>\n<md-input-container class=\"md-block\"><input type=\"text\" name=\"mobile_phone\" ng-model=\"vm.supportData.mobile_phone\" \nplaceholder=\"Mobile Phone\"></md-input-container><md-input-container class=\"md-block\"><label>Message</label><textarea \nname=\"message\" ng-model=\"vm.supportData.message\" md-maxlength=\"500\" rows=\"5\" required></textarea></md-input-container>\n<div class=\"submit-right\"><md-button type=\"submit\" class=\"md-raised md-accent promise-button\" aria-label=\"Send\" \nng-attr-data-loading=\"{{vm.dataLoading.submitMessage}}\" \nng-disabled=\"contactForm.$invalid || contactForm.$pristine || vm.dataLoading.submitMessage\" \nng-click=\"vm.submitMessage($event)\"><span class=\"promise-button-label\">Send</span><md-progress-circular \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular></md-button></div></form></div><div \nlayout=\"row\" flex=\"100\" flex-gt-sm=\"40\" layout-align=\"center start\"><div class=\"contacts\" layout=\"row\" flex=\"100\" \nflex-gt-md=\"60\" layout-align=\"space-between start\" layout-wrap><div class=\"contacts-office\"><h2></h2><address>\nCGI World Ltd:<br>Intershore Chambers<br>Road Town<br>Tortola<br>British Virgin Islands</address></div><div \nclass=\"contacts-support\"><h2>Support</h2><address>Email: <a href=\"mailto:support@ceek.io\">support@ceek.io</a></address>\n</div></div></div></div></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/transaction-history/transaction-history.html","<div id=\"transaction-history\" class=\"page-layout fullwidth\" layout=\"row\"><div class=\"top-bg\"><div class=\"header\"><div \nclass=\"md-display-1 font-weight-300 white-fg\"><span>My Transactions</span></div></div></div><div class=\"center\" \nlayout=\"column\" flex><div class=\"content-card md-whiteframe-1dp\"><div class=\"p-16\"><div class=\"h2 secondary-text\">\nTransaction History</div></div><div class=\"content\"><table datatable=\"\" dt-options=\"vm.dtOptions\" \ndt-columns=\"vm.dtColumns\" class=\"row-border hover\"></table></div></div></div></div>");
$templateCache.put("app/main/affiliate/affiliate.html","<div id=\"affiliate\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"header\"><span \nclass=\"md-display-1 font-weight-300\">Affiliate Campaign</span></div><div class=\"content\"><md-tabs md-dynamic-height>\n<md-tab label=\"Affiliate\"><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div \nclass=\"border-bottom\"><div class=\"disclaimer\"><span>Earn <b>\n{{vm.AffiliateData.affiliate_reward}}% {{vm.AffiliateData.token_name}}</b>\n from each purchase of friends you refer! Share this link with your friends now!</span></div></div><div layout=\"row\" \nlayout-wrap layout-align=\"left\"><div flex=\"100\" flex-gt-xs=\"20\" class=\"affiliate-text\">Affiliate link:</div><div \nflex=\"auto\" flex-gt-xs=\"initial\" class=\"affiliate-link\"><md-input-container class=\"md-block\" md-no-float><label>\n</label><input name=\"name\" \nng-value=\"vm.AffiliateData.link\r\n                                           +(vm.AffiliateData.user_subid?\'&\'+vm.AffiliateData.subid_param\r\n                                           +\'=\'+vm.AffiliateData.user_subid:\'\')\" \nreadonly=\"readonly\" ms-select-on-click><div class=\"hint\">Share this link to get <b>\n{{vm.AffiliateData.affiliate_reward}}% {{vm.AffiliateData.token_name}}</b> from each purchase of friends you refer!\n</div></md-input-container></div><div flex-gt-xs=\"10\"><md-button class=\"md-raised md-accent input-button\" \naria-label=\"Copy to clipboard\" \nms-click-copy=\"{{vm.AffiliateData.link\r\n                                           +(vm.AffiliateData.user_subid?\'&\'+vm.AffiliateData.subid_param\r\n                                           +\'=\'+vm.AffiliateData.user_subid:\'\')}}\" \nng-click=\"vm.showToast(\'success\', \'Link copied to clipboard\')\">Copy</md-button></div></div><div layout=\"row\" \nlayout-wrap class=\"affiliate-advanced\"><span flex=\"100\" flex-gt-xs=\"20\"></span><div class=\"advanced-container\"><form \nname=\"subIdForm\" id=\"subIdForm\"><md-checkbox flex-xs=\"100\" ng-model=\"vm.AffiliateData.advanced\" ng-true-value=\"1\" \nng-false-value=\"0\" ng-click=\"\" aria-label=\"Advanced\" flex><span>Advanced</span></md-checkbox><md-input-container \nng-show=\"vm.AffiliateData.advanced\" class=\"md-block affiliate-subid\"><label>SubID</label><input name=\"user_subid\" \nng-model=\"vm.AffiliateData.user_subid\" required ng-maxlength=\"6\" ng-pattern=\"/^[a-zA-Z0-9_-]+$/\"><div class=\"hint\">\nUse subid to track your advertising/sales channel. For example if you posting this on youtube and telegram, you can use 2 different links with respective subids and see how many sales comes from Telegram and how many comes from Youtube.\n</div><div ng-messages=\"subIdForm.user_subid.$error\" role=\"alert\"><div ng-message=\"pattern\"><span>\nSubId should only contain letters and numbers</span></div><div ng-message=\"minlength, maxlength\"><span>\nSubId must be up to 6 characters long</span></div></div></md-input-container></form></div></div></ms-widget-front>\n</ms-widget><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg pb-16\"><div class=\"widget-header\" \nlayout=\"row\"><div class=\"h2 secondary-text\">Affiliate transactions</div></div><table datatable \nclass=\"row-border hover\" dt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\" dt-instance=\"vm.dtInstance\"></table>\n</ms-widget-front></ms-widget></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/password-change/password-change.html","<div id=\"password-change\" class=\"page-layout fullwidth\" layout=\"row\"><div class=\"top-bg\"><div class=\"header\"><div \nclass=\"md-display-1 font-weight-300 white-fg\"><span>Password</span></div></div></div><div class=\"center\" \nlayout=\"column\" flex><div class=\"content-card md-whiteframe-1dp\"><div class=\"p-16\"><div class=\"h2 secondary-text\">\nChange your password</div></div><div class=\"content\"><div class=\"form-wrapper\"><form name=\"passwordForm\" \nid=\"passwordForm\" class=\"md-inline-form\" flex><div layout=\"column\" layout-gt-sm=\"row\" \nclass=\"change-password-container\"><md-input-container flex><input type=\"password\" name=\"password\" \nng-model=\"vm.passwordChangeData.password.current\" placeholder=\"Current password\" required><div \nng-messages=\"passwordForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span>Password field is required\n</span></div></div></md-input-container><md-input-container flex ng-if=\"user.two_factor_auth\"><input type=\"text\" \nname=\"code\" ng-model=\"vm.passwordChangeData.code\" placeholder=\"Google authenticator code\" required ng-minlength=\"6\" \nng-maxlength=\"6\"><div ng-messages=\"passwordForm.code.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nAuthenticator code is required</span></div><div ng-message=\"minlength, maxlength\"><span>Code must be 6 characters long\n</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" \nclass=\"change-password-container\"><md-input-container flex><input type=\"password\" name=\"new_password\" \nng-model=\"vm.passwordChangeData.password.new\" placeholder=\"New password\" required ng-minlength=\"6\"><div \nng-messages=\"passwordForm.new_password.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nNew password field is required</span></div><div ng-message=\"minlength\"><span>Password is too short</span></div></div>\n</md-input-container><md-input-container flex><input type=\"password\" name=\"new_password_confirm\" \nng-model=\"vm.passwordChangeData.password.confirm\" placeholder=\"Repeat new password\" required ng-minlength=\"6\"><div \nng-messages=\"passwordForm.new_password_confirm.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nConfirm new password field is required</span></div><div ng-message=\"minlength\"><span>Password is too short</span></div>\n</div></md-input-container></div><md-button type=\"submit\" class=\"md-raised md-accent promise-button\" \naria-label=\"Save Changes\" ng-attr-data-loading=\"{{vm.dataLoading.password}}\" \nng-disabled=\"passwordForm.$invalid || passwordForm.$pristine || vm.dataLoading.password\" \nng-click=\"vm.changePassword($event)\"><span class=\"promise-button-label\">Save Changes</span><md-progress-circular \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular></md-button></form></div></div></div>\n</div></div>");
$templateCache.put("app/main/activate-2fa/activate-2fa.html","<div id=\"activate-2fa\" class=\"page-layout fullwidth\" layout=\"row\"><div class=\"top-bg\"><div class=\"header\"><div \nclass=\"md-display-1 font-weight-300 white-fg\"><span>Activate 2FA</span></div></div></div><div class=\"center\" \nlayout=\"column\" flex><div class=\"content-card md-whiteframe-1dp\"><div class=\"p-16\"><div class=\"h2 secondary-text\">\nTwo-factor authentication settings</div></div><div class=\"content\"><div class=\"form-wrapper\"><form \nname=\"activate2faForm\" id=\"activate2faForm\" class=\"md-inline-form\" autocomplete=\"off\" flex><div class=\"md-block\">\n<md-input-container flex ng-if=\"user.two_factor_auth\" class=\"animate-slide-right\"><input type=\"text\" name=\"code\" \nng-model=\"vm.activate2faData.code\" placeholder=\"Authenticator code\" required autocomplete=\"off\" ng-minlength=\"6\" \nng-maxlength=\"6\"><div ng-messages=\"activate2faForm.code.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nAuthenticator code is required</span></div><div ng-message=\"minlength, maxlength\"><span>Code must be 6 characters long\n</span></div></div></md-input-container></div><md-input-container class=\"md-block\"><md-checkbox name=\"two_factor_auth\" \nng-model=\"vm.activate2faData.two_factor_auth\" ng-true-value=\"1\" ng-false-value=\"0\" \nng-click=\"vm.showTwoFactorAuthDialog($event)\" aria-label=\"2 Factor Auth\" class=\"md-align-top-left\" flex><span \nclass=\"two-factor\">Use two-factor authentication</span><div class=\"two-factor_helper secondary-text\">\nTwo Factor Authentication, is an extra layer of security that requires not only a password and email but also your smartphone. It is an excellent way to make sure your account is secure.\n</div></md-checkbox></md-input-container><md-input-container class=\"md-block\"><input type=\"password\" name=\"password\" \nng-model=\"vm.activate2faData.password.current\" autocomplete=\"off\" placeholder=\"Current password\" required><div \nng-messages=\"activate2faForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span>Password field is required\n</span></div></div></md-input-container><div class=\"hint animate-fade-in-out\" \nng-show=\"!activate2faForm.$pristine && !vm.activate2faData.password.current\">Enter your password <span \nng-show=\"user.two_factor_auth\">and google authenticator code </span>\nand press Save Changes button to confirm any changes</div><md-button type=\"submit\" \nclass=\"md-raised md-accent promise-button\" aria-label=\"Save Changes\" \nng-attr-data-loading=\"{{vm.dataLoading.settings}}\" \nng-disabled=\"activate2faForm.$invalid || activate2faForm.$pristine || vm.dataLoading.settings\" \nng-click=\"vm.changeSettings($event)\"><span class=\"promise-button-label\">Save Changes</span><md-progress-circular \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular></md-button></form></div></div></div>\n</div></div>");
$templateCache.put("app/navigation/toasts/error.html","<md-toast class=\"error\"><span class=\"md-toast-text\" flex>{{vm.data.message}}</span></md-toast>");
$templateCache.put("app/navigation/toasts/success.html","<md-toast class=\"success\"><span class=\"md-toast-text\" flex>{{vm.data.message}}</span></md-toast>");
$templateCache.put("app/main/user-info/user-info.html","<div id=\"user-info\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"content\"><md-tabs md-dynamic-height>\n<md-tab label=\"Setting\"><div class=\"form-wrapper md-whiteframe-1dp center\"><form name=\"accountForm\" id=\"accountForm\" \nclass=\"md-inline-form\" autocomplete=\"off\" flex><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><input \ntype=\"text\" name=\"email\" ng-model=\"vm.accountData.email\" placeholder=\"Primary Email\" disabled=\"disabled\" required><div \nng-messages=\"accountForm.email.$error\" role=\"alert\"><div ng-message=\"required\"><span>Primary email is required</span>\n</div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><input \ntype=\"text\" name=\"name\" ng-model=\"vm.accountData.name\" placeholder=\"First name\" required><div \nng-messages=\"accountForm.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>Please enter your first name</span>\n</div></div></md-input-container><md-input-container flex><input type=\"text\" name=\"surname\" \nng-model=\"vm.accountData.surname\" placeholder=\"Last name\" required><div ng-messages=\"accountForm.surname.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Please enter your last name</span></div></div></md-input-container></div>\n<div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><input type=\"text\" name=\"ether_address\" \nng-model=\"vm.accountData.ether_address\" ng-disabled=\"vm.accountData.is_external_purchase\" \nng-pattern=\"/^(0x)?[0-9a-fA-F]{40}$/\" placeholder=\"Ethereum wallet\" required><div \nng-messages=\"accountForm.ether_address.$error\" role=\"alert\"><div ng-message=\"pattern\"><span>\nPlease enter a valid ethereum address</span></div></div><span class=\"wallet-helper secondary-text\" \nng-if=\"!vm.accountData.is_external_purchase\">Don\'t have an Ethereum wallet yet? Click <a \nhref=\"https://www.myetherwallet.com/\" target=\"_blank\">here</a> to get started!</span></md-input-container></div><div \nclass=\"md-block\"><md-input-container flex><input type=\"password\" name=\"password\" \nng-model=\"vm.accountData.password.current\" autocomplete=\"off\" placeholder=\"Current password\" required><div \nng-messages=\"accountForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span>Password field is required\n</span></div></div></md-input-container><md-input-container flex ng-if=\"user.two_factor_auth\" \nclass=\"animate-slide-right\"><input type=\"text\" name=\"code\" ng-model=\"vm.accountData.code\" \nplaceholder=\"Authenticator code\" required autocomplete=\"off\" ng-minlength=\"6\" ng-maxlength=\"6\"><div \nng-messages=\"accountForm.code.$error\" role=\"alert\"><div ng-message=\"required\"><span>Authenticator code is required\n</span></div><div ng-message=\"minlength, maxlength\"><span>Code must be 6 characters long</span></div></div>\n</md-input-container><div class=\"hint animate-fade-in-out\" \nng-show=\"!accountForm.$pristine && !vm.accountData.password.current\">Enter your password <span \nng-show=\"user.two_factor_auth\">and google authenticator code </span>\nand press Save Changes button to confirm any changes</div></div><md-button type=\"submit\" \nclass=\"md-raised md-accent promise-button\" aria-label=\"Save Changes\" \nng-attr-data-loading=\"{{vm.dataLoading.settings}}\" \nng-disabled=\"accountForm.$invalid || accountForm.$pristine || vm.dataLoading.settings\" \nng-click=\"vm.changeSettings($event)\"><span class=\"promise-button-label\">Save Changes</span><md-progress-circular \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular></md-button></form></div></md-tab>\n</md-tabs></div></div>");
$templateCache.put("app/main/wallet/wallet.html","<div id=\"wallet\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"content\"><md-tabs md-dynamic-height>\n<md-tab label=\"Wallet\" md-on-select=\"vm.getWalletInfo()\"><div class=\"progress-bar-wrapper mb-16 mt-16\"><div \nclass=\"status-bar\" ng-style=\"{width: 100-100/vm.integrationData.progressBar.goals.length+\'%\'}\"><div \nclass=\"current-status\" style=\"width: 0\" \nng-style=\"{width: (100-100/(vm.integrationData.progressBar.goals.length-1))*\r\n                                     (vm.integrationData.progressBar.currentGoal.index)+((100/(vm.integrationData.progressBar.goals.length-1))/100*\r\n                                     ((vm.integrationData.progressBar.totalCoinValue-vm.integrationData.progressBar.currentGoal.amount)*100)/\r\n                                     (vm.integrationData.progressBar.currentGoal.nextGoalAmount-vm.integrationData.progressBar.currentGoal.amount))+\'%\',\r\n                                     transition: \'width \'+vm.integrationData.progressBar.goals.length*300+\'ms linear\'}\">\n</div><div class=\"current-amount\" style=\"left: 0\" \nng-style=\"{left: (100-100/(vm.integrationData.progressBar.goals.length-1))*\r\n                                     (vm.integrationData.progressBar.currentGoal.index)+((100/(vm.integrationData.progressBar.goals.length-1))/100*\r\n                                     ((vm.integrationData.progressBar.totalCoinValue-vm.integrationData.progressBar.currentGoal.amount)*100)/\r\n                                     (vm.integrationData.progressBar.currentGoal.nextGoalAmount-vm.integrationData.progressBar.currentGoal.amount))+\'%\',\r\n                                     transition: \'all \'+vm.integrationData.progressBar.goals.length*300+\'ms linear\'}\">\n<span>{{vm.integrationData.progressBar.totalCoinValue | number : 3}} {{vm.integrationData.progressBar.baseCurrency}}\n</span></div></div><ul class=\"progress-bar\"><li ng-repeat=\"(key, goal) in vm.integrationData.progressBar.goals\" \nclass=\"section\" \nng-style=\"{width: 100/vm.integrationData.progressBar.goals.length+\'%\', transition: \'all \'+key*700+\'ms linear\'}\" \nng-class=\"{visited: goal.passed, current: goal.current}\"><span class=\"goal-title\">{{goal.title}}</span> <span \nclass=\"goal-amount\">{{goal.amount>0?(goal.amount | number)+\' \'+vm.integrationData.progressBar.baseCurrency:\'\'}}</span>\n</li></ul></div><div class=\"wallet form-wrapper md-whiteframe-1dp center\"><div class=\"current-balance\"><span \nclass=\"title\">Current balance:</span> <span class=\"amount\">\n{{vm.accountData.tokensBalance?(vm.accountData.tokensBalance | number : 3):0}} {{vm.site.tokenName}}</span> <span \nclass=\"hint\" ng-show=\"vm.accountData.ether_address\">Your tokens will be sent to <b>{{vm.accountData.ether_address}}</b>\n </span><span class=\"hint\" ng-hide=\"vm.accountData.ether_address\">\nYou need to set up your ERC20 compatible address on settings tab</span></div><div class=\"disclaimer\"><span>\nYou must use ERC20 compatible wallet. Please see this video for instructions:</span><iframe class=\"video-iframe\" \nsrc=\"https://www.youtube.com/embed/phht73IvUDI\" frameborder=\"0\" allow=\"encrypted-media\" allowfullscreen></iframe></div>\n</div></md-tab></md-tabs></div></div>");
$templateCache.put("app/core/directives/ms-info-bar/ms-info-bar.html","<div id=\"ms-info-bar\" layout=\"row\" layout-align=\"start center\" flex><div id=\"ms-info-bar-message\" ng-transclude flex>\n</div><md-button id=\"ms-info-bar-close\" class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"removeInfoBar()\"><md-icon \nmd-font-icon=\"icon-close s24\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/ms-shortcuts/ms-shortcuts.html","<div class=\"shortcuts-container\" layout=\"row\" layout-align=\"space-between center\" flex \nng-class=\"{\'mobile-bar-active\': MsShortcuts.mobileBarActive}\"><div class=\"flex-noshrink\" layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"shortcuts hide show-gt-xs\" layout=\"row\" layout-align=\"start center\" \nms-scroll ng-if=\"MsShortcuts.shortcuts.length > 0\" ng-sortable=\"MsShortcuts.sortableOptions\"><div \nng-repeat=\"shortcut in MsShortcuts.shortcuts\" layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-icon-button shortcut\" aria-label=\"{{shortcut.title}}\" ui-sref=\"{{shortcut.uisref}}\"><md-icon \nng-if=\"shortcut.icon\" md-font-icon=\"{{shortcut.icon}}\" class=\"icon s24\"></md-icon><div ng-if=\"!shortcut.icon\" \nclass=\"first-letter\">{{shortcut.title.charAt(0)}}</div><md-tooltip md-direction=\"bottom\">{{shortcut.title}}\n</md-tooltip></md-button></div></div><md-menu md-offset=\"8 56\" class=\"shortcut-menu hide show-gt-xs\"><md-button \nclass=\"md-icon-button add-shortcut-button\" aria-label=\"Add shortcut\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-menu-origin md-font-icon=\"icon-star\" class=\"icon amber-600-fg s24\"></md-icon><md-tooltip md-direction=\"bottom\">\nClick to add/remove shortcut</md-tooltip></md-button><md-menu-content><div id=\"ms-shortcut-add-menu\"><div \nclass=\"shortcut-search\" layout=\"row\" layout-align=\"start center\"><div class=\"search-icon\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!MsShortcuts.resultsLoading\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon></div><div class=\"shortcut-loader\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"MsShortcuts.resultsLoading\"><md-progress-circular class=\"md-accent\" \nmd-diameter=\"20\" md-mode=\"indeterminate\"></md-progress-circular></div><input type=\"text\" placeholder=\"Search\" flex \nng-model=\"MsShortcuts.query\" ng-model-options=\"MsShortcuts.queryOptions\" \nng-keydown=\"MsShortcuts.handleKeydown($event)\"></div><div class=\"results\" ng-if=\"MsShortcuts.results\" ms-scroll><div \nclass=\"no-results\" ng-if=\"MsShortcuts.results.length === 0\">No Results!</div><div class=\"result\" \nng-repeat=\"result in MsShortcuts.results\" ng-click=\"MsShortcuts.handleResultClick(result)\" \nng-mouseenter=\"MsShortcuts.handleMouseenter($index)\" ng-mousedown=\"MsShortcuts.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsShortcuts.selectedResultIndex}\" md-prevent-menu-close=\"md-prevent-menu-close\" \nmd-ink-ripple><div layout=\"row\" layout-align=\"start space-between\"><div layout=\"row\" layout-align=\"start center\" flex>\n<div class=\"icon icon-container\" layout=\"row\" layout-align=\"center center\"><i ng-if=\"result.icon\" \nclass=\"{{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div><div><div class=\"title\">\n{{result.title}}</div></div></div><md-icon md-font-icon=\"icon-pin\" class=\"icon s18\" \nng-class=\"{\'fade-text\': !result.hasShortcut}\"></md-icon></div></div></div></div></md-menu-content></md-menu></div>\n<md-button class=\"md-icon-button toggle-mobile-menu hide-gt-xs\" aria-label=\"Add shortcut\" \nng-click=\"MsShortcuts.toggleMobileBar()\"><md-icon md-menu-origin md-font-icon=\"icon-star\" \nclass=\"icon amber-600-fg s24\" ng-hide=\"MsShortcuts.mobileBarActive\"></md-icon><md-icon md-menu-origin \nmd-font-icon=\"icon-close\" class=\"icon s24\" ng-hide=\"!MsShortcuts.mobileBarActive\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-button \nclass=\"ms-search-bar-expander md-icon-button\" aria-label=\"Expand Search Bar\" ng-click=\"MsSearchBar.expand()\" \nng-if=\"!MsSearchBar.resultsLoading || MsSearchBar.collapsed\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\">\n</md-icon></md-button><div class=\"ms-search-bar-loader\" layout=\"row\" layout-align=\"center center\" \nng-if=\"MsSearchBar.resultsLoading && !MsSearchBar.collapsed\"><md-progress-circular class=\"md-accent\" md-diameter=\"32\" \nmd-mode=\"indeterminate\"></md-progress-circular></div></label><input id=\"ms-search-bar-input\" type=\"text\" \nplaceholder=\"Search\" flex ng-model=\"MsSearchBar.query\" ng-model-options=\"MsSearchBar.queryOptions\" \nng-blur=\"MsSearchBar.collapse()\" ng-keydown=\"MsSearchBar.handleKeydown($event)\"><md-button \nclass=\"ms-search-bar-collapser md-icon-button\" ng-click=\"MsSearchBar.collapse()\" aria-label=\"Collapse Search Bar\">\n<md-icon md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></md-button><div class=\"ms-search-bar-results\" \nng-if=\"MsSearchBar.results\" ms-scroll><div class=\"no-results\" ng-if=\"MsSearchBar.results.length === 0\">No Results!\n</div><div class=\"result\" ng-repeat=\"result in MsSearchBar.results\" ng-click=\"MsSearchBar.handleResultClick(result)\" \nng-mouseenter=\"MsSearchBar.handleMouseenter($index)\" ng-mousedown=\"MsSearchBar.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsSearchBar.selectedResultIndex}\" md-ink-ripple><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"icon-container\" layout=\"row\" layout-align=\"center center\"><i \nng-if=\"result.icon\" class=\"icon {{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div>\n<div><div class=\"title\">{{result.title}}</div><div class=\"description\" ng-if=\"result.description\">\n{{result.description}}</div></div></div></div></div></div>");
$templateCache.put("app/core/directives/ms-material-color-picker/ms-material-color-picker.html","<md-menu md-position-mode=\"target-right target\"><div ng-click=\"$mdOpenMenu($event)\"><ms-color-picker-button><md-button \naria-label=\"Row Color\" md-menu-origin ng-click=\"$mdOpenMenu($event)\" ng-class=\"vm.selectedColor.class\"><span \nng-show=\"vm.selectedColor.palette\">{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span \nng-show=\"!vm.selectedColor.palette\">Select Color</span></md-button></ms-color-picker-button></div><md-menu-content \nclass=\"ms-material-color-picker-menu-content\" layout-column><header \nng-class=\"vm.selectedColor.class || \'md-accent-bg\'\" class=\"md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button md-prevent-menu-close ng-click=\"vm.activateHueSelection(false,false)\" \nclass=\"md-icon-button\" ng-class=\"{\'hidden\':!vm.selectedPalette}\" aria-label=\"Palette\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"s20\"></md-icon></md-button><span ng-if=\"vm.selectedColor.palette\">\n{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span ng-if=\"!vm.selectedColor.palette\">Select Color\n</span><md-button class=\"remove-color-button md-icon-button\" ng-click=\"vm.removeColor()\" aria-label=\"Remove Color\">\n<md-icon md-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></header><div class=\"colors\" ms-scroll><div \nng-show=\"!vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+palette+\'-500-bg\'\" \nng-repeat=\"(palette, hues) in vm.palettes\" ng-click=\"vm.activateHueSelection(palette,hues)\" layout=\"row\" \nlayout-align=\"start end\" md-prevent-menu-close md-ink-ripple><span class=\"label\">{{palette}}</span></div></div><div \nng-show=\"vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" \nng-class=\"\'md-\'+vm.selectedPalette+\'-\'+hue+\'-bg\'\" ng-repeat=\"(hue, values) in vm.selectedHues\" \nng-click=\"vm.selectColor(vm.selectedPalette,hue)\" layout=\"row\" layout-align=\"start end\" md-ink-ripple><span \nclass=\"label\">{{hue}} </span><i ng-if=\"vm.selectedPalette == vm.selectedColor.palette && hue == vm.selectedColor.hue\" \nclass=\"s16 icon-check\"></i></div></div></div></md-menu-content></md-menu>");
$templateCache.put("app/main/auth/forgot-password/forgot-password.html","<div id=\"forgot-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"forgot-password-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"forgot-password-form\" class=\"md-whiteframe-8dp\"><div \nclass=\"logo\"><span>{{$root.site.name}}</span></div><div class=\"title\" translate=\"FORGOTPASSWORD.TITLE\">\nRecover your password</div><form id=\"forgotPasswordForm\" name=\"forgotPasswordForm\" novalidate><md-input-container \nclass=\"md-block\" md-no-float><input type=\"email\" name=\"email\" ng-model=\"vm.form.email\" placeholder=\"Email address\" \ntranslate translate-attr-placeholder=\"FORGOTPASSWORD.EMAIL_ADRESS\" ng-pattern=\"/^.+@.+\\..+$/\" required><div \nng-messages=\"forgotPasswordForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"FORGOTPASSWORD.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div ng-message=\"pattern\"><span \ntranslate=\"FORGOTPASSWORD.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div></div>\n</md-input-container><md-button type=\"submit\" class=\"md-raised md-accent submit-button promise-button\" \naria-label=\"RESET MY PASSWORD\" ng-attr-data-loading=\"{{vm.dataLoading}}\" \ntranslate-attr-aria-label=\"FORGOTPASSWORD.SEND_RESET_LINK\" \nng-disabled=\"forgotPasswordForm.$invalid || forgotPasswordForm.$pristine || vm.dataLoading\" \nng-click=\"vm.passwordRecoveryRequest($event)\"><span class=\"promise-button-label\" \ntranslate=\"FORGOTPASSWORD.SEND_RESET_LINK\">SEND RESET LINK</span><md-progress-circular class=\"md-accent\" \nmd-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular></md-button></form><div class=\"login\" layout=\"row\" \nlayout-align=\"center center\"><a class=\"link\" ui-sref=\"app.login\" translate=\"FORGOTPASSWORD.GO_BACK\">Go back to login\n</a></div></div></div></div>");
$templateCache.put("app/main/auth/login/login.html","<div id=\"login\" layout=\"row\" layout-align=\"start\"><div id=\"login-intro\" flex hide show-gt-sm><div \nclass=\"intro-description\">Token Sale</div></div><div id=\"login-form-wrapper\" class=\"flex-scrollable md-whiteframe-8dp\" \nms-scroll><div class=\"disclaimer\">The Token Sale is Open to <b>Non US Residents Only</b>.</div><div id=\"login-form\">\n<div class=\"logo\" hide-gt-sm><span>{{$root.site.name}}</span></div><div class=\"title\" translate=\"LOGIN.TITLE\">\nLog in to your account</div><div class=\"description\" translate=\"LOGIN.DESCRIPTION\">Please make sure you at <a \nhref=\"https://tokensale.ceek.io\">https://tokensale.ceek.io</a></div><form name=\"loginForm\" id=\"loginForm\" \nng-submit=\"vm.login($event)\"><div class=\"absolute-container\" ng-class=\"{\'two-factor\': vm.twoFactor}\"><div \nng-hide=\"vm.twoFactor\" class=\"auth-animate\"><md-input-container class=\"md-block\" md-no-float><label \ntranslate=\"LOGIN.EMAIL\">Email</label><input type=\"email\" name=\"email\" ng-model=\"vm.form.email\" \nng-pattern=\"/^.+@.+\\..+$/\" required><div ng-messages=\"loginForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span translate=\"LOGIN.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div \nng-message=\"pattern\"><span translate=\"LOGIN.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div>\n</div></md-input-container><md-input-container class=\"md-block\" md-no-float><label translate=\"LOGIN.PASSWORD\">Password\n</label><input type=\"password\" name=\"password\" ng-model=\"vm.form.password\" required autocomplete=\"new-password\"><div \nng-messages=\"loginForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"LOGIN.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div></div></md-input-container><div \nclass=\"remember-forgot-password\" layout=\"row\" layout-xs=\"column\" layout-align=\"space-between center\"><span></span> <a \nui-sref=\"app.forgot-password\" class=\"forgot-password md-accent-color\" translate=\"LOGIN.FORGOT_PASSWORD\">\nForgot Password?</a></div><div class=\"grecaptcha\" ng-if=\"vm.clientCountry != \'CN\' && site.isCaptchaEnabled\" \nvc-recaptcha key=\"vm.recaptcha.key\" on-create=\"vm.setWidgetId(widgetId)\"></div></div><div ng-if=\"vm.twoFactor\" \nclass=\"auth-animate\"><md-input-container class=\"md-block\" md-no-float><label>Google authenticator code</label><input \ntype=\"text\" name=\"code\" ng-model=\"vm.form.code\" ng-maxlength=\"6\" ng-minlength=\"6\" required><div \nng-messages=\"loginForm.code.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"LOGIN.ERRORS.CODE_REQUIRED\">Google authenticator code is required</span></div><div \nng-message=\"maxlength, minlength\"><span translate=\"LOGIN.ERRORS.CODE_LENGTH\">Code must be exactly 6 characters long\n</span></div></div></md-input-container></div></div><div class=\"error-messages\"><div \nng-repeat=\"message in vm.errorMessages\">{{message}}</div></div><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button promise-button\" aria-label=\"LOG IN\" ng-attr-data-loading=\"{{vm.dataLoading}}\" \nng-disabled=\"loginForm.$invalid || vm.dataLoading\" translate-attr-aria-label=\"LOGIN.LOG_IN\"><span \nclass=\"promise-button-label\" translate=\"LOGIN.LOG_IN\">LOG IN</span><md-progress-circular class=\"md-accent\" \nmd-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular></md-button></form><div ng-if=\"vm.signup_enabled\"><div \nclass=\"separator\"><span class=\"text\" translate=\"LOGIN.OR\">OR</span></div><md-button \nclass=\"md-raised md-accent register-button\" aria-label=\"Create new account\" ui-sref=\"app.register\"><span \nclass=\"promise-button-label\">Create new account</span></md-button></div></div></div></div>");
$templateCache.put("app/main/auth/register/register.html","<div id=\"register\" layout=\"row\" layout-align=\"start\"><div id=\"register-intro\" flex hide show-gt-sm><div \nclass=\"intro-description\">Token Sale</div></div><div id=\"register-form-wrapper\" \nclass=\"flex-scrollable md-whiteframe-8dp\" layout=\"column\" flex ms-scroll><div class=\"disclaimer\">\nThe Token Sale is Open to <b>Non US Residents Only</b>.</div><div id=\"register-form\"><div class=\"logo\" hide-gt-sm>\n<span>{{$root.site.name}}</span></div><div class=\"title\" translate=\"REGISTER.TITLE\">Create an account</div><div \nclass=\"description\"><span class=\"text\" translate=\"REGISTER.ALREADY_HAVE\">Already have an account?</span> <a \nclass=\"link\" ui-sref=\"app.login\" translate=\"REGISTER.LOGIN\">Log in</a></div><form name=\"registerForm\" \nid=\"registerForm\" ng-submit=\"vm.signup($event)\" novalidate><md-input-container class=\"md-block\" md-no-float><label \ntranslate=\"REGISTER.FIRST_NAME\">First name</label><input name=\"name\" ng-model=\"vm.form.name\" required><div \nng-messages=\"registerForm.name.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"REGISTER.ERRORS.FIRST_NAME_REQUIRED\">First name field is required</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" md-no-float><label translate=\"REGISTER.LAST_NAME\">Last name</label><input \nname=\"surname\" ng-model=\"vm.form.surname\" required><div ng-messages=\"registerForm.surname.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"REGISTER.ERRORS.LAST_NAME_REQUIRED\">Last name field is required</span></div>\n</div></md-input-container><md-input-container class=\"md-block\" md-no-float><label translate=\"REGISTER.EMAIL\">Email\n</label><input type=\"email\" name=\"email\" ng-model=\"vm.form.email\" ng-pattern=\"/^.+@.+\\..+$/\" required><div \nng-messages=\"registerForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"REGISTER.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div ng-message=\"pattern\"><span \ntranslate=\"REGISTER.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div></div>\n</md-input-container><md-input-container class=\"md-block\" md-no-float><label translate=\"REGISTER.PASSWORD\">Password\n</label><input type=\"password\" name=\"password\" ng-model=\"vm.form.password\" required><div \nng-messages=\"registerForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"REGISTER.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" md-no-float><label translate=\"REGISTER.PASSWORD_CONFIRM\">Password (Confirm)\n</label><input type=\"password\" name=\"password_confirm\" ng-model=\"vm.form.password_confirm\" required><div \nng-messages=\"registerForm.password_confirm.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"REGISTER.ERRORS.PASSWORD_CONFIRM_REQUIRED\">Password (Confirm) field is required</span></div></div>\n</md-input-container><div class=\"error-messages\"><div ng-repeat=\"message in vm.errorMessages\">{{message}}</div></div>\n<div class=\"terms\" layout=\"row\" layout-align=\"center center\"><md-checkbox name=\"terms\" ng-model=\"data.cb1\" \naria-label=\"I read and accept\" required></md-checkbox><div layout=\"row\" layout-sm=\"column\" layout-align=\"start center\">\n<span translate=\"REGISTER.READ_ACCEPT\">I read and accept</span> <a href=\"api/CGI_Privacy_Terms_V2.html\" \ntarget=\"_blank\" class=\"md-accent-color\" translate=\"REGISTER.TERMS_COND\">terms and conditions</a></div></div><div \nclass=\"grecaptcha\" ng-if=\"vm.clientCountry != \'CN\' && site.isCaptchaEnabled\" vc-recaptcha key=\"vm.recaptcha.key\" \non-create=\"vm.setWidgetId(widgetId)\"></div><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button promise-button\" aria-label=\"CREATE MY ACCOUNT\" \nng-attr-data-loading=\"{{vm.dataLoading}}\" \nng-disabled=\"registerForm.$invalid || registerForm.$pristine || vm.dataLoading\" \ntranslate-attr-aria-label=\"REGISTER.CREATE_ACCOUNT\"><span class=\"promise-button-label\" \ntranslate=\"REGISTER.CREATE_ACCOUNT\">CREATE MY ACCOUNT</span><md-progress-circular class=\"md-accent\" \nmd-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular></md-button></form><div class=\"separator\"><span \nclass=\"text\" translate=\"LOGIN.OR\">OR</span></div><md-button class=\"md-raised md-accent login-button\" \naria-label=\"Log in\" ui-sref=\"app.login\"><span class=\"promise-button-label\">Log in</span></md-button></div></div></div>");
$templateCache.put("app/main/auth/reset-password/reset-password.html","<div id=\"reset-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"reset-password-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"reset-password-form\" class=\"md-whiteframe-8dp\"><div class=\"logo\">\n<span>{{$root.site.name}}</span></div><div class=\"title\" translate=\"RESETPASSWORD.TITLE\">Reset your password</div><form\n id=\"resetPasswordForm\" name=\"resetPasswordForm\" novalidate><md-input-container class=\"md-block\" md-no-float><input \ntype=\"password\" name=\"new_password\" ng-model=\"vm.form.password\" placeholder=\"Password\" translate \ntranslate-attr-placeholder=\"RESETPASSWORD.PASSWORD\" required><div ng-messages=\"registerForm.password.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"RESETPASSWORD.ERRORS.PASSWORD_REQUIRED\">\nPassword field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float>\n<input type=\"password\" name=\"new_password_confirm\" ng-model=\"vm.form.passwordConfirm\" placeholder=\"Password (Confirm)\" \ntranslate translate-attr-placeholder=\"RESETPASSWORD.PASSWORD_CONFIRM\" required><div \nng-messages=\"resetPasswordForm.passwordConfirm.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"RESETPASSWORD.ERRORS.PASSWORD_CONFIRM_REQUIRED\">Password (Confirm) field is required</span></div></div>\n</md-input-container><md-button type=\"submit\" class=\"md-raised md-accent submit-button promise-button\" \naria-label=\"UPDATE MY PASSWORD\" ng-attr-data-loading=\"{{vm.dataLoading}}\" \nng-disabled=\"resetPasswordForm.$invalid || resetPasswordForm.$pristine || vm.dataLoading\" \ntranslate-attr-aria-label=\"RESETPASSWORD.UPDATE_PASSWORD\" ng-click=\"vm.passwordRecoveryForm($event)\"><span \nclass=\"promise-button-label\" translate=\"RESETPASSWORD.UPDATE_PASSWORD\">RESET MY PASSWORD</span><md-progress-circular \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular></md-button></form></div></div></div>");
$templateCache.put("app/main/account/balance/account-balance.html","<div id=\"account-balance\" class=\"page-layout fullwidth\" layout=\"row\"><div class=\"top-bg\"><div class=\"header\"><div \nclass=\"md-display-1 font-weight-300 white-fg\"><span>My Balance</span></div></div></div><div class=\"center\" \nlayout=\"column\" flex><div class=\"content-card md-whiteframe-1dp\"><div class=\"content\"><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Invested\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Bonus</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Total</span></div></th><th \nclass=\"secondary-text\"></th></tr></thead><tbody><tr ng-repeat=\"(key, balance) in vm.balanceData\"><td class=\"title\"><i \nng-class=\"[\'cryptoicon-{{key}}\', \'cryptoicon-{{key}}-bg\']\"></i> <span hide-xs>{{balance.title}}</span></td><td>\n{{balance.invested}}</td><td>{{balance.bonus}}</td><td>{{balance.invested + balance.bonus}}</td><td><md-button \nui-sref=\"app.deposit\" class=\"md-raised invest-now\" aria-label=\"Invest now\">Invest now!</md-button></td></tr></tbody>\n</table></div></div></div></div>");
$templateCache.put("app/navigation/layouts/horizontal-navigation/navigation.html","<div layout=\"row\" layout-align=\"start center\"><ms-navigation-horizontal></ms-navigation-horizontal></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation/navigation.html","<md-toolbar class=\"navigation-header md-whiteframe-1dp\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">{{site.shortName}}</span> <span \nclass=\"logo-text\">{{$root.site.name}}</span></div><md-icon class=\"fold-toggle s18\" md-font-icon=\"icon-backburger\" hide \nshow-gt-sm ng-click=\"vm.toggleMsNavigationFolded()\"></md-icon></md-toolbar><ms-navigation class=\"scrollable\" \nfolded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html","<ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/toolbar/layouts/horizontal-navigation/toolbar.html","<div class=\"top-row\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">{{site.shortName}}</span> <span class=\"logo-text\">\n{{$root.site.name}}</span></div></div><div layout=\"row\" layout-align=\"start center\"><md-progress-circular \nid=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\">\n</md-progress-circular><ms-shortcuts></ms-shortcuts><md-menu-bar id=\"user-menu\"><md-menu \nmd-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdMenu.open()\" aria-label=\"User settings\" \ntranslate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Smith</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.user-info\"><md-icon md-font-icon=\"icon-gear\" class=\"icon\"></md-icon><md-button>Profile settings\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.transaction-history\"><md-icon \nmd-font-icon=\"icon-view-list\" class=\"icon\"></md-icon><md-button>Transactions</md-button></md-menu-item>\n<md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\">\n</md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar>\n<md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" \nng-click=\"$mdMenu.open()\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" \nlayout-align=\"center center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span \nclass=\"iso\">{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n</div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><ms-shortcuts></ms-shortcuts><div \nclass=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\"><md-progress-circular \nid=\"toolbar-progress\" ng-disabled=\"!$root.loadingProgress\" class=\"md-accent\" md-diameter=\"32\"></md-progress-circular>\n<md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nng-click=\"$mdMenu.open()\" aria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide \nshow-gt-sm>John Smith</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs></md-icon></div>\n</md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.user-info\"><md-icon \nmd-font-icon=\"icon-gear\" class=\"icon\"></md-icon><md-button>Profile settings</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\" ui-sref=\"app.transaction-history\"><md-icon md-font-icon=\"icon-view-list\" class=\"icon\"></md-icon>\n<md-button>Transactions</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\">\n<md-icon md-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button>\n</md-menu-item></md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><md-menu \nid=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" \nng-click=\"$mdMenu.open()\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" \nlayout-align=\"center center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span \nclass=\"iso\">{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n</div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"toolbar-separator\"></div><ms-shortcuts>\n</ms-shortcuts><div class=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"32\"></md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdMenu.open()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Smith</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.user-info\"><md-icon md-font-icon=\"icon-gear\" class=\"icon\"></md-icon><md-button>Profile settings\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.transaction-history\"><md-icon \nmd-font-icon=\"icon-view-list\" class=\"icon\"></md-icon><md-button>Transactions</md-button></md-menu-item>\n<md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\">\n</md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar>\n<div class=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" \nmd-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdMenu.open()\" \naria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" layout-align=\"center center\"><img \nclass=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">\n{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n</div></div>");
$templateCache.put("app/toolbar/layouts/content-with-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">{{site.shortName}}</span> <span class=\"logo-text\">\n{{$root.site.name}}</span></div><div class=\"toolbar-separator\"></div><ms-shortcuts></ms-shortcuts><div \nclass=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\"><md-progress-circular \nid=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\">\n</md-progress-circular><div class=\"toolbar-separator\"></div><md-menu-bar id=\"user-menu\"><md-menu \nmd-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdMenu.open()\" aria-label=\"User settings\" \ntranslate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Smith</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.user-info\"><md-icon md-font-icon=\"icon-gear\" class=\"icon\"></md-icon><md-button>Profile settings\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.transaction-history\"><md-icon \nmd-font-icon=\"icon-view-list\" class=\"icon\"></md-icon><md-button>Transactions</md-button></md-menu-item>\n<md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\">\n</md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar>\n<div class=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" \nmd-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdMenu.open()\" \naria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" layout-align=\"center center\"><img \nclass=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">\n{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n</div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><div class=\"logo\" \nlayout=\"row\" layout-align=\"center center\"><i hide-xs class=\"logo-image-full\"></i> <i hide-gt-xs \nclass=\"logo-image-short\"></i></div><md-button id=\"navigation-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><md-button class=\"md-icon-button navigation-fold-toggle\" hide show-gt-sm \naria-label=\"Toggle navigation fold\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION_FOLD\" \nng-click=\"vm.toggleMsNavigationFolded()\"><md-icon class=\"s18\" md-font-icon=\"icon-backburger\"></md-icon></md-button>\n</div><div layout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" \nng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular><div \nclass=\"kyc-status\" ng-click=\"vm.showKycDialog()\"><span \nng-class=\"\'badge-\'+vm.kycStatusBadges[(user.kyc_status?user.kyc_status:0)]\">\nKYC {{vm.kycStatuses[(user.kyc_status?user.kyc_status:0)]}}</span></div><md-menu-bar id=\"user-menu\"><md-menu \nmd-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdMenu.open()\" aria-label=\"User settings\" \ntranslate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nng-src=\"https://www.gravatar.com/avatar/{{user.gravatar}}?s=40&d=identicon\"></div><span class=\"username\" hide-xs>\n{{user.name?user.name:user.email}}</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\"></md-icon></div>\n</md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.user-info\"><md-icon \nmd-font-icon=\"icon-gear\" class=\"icon\"></md-icon><md-button>Profile settings</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\" ui-sref=\"app.wallet\"><md-icon md-font-icon=\"icon-cash-multiple\" class=\"icon\"></md-icon><md-button>\nWallet</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.transaction-history\"><md-icon \nmd-font-icon=\"icon-view-list\" class=\"icon\"></md-icon><md-button>Transactions</md-button></md-menu-item><md-menu-item \nng-if=\"user.show_kyc\" class=\"md-indent\" ng-click=\"vm.showKycDialog()\"><md-icon md-font-icon=\"icon-file-document-box\" \nclass=\"icon\"></md-icon><md-button>KYC</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item \nclass=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout\n</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar></div></div>");
$templateCache.put("app/toolbar/dialogs/kyc/kyc-dialog.html","<md-dialog aria-label=\"Identification form (KYC)\" id=\"kyc-dialog\"><div class=\"dialog-container\" flex ng-cloak \nng-if=\"$root.user.show_kyc\"><md-toolbar><div class=\"md-toolbar-tools\"><h3>Identification form (KYC)</h3><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"kyc\"><form id=\"kycForm\" \nname=\"kycForm\"><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm><label>First name</label><input \nname=\"name\" ng-model=\"$root.user.name\" required></md-input-container><md-input-container class=\"md-block\" flex-gt-sm>\n<label>Last Name</label><input name=\"surname\" ng-model=\"$root.user.surname\" required></md-input-container></div><div \nlayout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm><label>Address</label><input name=\"address_1\" \nng-model=\"vm.kyc.address_1\" required autocomplete=\"off\"></md-input-container><md-input-container md-no-float \nclass=\"md-block\" flex-gt-sm autocomplete=\"off\"><label>Address 2</label><input name=\"address_2\" \nng-model=\"vm.kyc.address_2\"></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" \nflex-gt-sm><label>Country</label><md-select name=\"country_code\" ng-model=\"vm.kyc.country_code\" required><md-option \nng-repeat=\"country in vm.countries\" value=\"{{country.code}}\">{{country.name}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm><label>City</label><input name=\"city\" \nng-model=\"vm.kyc.city\" required autocomplete=\"off\"></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm><label>Postal Code</label><input name=\"postal_code\" ng-model=\"vm.kyc.postal_code\" placeholder=\"12345\" \nrequired autocomplete=\"off\"></md-input-container></div><div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" \nflex-gt-xs><label>Mobile phone</label><input name=\"mobile_phone\" ng-model=\"vm.kyc.mobile_phone\"></md-input-container>\n</div><div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex-gt-xs><label>ID or passport number</label>\n<input name=\"passport\" ng-model=\"vm.kyc.passport\" required autocomplete=\"off\"></md-input-container><md-input-container>\n<label>Birth date</label><md-datepicker name=\"date_of_birth\" ng-model=\"vm.kyc.date_of_birth\" \nmd-max-date=\"vm.max_date_of_birth\" required></md-datepicker></md-input-container></div><ms-choose-file layout=\"row\" \nflex-gt-sm><input id=\"passport\" type=\"file\" accept=\"image/*\" ms-change=\"vm.validateFile\" class=\"ng-hide\" \ndata-hidden-file-input=\"1\" required><md-input-container flex class=\"md-block\" \nng-class=\"{\'md-input-invalid\': vm.fileError.passport}\"><label>ID or passport</label><input type=\"text\" \nname=\"passort_file\" ng-model=\"passport_fileName\" disabled=\"disabled\" required><div class=\"hint\">Photo or scan</div>\n</md-input-container><div><md-button class=\"md-raised button\" aria-label=\"Browse\">Browse</md-button></div>\n</ms-choose-file><ms-choose-file layout=\"row\" flex-gt-sm><input id=\"photo_holding_passport\" type=\"file\" \naccept=\"image/*\" ms-change=\"vm.validateFile\" class=\"ng-hide\" data-hidden-file-input=\"1\" required><md-input-container \nflex class=\"md-block\" ng-class=\"{\'md-input-invalid\': vm.fileError.photo_holding_passport}\"><label>Selfie</label><input \ntype=\"text\" name=\"photo_holding_passport_file\" ng-model=\"photo_holding_passport_fileName\" disabled=\"disabled\" required>\n<div class=\"hint\">Photo of you holding passport / id</div></md-input-container><div><md-button \nclass=\"md-raised button\" aria-label=\"Browse\">Browse</md-button></div></ms-choose-file><ms-choose-file layout=\"row\" \nflex-gt-sm><input id=\"por\" type=\"file\" accept=\"image/*\" ms-change=\"vm.validateFile\" class=\"ng-hide\" \ndata-hidden-file-input=\"1\" required><md-input-container flex class=\"md-block\" \nng-class=\"{\'md-input-invalid\': vm.fileError.por}\"><label>Proof of residency</label><input type=\"text\" name=\"por_file\" \nng-model=\"por_fileName\" disabled=\"disabled\" required><div class=\"hint\">E.g. utility bill</div></md-input-container>\n<div><md-button class=\"md-raised button\" aria-label=\"Browse\">Browse</md-button></div></ms-choose-file><span \nclass=\"hint\" \nng-class=\"{\'wrong-file\': (vm.fileError.passport || vm.fileError.por || vm.fileError.photo_holding_passport)}\">\nPlease upload files up to 15MB in JPEG or PNG format.</span></form></md-dialog-content><md-dialog-actions layout=\"row\">\n<md-button class=\"md-raised md-warn promise-button\" aria-label=\"Cancel\" ng-attr-data-loading=\"{{vm.dataLoading.kyc}}\" \nng-disabled=\"vm.dataLoading.kyc\" ng-click=\"vm.closeDialog()\"><span class=\"promise-button-label\">Cancel</span>\n<md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular></md-button>\n<span flex></span><md-button type=\"submit\" class=\"md-raised md-accent promise-button\" aria-label=\"Submit to KYC\" \nng-attr-data-loading=\"{{vm.dataLoading.kyc}}\" \nng-disabled=\"\r\n                       kycForm.$invalid ||\r\n                       kycForm.$pristine ||\r\n                       vm.dataLoading.kyc ||\r\n                       vm.fileError.passport ||\r\n                       vm.fileError.por ||\r\n                       vm.fileError.photo_holding_passport\" \nng-click=\"vm.kyc($event)\"><span class=\"promise-button-label\">Submit to KYC</span><md-progress-circular \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular></md-button></md-dialog-actions>\n</div><div class=\"dialog-container\" flex ng-cloak ng-if=\"$root.user.show_kyc == false && !$root.user.ether_address\">\n<md-toolbar><div class=\"md-toolbar-tools\"><h3>Ethereum Address</h3></div></md-toolbar><md-dialog-content><form \nid=\"ethAddressForm\" name=\"ethAddressForm\"><md-input-container class=\"md-block\" flex-gt-sm><label>Your ethereum address\n</label><input type=\"text\" required ng-model=\"vm.ether_address\" ng-pattern=\"/^(0x)?[0-9a-fA-F]{40}$/\" \nname=\"ether_address\"><div ng-messages=\"ethAddressForm.ether_address.$error\"><div ng-message=\"required\">\nA valid ethereum address is required</div><div ng-message=\"pattern\">Please enter a valid ethereum address</div></div>\n<div class=\"hint\">Don\'t have an Ethereum wallet yet? Click <a href=\"https://www.myetherwallet.com/\" target=\"_blank\">\nhere</a> to get started!</div></md-input-container></form></md-dialog-content><md-dialog-actions layout=\"row\"><span \nflex></span><md-button type=\"submit\" class=\"md-raised md-accent promise-button\" aria-label=\"Finish Setup\" \nng-attr-data-loading=\"{{vm.dataLoading.saveEtherAddress}}\" \nng-disabled=\"ethAddressForm.$invalid || ethAddressForm.$pristine || vm.dataLoading.saveEtherAddress\" \nng-click=\"vm.saveEtherAddress($event)\"><span class=\"promise-button-label\">Finish Setup</span><md-progress-circular \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular></md-button></md-dialog-actions>\n</div></md-dialog>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul \nclass=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" \nng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script \ntype=\"text/ng-template\" id=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\">\r\n\r\n        <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\"\r\n             ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\">\r\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\r\n        </div>\r\n\r\n        <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\r\n           ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\"\r\n           ng-if=\"node.uisref && node.title\">\r\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\r\n        </a>\r\n\r\n    </div>\r\n\r\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\r\n        <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\"\r\n            ng-class=\"{\'has-children\': vm.hasChildren}\"\r\n            ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\r\n    </ul>\n</script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<div class=\"navigation-container\"><ul flex=\"grow\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" \nng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul>\n</div><script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\">\r\n\r\n        <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title\">\r\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\r\n        </div>\r\n\r\n        <a class=\"ms-navigation-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\r\n           ng-if=\"node.uisref && node.title\">\r\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\r\n        </a>\r\n\r\n    </div>\r\n\r\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\r\n        <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\"\r\n            ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\"\r\n            ng-include=\"\'navigation-nested.html\'\"></li>\r\n    </ul>\n</script>");
$templateCache.put("app/main/deposit/dialogs/initial/initial-dialog.html","<md-dialog aria-label=\"Citizenship confirmation\" id=\"initial-dialog\"><div class=\"dialog-container\" flex ng-cloak \nng-if=\"!$root.user.is_citizenship_allowed\"><md-toolbar><div class=\"md-toolbar-tools\"><h3>Citizenship confirmation</h3>\n</div></md-toolbar><md-dialog-content ng-if=\"!vm.citizenshipDisallowed\"><h3>\nAre you a United States citizen or are you holding a passport issued by United States?</h3><div class=\"p-14\" \nlayout=\"row\" layout-align=\"center center\"><md-button type=\"submit\" class=\"md-raised md-accent promise-button\" \naria-label=\"No\" ng-attr-data-loading=\"{{vm.dataLoading.citizenshipAllowed}}\" \nng-disabled=\"vm.dataLoading.citizenshipAllowed\" ng-click=\"vm.citizenshipAllowed($event)\"><span \nclass=\"promise-button-label\">No</span><md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\">\n</md-progress-circular></md-button><md-button class=\"md-raised md-accent promise-button\" aria-label=\"Yes\" \nng-click=\"vm.citizenshipDisallowed = true\">Yes</md-button></div></md-dialog-content><md-dialog-content \nng-if=\"vm.citizenshipDisallowed\"><div class=\"blocked-access\"><h3 class=\"warning\">Blocked Access Country/Region</h3><p>\nSorry! Currently you are Not Eligible to participate in the Initial Token Sale, since you are accessing it from a Restricted Country/Region.\n<br>\nThe only exceptions are accredited investors who wish to participate in the Private Sale after qualifying based on the following:\n<br><b>Rule 501(a) of Regulation D defines the term \"Accredited Investor\".</b><br>\nIt provides that an Accredited Investor \"shall mean any person who comes within any of the following categories.</p>\nPlease read the following statements and confirm any that apply to you.<ul><li>\nA natural person whose individual net worth* or joint net worth with such person\'s spouse exceeds $1,000,000.</li><li>\nA natural person who had an individual income* in excess of $200,000 in each of the two most recent years and who reasonably expects to have an individual income in excess of $200,000 in the current year or who had joint income** in excess of $300,000 in each of the two most recent years and who reasonably expects to have a joint income in excess of $300,000 in the current year.\n</li><li>\nA corporation, partnership, limited liability company or business trust with total assets in excess of $5,000,000 (not including a corporation, partnership, limited liability company or business trust not formed for the purpose of investing in Units.\n</li><li>\nAn entity, all the equity owners of which are “accredited investors\" within one or more of the above categories (not including any such entity formed for the purpose of investing in Units).\n</li></ul><p><b>ATTENTION:</b>\n If you feel you qualify as an accredited investor that would like to participate in our PRIVATE SALE Please contact us via email: \n<a href=\"mailto:support@ceek.io\" target=\"_top\">support@CEEK.IO</a></p></div><div class=\"p-14\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-raised button\" aria-label=\"Back\" \nng-click=\"vm.citizenshipDisallowed = false\">Back</md-button></div></md-dialog-content></div><div \nclass=\"dialog-container\" flex ng-cloak ng-if=\"$root.user.is_citizenship_allowed && !$root.user.is_terms_accepted\">\n<md-toolbar><div class=\"md-toolbar-tools\"><h3>Terms and Conditions</h3></div></md-toolbar><md-dialog-content \nclass=\"tos\"><form id=\"tosForm\" name=\"tosForm\"><h3>Before you can proceed you must read and accept our <a \nhref=\"api/CGI_Privacy_Terms_V2.html\" target=\"_blank\">Terms & Conditions</a></h3><md-checkbox ng-model=\"vm.tos\" \naria-label=\"I read and accept CGI World Ltd Terms and Conditions\" required><h3>\nI read and accept CGI World Ltd Terms and Conditions</h3></md-checkbox></form></md-dialog-content><md-dialog-actions \nlayout=\"row\"><span flex></span><md-button type=\"submit\" class=\"md-raised md-accent promise-button\" \naria-label=\"Continue\" ng-attr-data-loading=\"{{vm.dataLoading.termsAccepted}}\" \nng-disabled=\"tosForm.$invalid || tosForm.$pristine || vm.dataLoading.termsAccepted\" \nng-click=\"vm.termsAccepted($event)\"><span class=\"promise-button-label\">Continue</span><md-progress-circular \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular></md-button></md-dialog-actions>\n</div><div class=\"dialog-container\" flex ng-cloak \nng-if=\"$root.user.is_terms_accepted && $root.user.show_kyc && !vm.kyc.isSkipped\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h3>Identification form (KYC)</h3><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.kyc.isSkipped = true\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"kyc\"><form id=\"kycForm\" name=\"kycForm\"><div layout-gt-sm=\"row\">\n<md-input-container class=\"md-block\" flex-gt-sm><label>First name</label><input name=\"name\" ng-model=\"$root.user.name\" \nrequired></md-input-container><md-input-container class=\"md-block\" flex-gt-sm><label>Last Name</label><input \nname=\"surname\" ng-model=\"$root.user.surname\" required></md-input-container></div><div layout-gt-sm=\"row\">\n<md-input-container class=\"md-block\" flex-gt-sm><label>Address</label><input name=\"address_1\" \nng-model=\"vm.kyc.address_1\" required autocomplete=\"off\"></md-input-container><md-input-container md-no-float \nclass=\"md-block\" flex-gt-sm autocomplete=\"off\"><label>Address 2</label><input name=\"address_2\" \nng-model=\"vm.kyc.address_2\"></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" \nflex-gt-sm><label>Country</label><md-select name=\"country_code\" ng-model=\"vm.kyc.country_code\" required><md-option \nng-repeat=\"country in vm.countries\" value=\"{{country.code}}\">{{country.name}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm><label>City</label><input name=\"city\" \nng-model=\"vm.kyc.city\" required autocomplete=\"off\"></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm><label>Postal Code</label><input name=\"postal_code\" ng-model=\"vm.kyc.postal_code\" placeholder=\"12345\" \nrequired autocomplete=\"off\"></md-input-container></div><div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" \nflex-gt-xs><label>Mobile phone</label><input name=\"mobile_phone\" ng-model=\"vm.kyc.mobile_phone\"></md-input-container>\n</div><div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex-gt-xs><label>ID or passport number</label>\n<input name=\"passport\" ng-model=\"vm.kyc.passport\" required autocomplete=\"off\"></md-input-container><md-input-container>\n<label>Birth date</label><md-datepicker name=\"date_of_birth\" ng-model=\"vm.kyc.date_of_birth\" \nmd-max-date=\"vm.max_date_of_birth\" required></md-datepicker></md-input-container></div><ms-choose-file layout=\"row\" \nflex-gt-sm><input id=\"passport\" type=\"file\" accept=\"image/*\" ms-change=\"vm.validateFile\" class=\"ng-hide\" \ndata-hidden-file-input=\"1\" required><md-input-container flex class=\"md-block\" \nng-class=\"{\'md-input-invalid\': vm.fileError.passport}\"><label>ID or passport</label><input type=\"text\" \nname=\"passort_file\" ng-model=\"passport_fileName\" disabled=\"disabled\" required><div class=\"hint\">Photo or scan</div>\n</md-input-container><div><md-button class=\"md-raised button\" aria-label=\"Browse\">Browse</md-button></div>\n</ms-choose-file><ms-choose-file layout=\"row\" flex-gt-sm><input id=\"photo_holding_passport\" type=\"file\" \naccept=\"image/*\" ms-change=\"vm.validateFile\" class=\"ng-hide\" data-hidden-file-input=\"1\" required><md-input-container \nflex class=\"md-block\" ng-class=\"{\'md-input-invalid\': vm.fileError.photo_holding_passport}\"><label>Selfie</label><input \ntype=\"text\" name=\"photo_holding_passport_file\" ng-model=\"photo_holding_passport_fileName\" disabled=\"disabled\" required>\n<div class=\"hint\">Photo of you holding passport / id</div></md-input-container><div><md-button \nclass=\"md-raised button\" aria-label=\"Browse\">Browse</md-button></div></ms-choose-file><ms-choose-file layout=\"row\" \nflex-gt-sm><input id=\"por\" type=\"file\" accept=\"image/*\" ms-change=\"vm.validateFile\" class=\"ng-hide\" \ndata-hidden-file-input=\"1\" required><md-input-container flex class=\"md-block\" \nng-class=\"{\'md-input-invalid\': vm.fileError.por}\"><label>Proof of residency</label><input type=\"text\" name=\"por_file\" \nng-model=\"por_fileName\" disabled=\"disabled\" required><div class=\"hint\">E.g. utility bill</div></md-input-container>\n<div><md-button class=\"md-raised button\" aria-label=\"Browse\">Browse</md-button></div></ms-choose-file><span \nclass=\"hint\" \nng-class=\"{\'wrong-file\': (vm.fileError.passport || vm.fileError.por || vm.fileError.photo_holding_passport)}\">\nPlease upload files up to 15MB in JPEG or PNG format.</span></form></md-dialog-content><md-dialog-actions layout=\"row\">\n<md-button class=\"md-raised md-accent promise-button\" aria-label=\"Skip\" ng-attr-data-loading=\"{{vm.dataLoading.kyc}}\" \nng-disabled=\"vm.dataLoading.kyc\" ng-click=\"vm.kyc.isSkipped = true\"><span class=\"promise-button-label\">Skip</span>\n<md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular></md-button>\n<span flex></span><md-button type=\"submit\" class=\"md-raised md-accent promise-button\" aria-label=\"Submit to KYC\" \nng-attr-data-loading=\"{{vm.dataLoading.kyc}}\" \nng-disabled=\"\r\n                       kycForm.$invalid ||\r\n                       kycForm.$pristine ||\r\n                       vm.dataLoading.kyc ||\r\n                       vm.fileError.passport ||\r\n                       vm.fileError.por ||\r\n                       vm.fileError.photo_holding_passport\" \nng-click=\"vm.kyc($event)\"><span class=\"promise-button-label\">Submit to KYC</span><md-progress-circular \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular></md-button></md-dialog-actions>\n</div><div class=\"dialog-container\" flex ng-cloak \nng-if=\"(!$root.user.show_kyc || vm.kyc.isSkipped) && !$root.user.ether_address\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h3>Ethereum Address</h3></div></md-toolbar><md-dialog-content><form id=\"ethAddressForm\" \nname=\"ethAddressForm\"><md-input-container class=\"md-block\" flex-gt-sm><label>Your ethereum address</label><input \ntype=\"text\" required ng-model=\"vm.ether_address\" ng-pattern=\"/^(0x)?[0-9a-fA-F]{40}$/\" name=\"ether_address\"><div \nng-messages=\"ethAddressForm.ether_address.$error\"><div ng-message=\"required\">A valid ethereum address is required</div>\n<div ng-message=\"pattern\">Please enter a valid ethereum address</div></div><div class=\"hint\">\nDon\'t have an Ethereum wallet yet? Click <a href=\"https://www.myetherwallet.com/\" target=\"_blank\">here</a>\n to get started!</div></md-input-container></form></md-dialog-content><md-dialog-actions layout=\"row\"><span flex>\n</span><md-button type=\"submit\" class=\"md-raised md-accent promise-button\" aria-label=\"Finish Setup\" \nng-attr-data-loading=\"{{vm.dataLoading.saveEtherAddress}}\" \nng-disabled=\"ethAddressForm.$invalid || ethAddressForm.$pristine || vm.dataLoading.saveEtherAddress\" \nng-click=\"vm.saveEtherAddress($event)\"><span class=\"promise-button-label\">Finish Setup</span><md-progress-circular \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular></md-button></md-dialog-actions>\n</div></md-dialog>");
$templateCache.put("app/main/activate-2fa/dialogs/two-factor-auth/two-factor-auth-dialog.html","<md-dialog aria-label=\"Set Up Google Authenticator\" id=\"two-factor-auth-dialog\"><form ng-cloak><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Set Up Google Authenticator</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-window-close\" class=\"icon s24\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content><form><ol><li>Follow <a \nhref=\"https://support.google.com/accounts/answer/1066447\" target=\"_blank\">this instruction</a>\n and install the app on your <a \nhref=\"https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2\" target=\"_blank\">\nAndroid device</a> or on your <a href=\"https://appstore.com/googleauthenticator\" target=\"_blank\">iPhone or iPad</a>.\n</li><li>Open Google Authenticator</li><li>Go to \"Set up account\" section and select \"Scan a barcode\"</li><li>\nUse your phone camera to scan this barcode:</li></ol><div class=\"qr-code-container\"><img src=\"{{vm.gaData.src}}\" \nalt=\"Google Authenticator QR code\"></div><h3>Can\'t scan the barcode?</h3><ol class=\"cant-scan\"><li>\nIn Google Authenticator, touch \"Menu\" and select \"Set up account\".</li><li>Select \"Enter provided key\".</li><li>\nIn \"Enter account name\" type \"{{$root.site.name}}\".</li><li>In \"Enter your key\" type your secret key: <span \nclass=\"secret-key\">{{vm.gaData.secretKey}}</span></li><li>Key type: make sure \"Time-based\" is selected.</li><li>\nTap Add.</li></ol></form></md-dialog-content><md-dialog-actions layout=\"row\"><form name=\"twoFactorForm\" \nid=\"twoFactorForm\" class=\"md-inline-form\" flex><md-input-container md-no-float><input type=\"text\" name=\"code\" \nng-model=\"vm.gaData.code\" placeholder=\"Authenticator code\" required ng-minlength=\"6\" ng-maxlength=\"6\"><div \nng-messages=\"twoFactorForm.code.$error\" role=\"alert\"><div ng-message=\"required\"><span>Authenticator code is required\n</span></div><div ng-message=\"minlength, maxlength\"><span>Code must be 6 characters long</span></div></div>\n</md-input-container><span flex></span><md-button type=\"submit\" class=\"md-raised md-accent ga-code-verify\" \naria-label=\"Save Changes\" ng-disabled=\"twoFactorForm.$invalid || twoFactorForm.$pristine\" \nng-click=\"vm.verifyGaCode($event)\">Verify</md-button><div class=\"two-factor_helper secondary-text ng-scope\" \nlayout=\"row\" ng-hide=\"vm.errorMessages\">\nOnce you have scanned the barcode, enter the 6-digit verification code generated by Google Authenticator app.</div><div\n class=\"two-factor_errors\" layout=\"row\" ng-show=\"vm.errorMessages\"><div ng-repeat=\"message in vm.errorMessages\">\n{{message}}</div></div></form></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/vertical.html","<div class=\"ms-stepper-vertical\"><div class=\"ms-stepper-vertical-line\"></div><div class=\"ms-stepper-steps\" \nng-transclude></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\"><div class=\"ms-stepper-navigation-wrapper\"><div class=\"ms-stepper-navigation\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(step.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber)\" \nng-repeat=\"step in MsStepper.steps | filter:MsStepper.filterHiddenStep\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"step md-accent-bg\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)\">{{$index + 1}} </span>\n<span ng-if=\"MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)\"><i \nclass=\"icon icon-check s18\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\" \ntranslate=\"{{step.stepTitleTranslate}}\">{{step.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(step.stepNumber)\">Optional</div></div></md-button></div></div><div \nclass=\"ms-stepper-steps\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" \nng-click=\"MsStepper.gotoPreviousStep()\">Back</md-button><div class=\"ms-stepper-dots\"><span \nng-repeat=\"step in MsStepper.steps\" ng-hide=\"MsStepper.isStepHidden(step.stepNumber)\" \nng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\"></span></div><md-button \nclass=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}\n</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\">\n<div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div \nclass=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div \nclass=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button \nclass=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div \nclass=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">\n{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" \nlayout-align=\"space-between\" layout-fill flex><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\">\n</md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" \nclass=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">\n{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html","<md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(stepInfo.stepNumber), \'valid\': MsStepper.isStepValid(stepInfo.stepNumber), \'disabled\': MsStepper.isStepDisabled(stepInfo.stepNumber), \'optional\': MsStepper.isStepOptional(stepInfo.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(stepInfo.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(stepInfo.stepNumber)\" \nng-hide=\"MsStepper.isStepHidden(stepInfo.stepNumber)\" aria-label=\"Stepper navigation button\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"step\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(stepInfo.stepNumber) || MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-checkbox-blank-circle-outline s18 md-accent-fg\"></i> </span><span \nng-if=\"MsStepper.isStepValid(stepInfo.stepNumber) && !MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-check-circle s18 md-accent-fg\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"title\" ng-if=\"stepInfo.stepTitleTranslate\">{{stepInfo.stepTitleTranslate | translate }}</div><div class=\"title\" \nng-if=\"!stepInfo.stepTitleTranslate\">{{stepInfo.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(stepInfo.stepNumber)\">Optional</div></div></md-button><div \nclass=\"ms-stepper-step-content\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"start center\" ng-show=\"MsStepper.isStepCurrent(stepInfo.stepNumber)\"><md-button \nclass=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" ng-click=\"MsStepper.gotoPreviousStep()\">Back\n</md-button><md-button class=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div>");}]);